// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Design Tokens — single source of truth for color/shape/depth
   Scheme system: "Golden Hour" (default) + 3 alternates, each with
   a light and dark variant, selected via [data-color-scheme] on
   <html> (see ui-settings-storage.ts's get/setColorSchemePreference
   and applyStoredColorScheme, called at boot before first paint).
   Falls through to Golden Hour when no attribute is set at all, so
   any markup that predates the scheme system keeps working.
   ============================================================ */
:root,
[data-color-scheme="goldenHour"] {
  /* Accent (marigold) — interactive/brand */
  --accent: #cc6b1c;
  --accent-hover: #b25914;
  --accent-soft: #fbeee0;
  --accent-border: #e8c9a4;
  --accent-text: #8a4812;
  --bubble-sent: #fbeee0;

  /* Success (sage-forest) — matches, online, live status */
  --success: #4d7a52;
  --success-hover: #3f6543;
  --success-soft: #e9f1e7;
  --success-border: #bcd4bd;
  --success-text: #2f4c32;

  /* Danger (brick) */
  --danger: #b23a2e;
  --danger-hover: #952f25;
  --danger-soft: #f7e7e3;
  --danger-border: #e6bcb1;

  /* Warning (dusty gold — distinct hue from accent) */
  --warning: #a9791e;
  --warning-soft: #f5eedd;
  --warning-border: #e4cf9c;
  --warning-text: #6b4d10;

  /* Neutrals (warm ink, not slate) */
  --text-primary: #211f1a;
  --text-secondary: #6b6354;
  --text-tertiary: #857c6a;
  --text-muted: #9c9587;
  --border: #e6e2d7;
  --border-strong: #d8d2c2;
  --bg-subtle: #f5f4f0;
  --bg-muted: #ede9e0;
  --surface: #ffffff;

  /* Gradients */
  --gradient-accent: linear-gradient(135deg, #e08a3c 0%, #cc6b1c 100%);
  --gradient-success: linear-gradient(135deg, #6b9970 0%, #4d7a52 100%);
  --gradient-success-hover: linear-gradient(135deg, #4d7a52 0%, #3f6543 100%);
}

[data-color-scheme="tropicalForest"] {
  --accent: #2f7a4f;
  --accent-hover: #256440;
  --accent-soft: #e1f0e5;
  --accent-border: #b9d9c1;
  --accent-text: #1c4c31;
  --bubble-sent: #e1f0e5;
  --success: #6b8e3d;
  --success-hover: #587532;
  --success-soft: #eef3e0;
  --success-border: #cfdcae;
  --success-text: #445a26;
  --danger: #c1452e;
  --danger-hover: #a13a26;
  --danger-soft: #f8e6e0;
  --danger-border: #e8bfae;
  --warning: #c98a24;
  --warning-soft: #f6ecd8;
  --warning-border: #e6cd97;
  --warning-text: #7c5615;
  --text-primary: #1e2a1f;
  --text-secondary: #54604f;
  --text-tertiary: #6f7c68;
  --text-muted: #8b9484;
  --border: #dbe4d2;
  --border-strong: #c7d3ba;
  --bg-subtle: #eff3ea;
  --bg-muted: #e2ead9;
  --surface: #ffffff;
  --gradient-accent: linear-gradient(135deg, #479166 0%, #2f7a4f 100%);
  --gradient-success: linear-gradient(135deg, #85a95a 0%, #6b8e3d 100%);
  --gradient-success-hover: linear-gradient(135deg, #6b8e3d 0%, #587532 100%);
}

[data-color-scheme="snowMountain"] {
  --accent: #1f8fc4;
  --accent-hover: #1a76a3;
  --accent-soft: #e2f2fa;
  --accent-border: #b7dced;
  --accent-text: #135a7c;
  --bubble-sent: #e2f2fa;
  --success: #3e7a4f;
  --success-hover: #336440;
  --success-soft: #e6f1e8;
  --success-border: #bcd8c2;
  --success-text: #274d31;
  --danger: #c23b2e;
  --danger-hover: #a23124;
  --danger-soft: #f8e5e2;
  --danger-border: #e8bcb0;
  --warning: #d69a2a;
  --warning-soft: #f7edd9;
  --warning-border: #ecd49b;
  --warning-text: #815e13;
  --text-primary: #1b2733;
  --text-secondary: #556575;
  --text-tertiary: #6d7c8b;
  --text-muted: #8b98a5;
  --border: #dbe4ea;
  --border-strong: #c5d2db;
  --bg-subtle: #f4f7fa;
  --bg-muted: #e6edf2;
  --surface: #ffffff;
  --gradient-accent: linear-gradient(135deg, #3fabdb 0%, #1f8fc4 100%);
  --gradient-success: linear-gradient(135deg, #619871 0%, #3e7a4f 100%);
  --gradient-success-hover: linear-gradient(135deg, #3e7a4f 0%, #336440 100%);
}

[data-color-scheme="beachSunset"] {
  --accent: #e8637a;
  --accent-hover: #d14964;
  --accent-soft: #fce7ec;
  --accent-border: #f0bfca;
  --accent-text: #9c3149;
  --bubble-sent: #fce7ec;
  --success: #2e8a83;
  --success-hover: #25716b;
  --success-soft: #e2f1ef;
  --success-border: #b2d9d5;
  --success-text: #1a534e;
  --danger: #c4453f;
  --danger-hover: #a53933;
  --danger-soft: #f8e5e3;
  --danger-border: #e9bcb8;
  --warning: #e0a431;
  --warning-soft: #faeed6;
  --warning-border: #efd696;
  --warning-text: #7f5714;
  --text-primary: #2b1e22;
  --text-secondary: #6b545a;
  --text-tertiary: #856b71;
  --text-muted: #a0888d;
  --border: #eddac4;
  --border-strong: #e0c6a8;
  --bg-subtle: #fbf1e4;
  --bg-muted: #f3e2ce;
  --surface: #ffffff;
  --gradient-accent: linear-gradient(135deg, #ee839a 0%, #e8637a 100%);
  --gradient-success: linear-gradient(135deg, #4fa39c 0%, #2e8a83 100%);
  --gradient-success-hover: linear-gradient(135deg, #2e8a83 0%, #25716b 100%);
}

/* Dark variants — same 4 schemes, applied when the OS/site theme is dark. Mirrors the
   pattern the redesign preview artifact used: same token names, deeper/brighter values. */
@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]),
  [data-color-scheme="goldenHour"]:not([data-theme="light"]) {
    --accent: #f0a93e; --accent-hover: #f5bc63; --accent-soft: #3a2a14; --accent-border: #5c451f; --accent-text: #f5bc63;
    --success: #7fb386; --success-hover: #97c29c; --success-soft: #1c2b1e; --success-border: #35492f;
    --danger: #e2796a; --danger-hover: #e89686; --danger-soft: #3a211c; --danger-border: #5a352c;
    --warning: #d3a94a; --warning-soft: #362b14; --warning-border: #56461f; --warning-text: #e0bc74;
    --text-primary: #f2eee6; --text-secondary: #c4bbaa; --text-tertiary: #a89d89; --text-muted: #877d6c;
    --border: #332c22; --border-strong: #443b2c; --bg-subtle: #17140f; --bg-muted: #1e1a14; --surface: #1e1a14;
  }
}
[data-theme="dark"][data-color-scheme="goldenHour"], :root[data-theme="dark"]:not([data-color-scheme]) {
  --accent: #f0a93e; --accent-hover: #f5bc63; --accent-soft: #3a2a14; --accent-border: #5c451f; --accent-text: #f5bc63;
  --success: #7fb386; --success-hover: #97c29c; --success-soft: #1c2b1e; --success-border: #35492f;
  --danger: #e2796a; --danger-hover: #e89686; --danger-soft: #3a211c; --danger-border: #5a352c;
  --warning: #d3a94a; --warning-soft: #362b14; --warning-border: #56461f; --warning-text: #e0bc74;
  --text-primary: #f2eee6; --text-secondary: #c4bbaa; --text-tertiary: #a89d89; --text-muted: #877d6c;
  --border: #332c22; --border-strong: #443b2c; --bg-subtle: #17140f; --bg-muted: #1e1a14; --surface: #1e1a14;
}
[data-theme="dark"][data-color-scheme="tropicalForest"] {
  --accent: #4fcb82; --accent-hover: #6fd89a; --accent-soft: #173322; --accent-border: #2c5138;
  --success: #a3c46a; --success-soft: #212f16; --danger: #e37b62; --danger-soft: #37201a; --warning: #e0b45c; --warning-soft: #332711;
  --text-primary: #e7f0e4; --text-secondary: #a9bba2; --text-tertiary: #8a9c83; --text-muted: #6d8069;
  --border: #26362b; --border-strong: #334839; --bg-subtle: #0e1912; --bg-muted: #152119; --surface: #152119;
}
[data-theme="dark"][data-color-scheme="snowMountain"] {
  --accent: #4dc4ec; --accent-hover: #71d1f0; --accent-soft: #123544; --accent-border: #234f61;
  --success: #79b98c; --success-soft: #17281c; --danger: #e08072; --danger-soft: #372019; --warning: #e0b558; --warning-soft: #332811;
  --text-primary: #eaf2f7; --text-secondary: #aebfc9; --text-tertiary: #8ea0ac; --text-muted: #6f818e;
  --border: #233442; --border-strong: #2f4353; --bg-subtle: #0d1720; --bg-muted: #132029; --surface: #132029;
}
[data-theme="dark"][data-color-scheme="beachSunset"] {
  --accent: #f58aa0; --accent-hover: #f9a4b5; --accent-soft: #3a1f28; --accent-border: #573240;
  --success: #5cb3ab; --success-soft: #173330; --danger: #e37b73; --danger-soft: #3a221e; --warning: #e6bc63; --warning-soft: #332811;
  --text-primary: #f5e8e0; --text-secondary: #c9aeb5; --text-tertiary: #ab8f95; --text-muted: #8a707a;
  --border: #3a2c40; --border-strong: #4a3a50; --bg-subtle: #1c1420; --bg-muted: #241a29; --surface: #241a29;
}

:root {
  /* Typography */
  --font-display: ui-rounded, "SF Pro Rounded", "Nunito", -apple-system, "Segoe UI", Roboto, sans-serif;

  /* Shape */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 14px;
  --radius-xl: 18px;
  --radius-full: 999px;

  /* Depth (warm-tinted, not cold slate) */
  --shadow-sm: 0 1px 2px rgba(33, 26, 15, 0.06);
  --shadow-md: 0 4px 12px rgba(33, 26, 15, 0.08);
  --shadow-lg: 0 12px 32px rgba(33, 26, 15, 0.16);
}

/* Reset and Base Styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
  overflow: hidden;
  /* Chrome/WebView's mobile "font boosting" inflates text independent of layout (icons,
     badges, card widths stay fixed while text grows and wraps) — breaks fixed-width UI like
     the chatroom list under a larger-than-default OS/browser font-size setting. Opt out so
     our own font sizes always render as specified; the Android WebView also pins
     textZoom=100 for the native app (MainActivity.kt), this covers browser access. */
  text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  line-height: 1.6;
  color: var(--text-primary);
  background-color: var(--bg-muted);
  -webkit-font-smoothing: antialiased;
}

/* Visible keyboard focus everywhere, no default ring on mouse click */
:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

button:focus:not(:focus-visible) {
  outline: none;
}

/* Loading Screen */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  height: 100dvh; /* mobile: exclude browser URL bar */
  background: var(--gradient-accent);
  color: white;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-left: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Main App Layout */
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh; /* mobile: exclude browser URL bar so bottom nav stays visible */
  overflow: hidden;
  background: var(--bg-muted);
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Single AppBar (top header) — redesign §1 */
.top-header {
  background: var(--surface);
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  z-index: 10;
  gap: 8px;
  position: relative;
}

.app-bar-left {
  display: flex;
  align-items: center;
  min-width: 36px;
  flex-shrink: 0;
}

.app-bar-back-btn {
  width: 36px;
  height: 36px;
  background: none;
  border: none;
  font-size: 1.4em;
  cursor: pointer;
  color: var(--text-primary);
  border-radius: var(--radius-sm);
  align-items: center;
  justify-content: center;
}

.app-bar-back-btn:hover {
  background: var(--bg-muted);
}

.app-bar-center {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  overflow: hidden;
}

.header-title {
  font-family: var(--font-display);
  font-size: 1.1em;
  font-weight: 700;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-title:empty {
  display: none;
}

.header-actions {
  display: flex;
  gap: 2px;
  min-width: 44px;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  flex-shrink: 0;
}

.app-bar-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.app-bar-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: var(--radius-sm);
}

.app-bar-action-btn:disabled,
#dm-inbox-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

/* Icon-only inline; the label shows when the button lives in the ⋯ panel */
.app-bar-actions .app-bar-btn-label {
  display: none;
}

.app-bar-overflow-menu {
  display: none;
  align-items: center;
  position: relative;
}

.app-bar-overflow-btn {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
}

.app-bar-overflow-panel {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 999;
  background: var(--surface);
  border-radius: var(--radius-md);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);
  min-width: 190px;
  overflow: hidden;
  flex-direction: column;
}

.app-bar-overflow-panel.open {
  display: flex;
}

.app-bar-overflow-panel .app-bar-action-btn {
  width: 100%;
  justify-content: flex-start;
  padding: 10px 14px;
  font-size: 1em;
  border-radius: 0;
}

.app-bar-overflow-panel .app-bar-btn-label {
  display: inline;
  font-size: 0.9em;
}

.appbar-view-hidden {
  display: none !important;
}

/* Mobile "Filters ▾" disclosure — redesign §6 */
.filter-bar {
  padding: 8px 12px;
  border-bottom: 1px solid var(--border);
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.filter-bar-toggle {
  display: none;
  background: var(--bg-muted);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  padding: 6px 12px;
  cursor: pointer;
  font-size: 0.9em;
  align-items: center;
  gap: 4px;
}

.filter-bar-content {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
}

@media (max-width: 767px) {
  .filter-bar-toggle {
    display: inline-flex;
  }

  .filter-bar-content {
    display: none;
  }

  .filter-bar-content.open {
    display: flex;
    flex-basis: 100%;
  }
}

.header-btn {
  background: none;
  border: none;
  font-size: 1.3em;
  cursor: pointer;
  padding: 5px;
  color: var(--text-primary);
  transition: opacity 0.2s;
}

.header-btn:hover {
  opacity: 0.7;
}

.header-user-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-user-info .user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--gradient-accent);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.9em;
}

.header-status {
  flex: 1;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--text-primary);
  font-size: 0.92em;
  font-weight: 600;
  text-align: center;
}

.header-status-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-status-text[hidden] {
  display: none;
}

/* The selected folder/detail heading already names the scope; the AppBar shows changing counts. */
#status-bar-text {
  display: inline-flex;
  align-items: center;
  line-height: 1.15;
}

#status-bar-text .status-bar-meta {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#status-bar-text .status-bar-meta {
  font-weight: 500;
  color: var(--text-secondary, #4b5563);
}

/* View Container */
.view-container {
  flex: 1;
  min-height: 0; /* Prevent flex item from overflowing */
  position: relative;
  overflow: hidden;
  background: var(--bg-muted);
}

.view-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  flex-direction: column;
  background: var(--bg-muted);
  overflow: hidden;
}

.view-panel.active {
  display: flex;
}

.view-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: var(--surface);
}

/* Bottom Navigation */
.bottom-nav {
  height: calc(70px + env(safe-area-inset-bottom, 0px));
  min-height: calc(70px + env(safe-area-inset-bottom, 0px));
  max-height: calc(70px + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: var(--surface);
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 0;
  padding: 0;
  box-sizing: border-box;
}

.nav-btn {
  flex: 1;
  height: 100%;
  max-height: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  gap: 3px;
  transition: all 0.2s;
  box-sizing: border-box;
  overflow: hidden;
}

.nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  transition: color 0.2s, transform 0.2s;
}

.nav-icon svg {
  width: 24px;
  height: 24px;
}

.nav-label {
  font-family: var(--font-display);
  font-size: 0.75em;
  color: var(--text-muted);
  font-weight: 600;
  transition: all 0.2s;
}

.nav-btn.active .nav-icon {
  color: var(--accent);
  transform: translateY(-1px);
}

.nav-btn.active .nav-label {
  color: var(--accent);
  font-weight: 600;
}

.nav-btn:hover {
  background: rgba(15, 23, 42, 0.04);
}

/* Remove old sidebar styles */
.sidebar {
  display: none;
}

.sidebar-actions {
  display: none;
}

.main-content {
  display: none;
}

/* Header */
.header {
  background: var(--surface);
  padding: 15px 20px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: between;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
}

.profile-avatar-image {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: inherit;
  object-fit: cover;
}

.chatbot-overlay {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  background: var(--success);
  border-radius: 50%;
  border: 2px solid white;
}

/* Chatroom Info */
.chatroom-info {
  padding: 12px 15px;
  background: var(--bg-muted);
  border-bottom: 1px solid var(--border-strong);
  flex-shrink: 0;
}

.chatroom-title {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 0.9em;
  margin-bottom: 3px;
  color: var(--text-primary);
}

.chatroom-status {
  font-size: 0.75em;
  color: var(--text-muted);
}

/* Conversation List */
.conversation-list {
  flex: 1;
  overflow-y: auto;
  padding: 0;
  background: var(--surface);
}

.conversation-item {
  background: var(--surface);
  border-radius: var(--radius-md);
  padding: 15px;
  margin-bottom: 10px;
  border: 1px solid var(--border);
  cursor: pointer;
  transition: all 0.2s ease;
}

.conversation-item:hover {
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.conversation-item.active {
  border-color: var(--accent);
  background: var(--accent-soft);
}

.conversation-preview {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.conversation-details h4 {
  margin-bottom: 5px;
  color: var(--text-primary);
}

.conversation-details p {
  color: var(--text-tertiary);
  font-size: 0.9em;
}

.conversation-meta {
  text-align: right;
  font-size: 0.8em;
  color: var(--text-muted);
}

.unread-badge {
  background: var(--accent);
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
  margin-top: 5px;
}

/* Welcome Banner */
.location-room-suggestion {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 10px 12px;
  border: 1px solid var(--accent-border);
  border-radius: var(--radius-md);
  background: var(--accent-soft);
  color: var(--accent-text);
}

.location-room-suggestion button {
  border: 0;
  border-radius: var(--radius-sm);
  padding: 5px 9px;
  cursor: pointer;
  background: var(--accent);
  color: #fff;
}

.location-room-suggestion button[data-action="dismiss"] {
  margin-left: auto;
  background: transparent;
  color: var(--accent-text);
  font-size: 18px;
  line-height: 1;
}

.system-announcements {
  display: grid;
  gap: 8px;
  margin: 0 0 12px;
}

.system-announcement {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--warning-border);
  border-radius: var(--radius-md);
  background: var(--warning-soft);
  color: var(--warning-text);
}

.system-announcement button {
  margin-left: auto;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

/* App-download banner: shown to plain browser tabs (never inside the packaged Electron shell) */
.app-download-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  background: var(--gradient-accent);
  color: #fff;
  font-size: 0.85em;
}

.app-download-banner-text {
  font-weight: 600;
}

.app-download-banner-link {
  color: #fff;
  font-weight: 700;
  text-decoration: underline;
  white-space: nowrap;
}

.app-download-banner-see-options {
  border: 0;
  background: transparent;
  font: inherit;
  cursor: pointer;
  padding: 0;
}

.app-download-banner-dismiss {
  margin-left: auto;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.85;
}

/* Status Bar - Permanent chatroom status display */
.status-bar {
  background: var(--gradient-accent);
  color: white;
  padding: 10px 16px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
  position: sticky;
  top: 0;
  z-index: 10;
  /* Stay visible: #chatrooms-view is a flex column; without this the bar can shrink when the member list grows */
  flex-shrink: 0;
  flex-grow: 0;
}

#chatrooms-view > .status-bar {
  min-height: min-content;
}

.status-bar-content {
  font-size: 0.9em;
  font-weight: 500;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.status-bar-content::before {
  content: '👤';
  font-size: 1.1em;
}

.status-bar-actions {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Chatroom List */
#chatroom-list-container {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: var(--surface);
  display: flex;
  flex-direction: column;
  position: relative;
}

#chatroom-list {
  padding: 8px;
  min-height: 0;
  overflow-y: auto;
}

.chatroom-view-mode-btn[aria-pressed='true'] {
  background: var(--accent-soft);
  color: var(--accent-text);
  box-shadow: inset 0 0 0 1px var(--accent-border);
}

.chatroom-view-mode-btn:focus-visible {
  outline: 3px solid color-mix(in srgb, var(--accent) 35%, transparent);
  outline-offset: 1px;
}

.chatroom-map-status {
  position: absolute;
  z-index: 2;
  top: 8px;
  left: 8px;
  max-width: calc(100% - 72px);
  padding: 5px 8px;
  border-radius: var(--radius-sm);
  background: rgb(255 255 255 / 90%);
  color: var(--text-secondary);
  font-size: 0.82rem;
  line-height: 1.25;
  box-shadow: var(--shadow-sm);
  pointer-events: none;
}

.chatroom-map {
  flex: 1 1 auto;
  min-height: 320px;
  width: 100%;
  background: var(--bg-subtle);
  color: var(--text-muted);
}

.chatroom-map.loading,
.chatroom-map.load-failed {
  display: grid;
  place-items: center;
  padding: 24px;
  text-align: center;
}

.chatroom-map-marker {
  display: grid;
  place-items: center;
  position: relative;
  width: 34px !important;
  height: 34px !important;
  margin: 0 !important;
  border: 3px solid #fff;
  border-radius: 50%;
  /* Fixed (not theme-token) colors: --accent and --success can both land on
     similar greens in some color schemes (e.g. tropicalForest), which made
     "your room" vs "other rooms" unreadable on the map. Matches the
     underlying MapLibre circle layer's hardcoded #2563eb/#16803c pair
     (chatroom-map-view.ts) so both rendering layers agree. */
  background: #2563eb;
  color: #fff;
  box-shadow: 0 2px 8px rgb(0 0 0 / 35%);
  font-size: 0.75rem;
  font-weight: 800;
  cursor: pointer;
  appearance: none;
}

.chatroom-map-marker.empty-place {
  opacity: 0.55;
}

.chatroom-map-marker.current-room {
  background: #16803c;
  box-shadow: 0 0 0 4px rgb(22 128 60 / 30%), 0 2px 8px rgb(0 0 0 / 35%);
}

.chatroom-map-tooltip {
  display: none;
  position: absolute;
  z-index: 2;
  bottom: calc(100% + 9px);
  left: 50%;
  min-width: max-content;
  max-width: 220px;
  padding: 7px 9px;
  border: 1px solid rgb(0 0 0 / 12%);
  border-radius: 6px;
  background: #fff;
  color: #111827;
  box-shadow: 0 3px 12px rgb(0 0 0 / 22%);
  transform: translateX(-50%);
  text-align: left;
  gap: 2px;
  pointer-events: none;
}

/* Room list header: Nearby headcount and the custom-room sort choice. */
.room-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 4px 2px;
  font-size: 0.92em;
}

.room-list-header-sort-only {
  justify-content: flex-end;
}

.room-list-total {
  font-weight: 700;
}

.room-list-sort {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-secondary, #4b5563);
}

.room-list-sort select {
  padding: 4px 8px;
  border: 1px solid var(--border-strong, #d1d5db);
  border-radius: 8px;
  background: var(--surface, #fff);
  color: inherit;
}

/* People on the map: ★ me (larger), green = my room (can exchange Talks), yellow = others. */
.chatroom-map-user-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgb(0 0 0 / 35%);
  color: #111827;
  font: 700 9px/1 system-ui, sans-serif;
}

.chatroom-map-user-dot[data-count]:not([data-count="1"]) {
  min-width: 32px;
  width: auto;
  height: 24px;
  padding: 0 5px;
  border-radius: 12px;
  font-size: 11px;
}

/* Broadcast waves sit under markers and never intercept taps or map gestures. */
.chatroom-map-broadcast-effects {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.chatroom-map-broadcast-label {
  font: 600 12px/1.4 system-ui, sans-serif;
  paint-order: stroke;
  stroke: #fff;
  stroke-width: 4px;
  stroke-linejoin: round;
}

.chatroom-map-user-dot-matched {
  width: auto;
  min-width: 36px;
  height: 26px;
  padding: 0 5px;
  border-radius: 13px;
  font-size: 11px;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #16a34a;
}

.chatroom-map-member-contact {
  border: 0;
  padding: 0;
  background: none;
  color: inherit;
  font: inherit;
  font-weight: 700;
  text-align: start;
  text-decoration: underline;
  cursor: pointer;
}

.chatroom-map-user-dot-room {
  background: #16a34a;
  color: #fff;
}

.chatroom-map-user-dot-other {
  background: #facc15;
}

.chatroom-map-user-dot-self {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 0;
  background: none;
  box-shadow: none;
  color: #f59e0b;
  font-size: 28px;
  text-shadow: 0 0 2px #fff, 0 0 2px #fff, 0 1px 3px rgb(0 0 0 / 55%);
}

.chatroom-map-user-dot {
  position: relative;
}

/* Keep marker positioning independent of the lazy-loaded MapLibre stylesheet's order. */
.chatroom-map-user-dot.maplibregl-marker,
.chatroom-map-marker.maplibregl-marker {
  position: absolute;
}

.chatroom-map-user-dot-traveler {
  position: absolute;
  top: -9px;
  right: -10px;
  color: #1e293b;
  font: 700 11px/1 system-ui, sans-serif;
  text-shadow: 0 0 2px #fff, 0 0 2px #fff;
}

.chatroom-map-user-legend {
  position: absolute;
  left: 8px;
  bottom: 30px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 8px;
  border-radius: 8px;
  background: var(--surface, #fff);
  color: var(--text-primary, #111827);
  box-shadow: 0 2px 8px rgb(0 0 0 / 20%);
  font-size: 0.8em;
  pointer-events: none;
}

.chatroom-map-user-legend[hidden] {
  display: none;
}

.chatroom-map-user-legend > span {
  display: flex;
  align-items: center;
  gap: 6px;
}

.chatroom-map-user-legend-swatch.chatroom-map-user-dot-self {
  width: 14px;
  height: 14px;
  font-size: 15px;
}

/* Tapped tile on the room map: its name and an Enter button, pinned at the tap point. */
.chatroom-map-tile-card {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 240px;
  margin-bottom: 6px;
  padding: 6px 6px 6px 10px;
  border: 1px solid rgb(0 0 0 / 12%);
  border-radius: 8px;
  background: var(--surface, #fff);
  color: var(--text-primary, #111827);
  box-shadow: 0 3px 12px rgb(0 0 0 / 22%);
  font-size: 0.9em;
}

.chatroom-map-tile-card > strong {
  overflow: hidden;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chatroom-map-member-card {
  flex-direction: column;
  align-items: stretch;
  width: min(280px, 80vw);
  max-width: none;
  max-height: 50vh;
  overflow-y: auto;
  padding: 8px;
  cursor: default;
}

.chatroom-map-member {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 4px 10px;
  align-items: start;
}

.chatroom-map-member + .chatroom-map-member {
  padding-top: 8px;
  border-top: 1px solid var(--border, rgb(0 0 0 / 10%));
}

.chatroom-map-member-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  background: #16803c;
  color: #fff;
  font-weight: 600;
}

.chatroom-map-member-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.chatroom-map-member-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.chatroom-map-member-info strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chatroom-map-member-status,
.chatroom-map-member-details span {
  color: var(--text-secondary, #4b5563);
  font-size: 0.85em;
  overflow-wrap: anywhere;
}

.chatroom-map-member-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 2px;
}

.chatroom-map-member-actions {
  display: flex;
  grid-column: 1 / -1;
  gap: 6px;
}

.chatroom-map-member-actions button {
  flex: 1;
}

.chatroom-map-member-profile {
  min-height: 32px;
  padding: 4px 10px;
  border: 1px solid var(--border, rgb(0 0 0 / 15%));
  border-radius: 6px;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.chatroom-map-user-dot[role="button"] {
  cursor: pointer;
}

/* Older/static map sources have no self action; interactive stars open Me. */
.chatroom-map-user-dot-self {
  pointer-events: none;
}
.chatroom-map-user-dot-self[role="button"] { pointer-events: auto; }

/* A 14 px dot is a hard tap target on a phone: widen the hit area without changing the dot. */
.chatroom-map-user-dot[role="button"]::after {
  content: '';
  position: absolute;
  inset: -12px;
}

.chatroom-map-tile-enter {
  flex: none;
  min-height: 32px;
  padding: 4px 10px;
  border: 0;
  border-radius: 6px;
  background: var(--accent, #2563eb);
  color: #fff;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.chatroom-map-marker:hover .chatroom-map-tooltip,
.chatroom-map-marker:focus-visible .chatroom-map-tooltip {
  display: grid;
}

.chatroom-map-tooltip > span {
  color: #4b5563;
  font-size: 0.78rem;
}

.chatroom-map-cluster {
  display: grid;
  place-items: center;
  min-width: 42px;
  height: 42px;
  padding: 0 8px;
  border: 3px solid #fff;
  border-radius: 999px;
  background: #0f766e;
  color: #fff;
  box-shadow: 0 2px 10px rgb(0 0 0 / 35%);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 800;
  cursor: zoom-in;
}

.chatroom-map-cluster:focus-visible,
.chatroom-map-marker:focus-visible {
  outline: 3px solid color-mix(in srgb, var(--accent) 45%, white);
  outline-offset: 2px;
}

@media (max-width: 480px) {
  .chatroom-map-status {
    max-width: calc(100% - 64px);
  }

  .chatroom-map {
    min-height: 260px;
  }
}

.chatroom-item {
  display: flex;
  align-items: center;
  padding: 16px;
  margin-bottom: 8px;
  background: var(--surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.chatroom-flat-section + .chatroom-flat-section {
  margin-top: 22px;
}

/* Nearby v3 list: custom rooms and nearby people share one compact browser surface. */
.nearby-browser-list {
  margin-top: 10px;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
}

.nearby-browser-people,
#chatroom-members-list {
  position: relative;
}

.nearby-self-row {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 78px;
  padding: 10px 14px;
  border: 0;
  border-radius: 0;
  background: var(--bg-subtle);
  color: var(--text-primary);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.nearby-self-row .chatroom-member-avatar {
  margin-right: 12px;
  flex-shrink: 0;
  color: #b45309;
  background: #fef3c7;
}

.nearby-self-row .chatroom-member-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nearby-self-effect-space {
  display: block;
  height: 20px;
}

.nearby-self-row:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: -3px;
}

.nearby-browser-list .chatroom-flat-section + .chatroom-flat-section {
  margin-top: 0;
  border-top: 1px solid var(--border);
}

.nearby-browser-list .chatroom-flat-heading {
  margin: 0;
  padding: 10px 14px 7px;
  background: var(--bg-subtle);
}

.nearby-browser-list .chatroom-item,
.nearby-browser-list .nearby-person-item {
  display: flex;
  align-items: center;
  min-height: 58px;
  margin: 0;
  padding: 10px 14px;
  border: 0;
  border-top: 1px solid var(--border);
  border-radius: 0;
  background: var(--surface);
  cursor: pointer;
  transition: background 0.2s ease;
}

.nearby-browser-list .chatroom-item:hover,
.nearby-browser-list .nearby-person-item:hover {
  transform: none;
  background: var(--bg-subtle);
}

.nearby-browser-list .chatroom-item:active {
  transform: none;
}

.nearby-browser-list .chatroom-icon {
  width: 40px;
  margin-right: 12px;
  text-align: center;
  font-size: 1.55rem;
}

.nearby-browser-list .chatroom-flat-metrics {
  margin-top: 4px;
}

.nearby-browser-list .chatroom-headcount {
  padding: 0;
  background: transparent;
  color: var(--text-tertiary);
}

.nearby-browser-list .chatroom-flat-empty {
  margin: 0;
  padding: 14px;
  border: 0;
  border-top: 1px solid var(--border);
  border-radius: 0;
}

.chatroom-flat-heading {
  margin: 4px 8px 10px;
  color: var(--text-secondary);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

/* Nearby (§3.7): "Sent to N of M" under my Nearby row; "Show more people here" under my list. */
.chatroom-flat-progress {
  margin: 4px 12px 0;
  color: var(--text-secondary);
  font-size: 0.85rem;
}

/* §3.7 "Meeting new people in groups": the group bar above the people, Nearby and Places alike. */
.nearby-group-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  margin: 8px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
}

.nearby-group-title {
  font-weight: 600;
}

.nearby-group-note {
  margin-top: 2px;
  color: var(--text-tertiary);
  font-size: 0.88rem;
}

.nearby-group-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.nearby-meet-confirm {
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.48);
}

.nearby-meet-confirm-card {
  width: min(440px, 96vw);
  padding: 18px;
  border-radius: 16px;
  background: var(--surface);
  box-shadow: 0 18px 55px rgba(15, 23, 42, 0.2);
}

.nearby-meet-confirm-title {
  font-size: 1.05em;
  font-weight: 700;
}

.nearby-meet-confirm-body {
  margin: 8px 0 16px;
  color: var(--text-secondary);
  line-height: 1.45;
}

.nearby-meet-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.chatroom-flat-empty {
  margin: 0 8px;
  padding: 16px;
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-lg);
  color: var(--text-tertiary);
  font-size: 0.9rem;
}

.chatroom-flat-metrics {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  margin-top: 8px;
  color: var(--text-tertiary);
  font-size: 0.82rem;
}

.chatroom-item:hover {
  background: var(--bg-subtle);
  border-color: var(--success);
  transform: translateX(4px);
}

.chatroom-item:active {
  transform: translateX(4px) scale(0.98);
}

/* Expand/Collapse icon */
.chatroom-expand-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  font-size: 0.8em;
  color: var(--text-tertiary);
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.chatroom-expand-icon:hover {
  color: var(--success);
  transform: scale(1.2);
}

.chatroom-expand-icon-placeholder {
  width: 20px;
  margin-right: 8px;
  flex-shrink: 0;
}

/* Remove old margin-based indentation (now using inline style padding-left) */

.chatroom-icon {
  font-size: 2em;
  margin-right: 16px;
  flex-shrink: 0;
}

.chatroom-info {
  flex: 1;
  min-width: 0;
}

.chatroom-name {
  font-size: 1.05em;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 8px;
  overflow-wrap: break-word;
}

.chatroom-description {
  font-size: 0.85em;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chatroom-arrow {
  font-size: 1.5em;
  color: var(--border-strong);
  margin-left: 8px;
  flex-shrink: 0;
}

.chatroom-headcount {
  margin-left: 0;
  padding: 2px 8px;
  background: var(--success-soft);
  color: var(--success-text);
  border-radius: var(--radius-lg);
  font-size: 0.9em;
  font-weight: 500;
  display: inline-block;
}

.current-room-badge {
  margin-left: 8px;
  padding: 2px 8px;
  background: var(--success);
  color: white;
  border-radius: var(--radius-lg);
  font-size: 0.75em;
  font-weight: 600;
  display: inline-block;
}

.chatroom-item.current-room {
  border-color: var(--success);
  border-width: 2px;
  background: var(--success-soft);
}

/* Chatroom Detail View */
#chatroom-detail-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--surface);
  overflow: hidden;
}

.chatroom-detail-header {
  padding: 16px;
  background: var(--bg-subtle);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 12px;
}

#back-to-chatrooms {
  background: none;
  border: none;
  font-size: 1.5em;
  color: var(--success);
  cursor: pointer;
  padding: 4px 8px;
  transition: transform 0.2s ease;
}

#back-to-chatrooms:hover {
  transform: translateX(-4px);
}

#chatroom-detail-info {
  flex: 1;
}

#current-chatroom-title {
  font-size: 1.1em;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
}

#current-chatroom-status {
  font-size: 0.85em;
  color: var(--text-muted);
}

#chatroom-metadata {
  margin: 8px 16px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-subtle);
}

.chatroom-metadata-title {
  margin-bottom: 8px;
  font-weight: 600;
  color: var(--text-primary);
}

.chatroom-metadata-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 3px 0;
  font-size: 0.85em;
  color: var(--text-tertiary);
}

.chatroom-metadata-row strong {
  text-align: right;
  color: var(--text-primary);
  font-weight: 500;
}

/* Contacts View */
#contacts-list-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 8px;
}

.contact-item:hover {
  background: var(--bg-subtle) !important;
  border-color: var(--success) !important;
}

.contact-detail-header {
  padding: 16px;
  background: var(--bg-subtle);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 12px;
}

#contact-detail-container .contact-talks-list {
  padding: 8px;
  overflow-y: auto;
}

.contact-talk-item:hover {
  background: var(--bg-muted) !important;
}

#chatroom-members-list {
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 8px;
}

.chatroom-member-item {
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
  background: var(--surface);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  cursor: pointer;
  transition: all 0.2s ease;
}

.chatroom-member-item:hover {
  background: var(--bg-subtle);
  border-color: var(--success);
}

.chatroom-member-avatar {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  background: var(--gradient-accent);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1.1em;
  flex-shrink: 0;
}

/* Holds the avatar and, for a Traveler, the ✈ badge on its top-right corner. */
.chatroom-member-avatar-wrap {
  position: relative;
  margin-right: 12px;
  flex-shrink: 0;
}

.chatroom-member-info {
  flex: 1;
  min-width: 0;
}

.chatroom-member-name {
  font-size: 1em;
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.chatroom-member-status {
  font-size: 0.8em;
  color: var(--success);
}

/* Broadcast sent: highlight members who received the broadcast */
.chatroom-member-item.broadcast-sent-to {
  background: var(--success-soft) !important;
  border-radius: var(--radius-md);
  transition: background 0.3s ease;
}

/* Match indicator on member name (Tom sees green when Jerry/Bob match) */
.chatroom-member-item.member-matched .chatroom-member-name,
.nearby-person-item.member-matched .chatroom-member-name {
  color: var(--success);
  font-weight: 700;
}

.chatroom-member-item.member-matched .chatroom-member-status,
.nearby-person-item.member-matched .chatroom-member-status {
  content: 'Matched';
}

/* Flash when new talk received from this user */
.chatroom-member-item.flash-new-talk {
  animation: flashMember 1s ease-out;
}

/* TechSupport's fixed, compact pinned row above the sorted roster — a single line, not the
   two-line avatar+status block ordinary members get (same reasoning as the Contacts tab's
   own pinned support row, contacts-view.ts). */
.chatroom-member-support-pinned {
  padding: 8px 12px;
  background: var(--accent-soft);
  border-color: var(--accent-border);
}

.chatroom-member-support-pinned .chatroom-member-name {
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
}

.chatroom-member-support-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent-hover);
  font-size: 0.72em;
  font-weight: 700;
  margin-left: 8px;
}

.chatroom-member-traveler-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--surface);
  color: var(--accent-hover);
  border: 1px solid var(--border-strong);
  font-size: 11px;
  line-height: 1;
  pointer-events: none;
}

@keyframes flashMember {
  0%, 100% { background: transparent; }
  25% { background: rgba(5, 150, 105, 0.4); }
  50% { background: transparent; }
  75% { background: rgba(5, 150, 105, 0.25); }
}

/* TODO §Q: Talk -> Me-tab Q&A reverse edge — briefly highlights the answer row(s) scrolled to. */
.answer-item-highlighted {
  animation: flashMember 2s ease-out;
}

/* Settings tab — drill-down menu */
.settings-jump-menu {
  display: grid;
  gap: 14px;
}

.settings-jump-menu-group {
  display: grid;
  gap: 6px;
}

.settings-jump-menu-group-label {
  margin: 0;
  padding: 0 4px;
  color: var(--text-tertiary);
  font-size: 0.76em;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.settings-jump-menu-group-items {
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
}

.settings-jump-menu-item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border: none;
  background: none;
  color: var(--text-primary);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.settings-jump-menu-item:hover {
  background: var(--bg-subtle);
}

.settings-jump-menu-icon {
  flex-shrink: 0;
  font-size: 1.05em;
}

.settings-jump-menu-label {
  flex: 1 1 auto;
}

.settings-jump-menu-chevron {
  color: var(--text-tertiary);
}

.status-bar-actions #broadcast-talk-btn {
  margin: 0;
  padding: 12px 14px;
  background: var(--gradient-success);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 0.98em;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.status-bar-actions #broadcast-talk-btn:hover {
  background: var(--gradient-success-hover);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(5, 150, 105, 0.4);
}

.status-bar-actions #broadcast-talk-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);
}

/* Talks View */
.talks-nav-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--bg-subtle);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.talks-nav-tabs {
  display: flex;
  gap: 8px;
  flex: 1;
}

.talks-nav-btn,
.talks-nav-back {
  border: 1px solid var(--border-strong);
  background: var(--surface);
  color: var(--text-secondary);
  border-radius: var(--radius-full);
  padding: 8px 14px;
  font-size: 0.92em;
  font-weight: 600;
}

.talks-nav-btn.active {
  background: var(--accent);
  border-color: var(--accent);
  color: white;
}

.talks-nav-back {
  flex-shrink: 0;
}

.talks-header {
  padding: 16px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.create-talk-btn {
  width: 100%;
  padding: 14px 20px;
  background: var(--gradient-success);
  color: white;
  border: none;
  border-radius: var(--radius-lg);
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.create-talk-btn:hover {
  background: var(--gradient-success-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
}

.create-talk-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(5, 150, 105, 0.2);
}

.talks-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: var(--bg-subtle);
  padding: 8px;
}

/* Shared manual pin control for Contacts, Talks, and Me answer rows. */
.list-pin-button {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted);
  opacity: 0.5;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}

.list-pin-button:hover,
.list-pin-button:focus-visible {
  background: var(--accent-soft);
  border-color: var(--accent-border);
  color: var(--accent-text);
  opacity: 1;
  outline: none;
}

.list-pin-button.is-pinned {
  color: var(--accent-text);
  background: var(--accent-soft);
  opacity: 1;
}

.list-pin-button.talk-copy-button.is-copied {
  position: relative;
  color: var(--accent-text);
  background: var(--accent-soft);
  opacity: 1;
}

.list-pin-button.talk-copy-button.is-copied::after {
  content: '✓';
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--success);
  color: #fff;
  font-size: 10px;
  line-height: 14px;
  text-align: center;
}

.answer-question-item {
  position: relative;
}

.answer-question-item > .list-pin-badge {
  position: absolute;
  top: 8px;
  right: 10px;
}

.talk-list-item {
  background: var(--surface);
  border-radius: var(--radius-lg);
  padding: 16px;
  margin-bottom: 8px;
  border: 1px solid var(--border);
  cursor: pointer;
  transition: all 0.2s ease;
}

.talk-list-item:hover {
  background: var(--bg-subtle);
  border-color: var(--success);
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.talk-list-item:active {
  transform: translateX(4px) scale(0.98);
}

/* Row gestures (incoming: down = retain, left = Ignore/Pass, right = Like for tags;
 * outgoing: left = delete):
 * \`.talk-gesture-live\` suspends the row's own hover/active transition while a drag is in
 * progress so the row tracks the pointer 1:1, then removing it lets the base transition
 * animate the snap-back on release. The hint classes preview the color of the
 * retain/Ignore/delete outcome before the commit threshold is reached. */
.talk-list-item.talk-gesture-live {
  transition: none;
}

.talk-list-item.talk-gesture-hint-copy {
  background: #dcfce7 !important;
}

.talk-list-item.talk-gesture-hint-delete {
  background: #fee2e2 !important;
}

.talk-list-item.talk-gesture-hint-ignore {
  background: var(--bg-muted) !important;
}

.talk-list-item.talk-gesture-hint-like {
  background: #dcfce7 !important;
}

.talk-list-item[data-role="incoming"].talk-gesture-hint-ignore::after,
.talk-list-item[data-role="incoming"].talk-gesture-hint-like::after {
  content: attr(data-gesture-label);
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
}

.talk-item-chevron {
  color: var(--text-muted);
  font-size: 1.1em;
  line-height: 1;
}

.talk-icon-badge {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 2px 6px;
  font-size: 0.95em;
  cursor: pointer;
}

.talk-icon-badge input[type="checkbox"] {
  accent-color: var(--accent);
  width: 14px;
  height: 14px;
  margin: 0;
}

/* Me tab — merged-by-question answer rows */
.answer-tag-item {
  transition: background 0.15s ease;
}

.answer-tag-item .answer-tag-checkbox {
  width: 18px;
  height: 18px;
  accent-color: var(--accent);
  flex-shrink: 0;
}

.settings-scheme-radio {
  accent-color: var(--accent);
}

.answer-qa-item {
  display: flex;
  flex-direction: column;
  border-radius: var(--radius-lg);
  padding: 10px 12px;
  background: var(--surface);
  border: 1px solid var(--border);
  cursor: pointer;
  transition: background 0.15s ease;
}

.qa-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
}

.qa-question {
  font-weight: 600;
  color: var(--text-primary);
}

.qa-arrow {
  color: var(--text-tertiary);
}

.qa-answer {
  font-weight: 600;
  color: var(--accent-text);
}

.qa-chevron {
  color: var(--text-tertiary);
  font-size: 1.05em;
  line-height: 1;
  margin-left: auto;
  flex-shrink: 0;
}

.qa-stats {
  margin-top: 6px;
  font-size: 0.76em;
  color: var(--text-tertiary);
}

.context-indicator {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: var(--warning-soft);
  border: 1px solid var(--warning-border);
  color: var(--warning-text);
  border-radius: var(--radius-full);
  padding: 2px 7px;
  font-size: 0.78em;
  flex-shrink: 0;
}

.context-indicator .count {
  font-weight: 700;
}

/* Contacts tab — icon-only broadcast-to-group button (was an oversized text button) */
button.contacts-broadcast-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: var(--radius-sm);
  background: var(--accent);
  color: #fff;
  border: none;
  font-size: 1em;
  flex-shrink: 0;
}

.talk-list-item.talk-incoming-new {
  background: var(--accent-soft);
  border-color: var(--accent-border);
  box-shadow: inset 0 0 0 1px var(--accent-border);
}

.talk-list-item.talk-incoming-answered,
.talk-list-item.talk-broadcast-disabled {
  background: var(--bg-muted);
  border-color: var(--border-strong);
  color: var(--text-tertiary);
}

.talk-list-item.talk-broadcast-enabled {
  background: var(--success-soft);
  border-color: var(--success-border);
}

.talk-incoming-sender {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 6px;
  min-width: 0;
}

.talk-incoming-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--accent-soft);
  color: var(--accent-text);
  border: 1px solid var(--accent-border);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 26px;
  font-size: 0.78em;
  font-weight: 800;
  overflow: hidden;
}

.talk-incoming-avatar .profile-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.talk-incoming-sender-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.9em;
  font-weight: 700;
  color: var(--text-primary);
}

.talk-info-chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 6px 0 8px;
}

.talk-info-chip {
  min-height: 22px;
  border-radius: var(--radius-full);
  border: 1px solid var(--border-strong);
  background: var(--bg-subtle);
  color: var(--text-primary);
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  font-size: 0.78em;
  font-weight: 700;
  line-height: 1.2;
}

.talk-language-alert {
  background: var(--warning-soft);
  border-color: var(--warning-border);
  color: var(--warning-text);
}

.talk-expiry-green {
  background: var(--success-soft);
  border-color: var(--success-border);
  color: var(--success-hover);
}

.talk-expiry-amber {
  background: var(--warning-soft);
  border-color: var(--warning-border);
  color: var(--warning-text);
}

.talk-expiry-red {
  background: var(--danger-soft);
  border-color: var(--danger-border);
  color: var(--danger-hover);
}

.talk-progress-ring {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: conic-gradient(var(--accent) var(--progress, 0%), var(--accent-soft) 0);
  box-shadow: inset 0 0 0 3px #fff;
  flex: 0 0 14px;
}

.talk-list-item.talk-type-tag,
.talk-list-item.talk-tag-chip {
  min-height: 34px;
  padding: 6px 10px;
  border-radius: var(--radius-full);
  border: 1px solid var(--accent-border);
  background: var(--accent-soft);
  color: var(--accent-text);
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  max-width: 100%;
}

/* Filled pill = incoming, outlined pill = outgoing — the same filled-vs-outline
 * shape language as the card rows' tinted-vs-white background below. */
.talk-list-item.talk-tag-in {
  border-color: var(--accent-border);
  background: var(--accent-soft);
  color: var(--accent-hover);
}

.talk-list-item.talk-tag-out {
  border-color: var(--accent);
  background: var(--surface);
  color: var(--accent-text);
}

/* Starter tags (OPEN-87): an icon heading per group, its tags indented below it. */
.starter-tag-group-heading {
  margin: 14px 0 4px;
  font-size: 0.85em;
  font-weight: 700;
  color: var(--text-secondary);
}

.starter-tag-create-prompt {
  margin: 14px 0 6px 18px;
  padding: 12px 14px;
  border: 1px dashed var(--accent);
  border-radius: 12px;
  background: var(--accent-soft);
}
.starter-tag-create-title { font-weight: 700; margin-bottom: 4px; }
.starter-tag-create-body { font-size: 0.88em; color: var(--text-secondary); margin-bottom: 10px; }

/* One-tap tag answering (OPEN-87): Like moves right, then down; Pass flies left, then up. */
.talk-list-item.talk-tag-chip.talk-tag-fly-like {
  animation: talk-tag-fly-like 520ms ease-in forwards;
  pointer-events: none;
}
.talk-list-item.talk-tag-chip.talk-tag-fly-pass {
  animation: talk-tag-fly-pass 520ms ease-in forwards;
  pointer-events: none;
}
@keyframes talk-tag-fly-like {
  0% { transform: none; opacity: 1; }
  45% { transform: translateX(45vw); opacity: 1; }
  100% { transform: translate(45vw, 60vh); opacity: 0; }
}
@keyframes talk-tag-fly-pass {
  0% { transform: none; opacity: 1; }
  45% { transform: translateX(-45vw); opacity: 1; }
  100% { transform: translate(-45vw, -60vh); opacity: 0; }
}
@keyframes talk-tag-fade {
  to { opacity: 0; }
}
@media (prefers-reduced-motion: reduce) {
  .talk-list-item.talk-tag-chip.talk-tag-fly-like,
  .talk-list-item.talk-tag-chip.talk-tag-fly-pass {
    animation: talk-tag-fade 200ms linear forwards;
  }
}

.talk-list-item.talk-tag-chip:hover {
  transform: translateX(2px);
  border-color: var(--accent);
  background: var(--accent-soft);
}

.talk-tag-decision-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  flex: 0 0 auto;
}

.talk-tag-decision-button {
  width: 30px;
  height: 30px;
  margin: 0;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 50%;
  background: var(--surface);
  color: var(--text-muted);
  font: inherit;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
}

.talk-tag-decision-button:hover,
.talk-tag-decision-button:focus-visible {
  border-color: currentColor;
}

.talk-tag-pass-button:hover,
.talk-tag-pass-button:focus-visible,
.talk-tag-pass-button.is-selected {
  background: var(--bg-muted);
  color: var(--text-tertiary);
}

.talk-tag-like-button:hover,
.talk-tag-like-button:focus-visible,
.talk-tag-like-button.is-selected {
  border-color: var(--success);
  background: #dcfce7;
  color: var(--success);
}

.talk-tag-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.94em;
  font-weight: 700;
}

.talk-tag-text-button {
  border: 0;
  background: transparent;
  color: inherit;
  padding: 0;
  cursor: pointer;
  text-align: left;
  font: inherit;
}

.talk-tag-text-button:hover {
  text-decoration: underline;
}

.talk-list-item.talk-type-flow {
  border-radius: var(--radius-md);
  border-color: var(--accent-border);
  background: var(--accent-soft);
}

.talk-list-item.talk-type-survey {
  border-radius: 8px 18px 8px 18px;
  border-color: var(--success-border);
  background: var(--success-soft);
}

.talk-list-item.talk-type-route {
  border-radius: var(--radius-md);
  border-color: var(--warning);
  background: var(--warning-soft);
  padding: 18px;
  box-shadow: inset 0 0 0 1px var(--warning-border);
}

.talk-list-item.talk-type-route .talk-item-title {
  font-size: 1.18em;
}

.talk-list-item.talk-type-flow .talk-badge-type {
  background: var(--accent-soft);
  color: var(--accent-text);
}

.talk-list-item.talk-type-survey .talk-badge-type {
  background: var(--success-soft);
  color: var(--success-hover);
}

.talk-list-item.talk-type-route .talk-badge-type {
  background: var(--warning-soft);
  color: var(--warning-text);
}

.talk-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.talk-item-title {
  flex: 1 1 auto;
  font-size: 1.1em;
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


.talk-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: var(--radius-lg);
  font-size: 0.75em;
  font-weight: 600;
  margin-bottom: 6px;
}

/* Consecutive badges (role/status + type + language, at the top of a talk's details
   popup — ui-manager.ts) render with no gap between them otherwise, since .talk-badge
   itself carries no margin — they end up touching, looking like one run-on block. */
.talk-badge + .talk-badge {
  margin-left: 6px;
}

.talk-badge-created {
  background: var(--accent-soft);
  color: var(--accent-text);
}

.talk-badge-answered {
  background: var(--success-soft);
  color: var(--success-text);
}

.talk-badge-type {
  background: var(--bg-muted);
  color: var(--text-tertiary);
}

.talk-badge-broadcast-enabled {
  background: var(--success-soft);
  color: var(--success-text);
}

.talk-badge-broadcast-disabled {
  background: var(--bg-muted);
  color: var(--text-tertiary);
}

/* Icon-only row actions (view/details/broadcast-toggle/remove/survey-stats) — one
 * compact, ghost-style control instead of a full-size solid-colored \`.btn\` each.
 * State (on/off, destructive) is carried by the icon glyph itself, not a filled
 * background, so it doesn't add its own redundant color on top of the icon. */
button.talk-icon-btn {
  background: transparent;
  color: var(--text-secondary);
  border: none;
  padding: 4px 6px;
  font-size: 0.95em;
  min-width: 0;
  line-height: 1;
  border-radius: var(--radius-sm);
  box-shadow: none;
}

button.talk-icon-btn:hover {
  background: var(--bg-subtle);
  color: var(--text-primary);
  transform: none;
  box-shadow: none;
}

.talk-broadcast-toggle-btn.talk-broadcast-toggle-off {
  opacity: 0.6;
}

.talk-item-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.talk-item-time {
  font-size: 0.85em;
  color: var(--text-muted);
}

/* Chat Area */
.chat-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: var(--bg-muted);
}

.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 15px;
  background: var(--bg-muted);
}

.message {
  max-width: 70%;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.message.sent {
  margin-left: auto;
  flex-direction: row-reverse;
}

.message-bubble {
  background: var(--surface);
  padding: 10px 14px;
  border-radius: var(--radius-md);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  position: relative;
  word-wrap: break-word;
}

.message.sent .message-bubble {
  background: var(--bubble-sent);
  color: var(--text-primary);
}

.message-time {
  font-size: 0.7em;
  color: var(--text-muted);
  margin-top: 5px;
}

/* Talk Interface */
.talk-question {
  background: var(--surface);
  border-radius: var(--radius-lg);
  padding: 20px;
  margin-bottom: 20px;
  border: 2px solid var(--border);
}

.question-text {
  font-size: 1.1em;
  margin-bottom: 15px;
  color: var(--text-primary);
}

.answer-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.answer-chip {
  background: var(--bg-muted);
  border: 2px solid transparent;
  border-radius: var(--radius-xl);
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.answer-chip:hover {
  background: var(--accent-soft);
  border-color: var(--accent);
}

.answer-chip.selected {
  background: var(--accent);
  color: white;
  border-color: var(--accent-hover);
}

.answer-chip.ignore {
  background: var(--danger);
  color: white;
}

.answer-chip.match {
  background: var(--success);
  color: white;
}

/* Message Input */
.message-input-area {
  background: var(--surface);
  border-top: 1px solid var(--border);
  padding: 15px 20px;
}

.message-input-container {
  display: flex;
  gap: 10px;
  align-items: flex-end;
}

.message-input {
  flex: 1;
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  padding: 10px 15px;
  outline: none;
  resize: none;
  min-height: 40px;
  max-height: 120px;
}

.message-input:focus {
  border-color: var(--accent);
}

.send-button {
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
}

.send-button:hover {
  background: var(--accent-hover);
}

.send-button:disabled {
  background: var(--border-strong);
  cursor: not-allowed;
}

/* Tabs */
.tabs {
  display: flex;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
}

.tab {
  flex: 1;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.2s ease;
}

.tab:hover {
  background: var(--bg-subtle);
}

.tab.active {
  border-bottom-color: var(--accent);
  color: var(--accent);
  font-weight: bold;
}

/* Buttons */
.btn {
  background: var(--accent);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1em;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

.btn:disabled {
  background: var(--border-strong);
  cursor: not-allowed;
  transform: none;
}

.btn-secondary {
  background: var(--surface);
  color: var(--text-secondary);
  border: 1px solid var(--border-strong);
}

.btn-secondary:hover {
  background: var(--bg-subtle);
  color: var(--text-primary);
}

.btn-success {
  background: var(--success);
}

.btn-success:hover {
  background: var(--success-hover);
}

.btn-danger {
  background: var(--danger);
}

.btn-danger:hover {
  background: var(--danger-hover);
}

/* Form Elements */
.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: var(--text-primary);
}

.form-input {
  width: 100%;
  padding: 10px 15px;
  background: var(--surface);
  color: var(--text-primary);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  outline: none;
  transition: border-color 0.2s ease;
}

.form-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.form-textarea {
  resize: vertical;
  min-height: 80px;
}

/* Notifications - above modals so "no talks to broadcast" etc. are visible when modal opens */
.notification {
  position: fixed;
  top: calc(62px + (var(--toast-index, 0) * 58px));
  right: 20px;
  padding: 15px 20px;
  border-radius: var(--radius-sm);
  color: white;
  z-index: 10000;
  animation: slideIn 0.3s ease;
}

/* Toast placement per width (GUI redesign §8): < 768px they render full-width
   at the top, one at a time, instead of stacking top-right. */
@media (max-width: 767px) {
  .notification {
    top: calc(58px + (var(--toast-index, 0) * 58px) + env(safe-area-inset-top, 0px));
    left: 12px;
    right: 12px;
    text-align: center;
  }
}

.notification.success {
  background: var(--success);
}

.notification.error {
  background: var(--danger);
}

.notification.info {
  background: var(--accent);
}

.notification.warning {
  background: var(--warning);
  color: var(--text-primary);
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: var(--surface);
  color: var(--text-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  padding: 30px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-header {
  margin-bottom: 20px;
}

/* Headers that carry a close button (many don't — some just have a title + subtitle
   paragraph, which must stay stacked, not pushed to the right) get title-left/×-right
   layout by default instead of the close button silently falling to its own line below
   the title as an unlabeled block element. */
.modal-header:has(.close-button) {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.modal-header:has(.close-button) .modal-title {
  margin-bottom: 0;
}

.modal-title {
  margin-bottom: 10px;
  color: var(--text-primary);
}

/* Some call sites already inline this same styling per-instance; this shared default
   covers the rest so an unstyled native <button>&times;</button> never renders as a
   raw bordered box that reads as a stray/broken element instead of a close icon. */
.close-button {
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: var(--text-tertiary, #666);
  padding: 0;
  flex-shrink: 0;
}

.close-button:hover {
  color: var(--text-primary);
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

/* First-run tour: each stop gets its own color and a concise product promise.
   The decorative orbits suggest one idea branching into many conversations. */
.walkthrough-card {
  position: relative;
  overflow-x: hidden;
  border: 1px solid color-mix(in srgb, var(--walkthrough-accent) 24%, var(--border));
  background:
    radial-gradient(circle at 100% 0%, var(--walkthrough-accent-soft), transparent 38%),
    var(--surface);
}

.walkthrough-card::before {
  content: '';
  position: absolute;
  inset: 0 0 auto;
  height: 4px;
  background: var(--walkthrough-accent);
}

.walkthrough-header {
  position: relative;
  display: grid !important;
  grid-template-columns: 1fr auto;
  gap: 3px 12px !important;
  margin-bottom: 8px;
}

.walkthrough-progress-label {
  color: var(--walkthrough-accent);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.walkthrough-header .modal-title {
  grid-column: 1;
  font-size: clamp(1.35rem, 5vw, 1.75rem);
}

.walkthrough-header .close-button {
  grid-column: 2;
  grid-row: 1 / span 2;
}

.walkthrough-hero {
  position: relative;
  padding: 12px 18px 18px;
  text-align: center;
  animation: walkthrough-reveal 240ms ease-out;
}

.walkthrough-icon {
  position: relative;
  display: grid;
  place-items: center;
  width: 74px;
  height: 74px;
  margin: 0 auto 14px;
  border: 1px solid color-mix(in srgb, var(--walkthrough-accent) 35%, transparent);
  border-radius: 24px;
  background: var(--walkthrough-accent-soft);
  box-shadow: 0 12px 28px color-mix(in srgb, var(--walkthrough-accent) 18%, transparent);
  font-size: 2.35rem;
  line-height: 1;
  transform: rotate(-3deg);
}

.walkthrough-tagline {
  position: relative;
  max-width: 460px;
  margin: 0 auto 10px;
  color: var(--text-primary);
  font-size: clamp(1.08rem, 4.5vw, 1.32rem);
  font-weight: 800;
  line-height: 1.25;
  text-wrap: balance;
}

.walkthrough-body {
  position: relative;
  max-width: 465px;
  margin: 0 auto;
  color: var(--text-secondary, #555);
  font-size: 0.96rem;
  line-height: 1.55;
  text-wrap: pretty;
}

.walkthrough-points {
  position: relative;
  display: grid;
  gap: 7px;
  max-width: 465px;
  margin: 14px auto 0;
  padding: 0;
  list-style: none;
  text-align: left;
}

.walkthrough-points li {
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: start;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid color-mix(in srgb, var(--walkthrough-accent) 18%, var(--border));
  border-radius: 10px;
  background: color-mix(in srgb, var(--walkthrough-accent-soft) 45%, var(--surface));
  color: var(--text-primary);
  font-size: 0.86rem;
  font-weight: 600;
  line-height: 1.35;
}

.walkthrough-point-icon {
  line-height: 1.2;
  text-align: center;
}

.walkthrough-orbit {
  position: absolute;
  border-radius: 50%;
  background: var(--walkthrough-accent-soft);
  /* OPEN-39: decorative only — a few loops, then rest. A never-ending loop kept the compositor at
     ~38 % of a core on Android 7 while the walkthrough stayed open. */
  animation: walkthrough-float 3.2s ease-in-out 3;
}

.walkthrough-orbit.orbit-one {
  top: 6px;
  left: 15%;
  width: 13px;
  height: 13px;
}

.walkthrough-orbit.orbit-two {
  top: 54px;
  right: 13%;
  width: 20px;
  height: 20px;
  animation-delay: -1.4s;
}

.walkthrough-dots {
  display: flex;
  justify-content: center;
  gap: 7px;
  margin-bottom: 12px;
}

.walkthrough-dot {
  width: 9px;
  height: 9px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: var(--border);
  cursor: pointer;
  transition: width 160ms ease, background-color 160ms ease, transform 160ms ease;
}

.walkthrough-dot:hover {
  transform: scale(1.25);
}

.walkthrough-dot.active {
  width: 25px;
  background: var(--walkthrough-accent);
}

.walkthrough-dot:focus-visible {
  outline: 3px solid var(--walkthrough-accent-soft);
  outline-offset: 3px;
}

.walkthrough-actions {
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.walkthrough-navigation {
  display: flex;
  gap: 8px;
}

.walkthrough-card .primary-btn {
  background: var(--walkthrough-accent);
  border-color: var(--walkthrough-accent);
}

@keyframes walkthrough-reveal {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes walkthrough-float {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-6px) scale(1.08); }
}

@media (prefers-reduced-motion: reduce) {
  .walkthrough-hero,
  .walkthrough-orbit {
    animation: none;
  }

  .walkthrough-dot {
    transition: none;
  }
}

/* Starter actions shown when the ordinary Talks list is empty. */
.talks-starter-heading h2 {
  margin: 8px 0;
  color: var(--text-primary);
  font-size: clamp(1.35rem, 5vw, 1.75rem);
  line-height: 1.2;
  text-wrap: balance;
}

.talks-starter-heading p {
  margin: 0 auto 16px;
  color: var(--text-secondary);
  line-height: 1.5;
}

.talks-starter-mark {
  display: grid;
  place-items: center;
  width: 68px;
  height: 68px;
  margin: 10px auto;
  border-radius: 22px;
  background: var(--accent-soft);
  font-size: 2rem;
}

.talks-starter-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}

.talks-starter-card {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  gap: 9px;
  align-items: start;
  min-height: 76px;
  padding: 11px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface);
  color: var(--text-primary);
  cursor: pointer;
  text-align: left;
}

.talks-starter-card:hover {
  border-color: var(--accent);
  background: var(--accent-soft);
}

.talks-starter-card small {
  display: block;
  margin-top: 3px;
  color: var(--text-secondary);
  font-size: 0.78rem;
  line-height: 1.3;
}

.talks-starter-icon {
  font-size: 1.35rem;
  line-height: 1.2;
}

.settings-inline-actions,
.talks-starter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.talks-starter-shelf {
  max-width: 760px;
  margin: 0 auto;
  padding: 26px 18px 40px;
}

.talks-starter-heading {
  margin-bottom: 18px;
  text-align: center;
}

.talks-starter-actions {
  justify-content: center;
  margin-top: 16px;
}

/* Identity & devices WP1: resilient card/row layout and a close control that
   remains reachable while the full-screen page scrolls on small displays. */
.identity-devices-page {
  box-sizing: border-box;
}

.identity-devices-header {
  position: sticky;
  top: -30px;
  z-index: 2;
  margin: -30px -30px 16px;
  padding: 20px 30px 12px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
}

.identity-linked-device-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  margin-bottom: 8px;
}

.identity-linked-device-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.identity-current-device-summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

/* ==========================================================================
   Popup responsive size classes (GUI redesign §8)
   Reference width matrix: 320 · 390 · 768 · 1024.
   Size classes are set per-dialog via \`.modal-content.size-{s,m,l,xl}\`;
   L/XL dialogs additionally carry \`.modal-fullscreen\` so they take over the
   screen (not a bottom sheet) on narrow viewports.
   ========================================================================== */
.modal-content {
  /* Never allow horizontal scrolling inside a dialog (e2e-asserted). */
  overflow-x: hidden;
}
.modal-content.size-s { max-width: 440px; }
.modal-content.size-m { max-width: 560px; }
.modal-content.size-l { max-width: 800px; }
.modal-content.size-xl { max-width: 1000px; max-height: 90vh; }

/* 768px: L/XL clamp to the viewport with a small gutter. */
@media (max-width: 768px) {
  .modal-content.size-l,
  .modal-content.size-xl {
    max-width: calc(100vw - 40px);
  }
}

/* ≤480px (covers 320/390): bottom sheets + stacked full-width actions. */
@media (max-width: 480px) {
  .modal-overlay {
    align-items: flex-end;
  }
  .modal-content {
    width: calc(100vw - 24px);
    max-width: calc(100vw - 24px);
    max-height: 92dvh;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding: 20px;
  }
  .modal-actions {
    flex-direction: column-reverse; /* primary action (last in DOM) ends up at the bottom */
    align-items: stretch;
  }
  .modal-actions > button,
  .modal-actions > .btn {
    width: 100%;
    min-height: 44px;
  }
  .walkthrough-card {
    padding: 18px 18px max(18px, env(safe-area-inset-bottom));
  }
  .talks-starter-grid {
    grid-template-columns: 1fr;
  }
  .settings-inline-actions,
  .settings-inline-actions .btn,
  .talks-starter-actions,
  .talks-starter-actions .btn {
    width: 100%;
  }
  .walkthrough-hero {
    padding: 8px 4px 14px;
  }
  .walkthrough-points {
    gap: 6px;
    margin-top: 11px;
  }
  .walkthrough-points li {
    padding: 7px 8px;
    font-size: 0.82rem;
  }
  .walkthrough-actions {
    flex-direction: row;
    align-items: center;
  }
  .walkthrough-actions > button {
    width: auto;
  }
  .walkthrough-navigation {
    flex: 1;
  }
  .walkthrough-navigation .btn {
    flex: 1;
    min-height: 44px;
  }
  /* Inputs/selects keep a 44px touch target. */
  .modal-content input,
  .modal-content select,
  .modal-content textarea {
    min-height: 44px;
  }
  /* L/XL dialogs become full-screen takeovers (no visible scrim to click). */
  .modal-content.modal-fullscreen {
    width: 100vw;
    max-width: 100vw;
    height: 100dvh;
    max-height: 100dvh;
    border-radius: 0;
  }

  .identity-devices-page.modal-fullscreen {
    margin: 0;
    width: 100vw;
    max-width: 100vw;
    height: 100dvh;
    max-height: 100dvh;
    padding: 16px;
    border-radius: 0;
  }

  .identity-devices-header {
    top: -16px;
    margin: -16px -16px 12px;
    padding: 14px 16px 10px;
  }

  .identity-linked-device-row,
  .identity-current-device-summary {
    align-items: stretch;
    flex-direction: column;
  }

  .identity-linked-device-row > .btn {
    width: 100%;
    min-height: 44px;
  }
}

/* My Answers list – single row per item, wider layout */
.answers-view-inner {
  max-width: min(900px, 95%);
  margin-left: auto;
  margin-right: auto;
}

.answer-outcome-item {
  cursor: pointer;
  transition: all 0.2s ease;
}

.answer-outcome-item:hover {
  filter: brightness(0.97);
}

/* Answer modal: table-style grid – Auto | Manual | Permanent columns, answers on the right */
.response-step-panel {
  background: var(--bg-subtle);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 10px 12px;
  margin-bottom: 16px;
}

.response-step-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--text-secondary);
  font-size: 0.86em;
  font-weight: 700;
  margin-bottom: 8px;
}

.response-step-dots {
  display: flex;
  align-items: center;
  gap: 6px;
}

.response-step-dot {
  width: 10px;
  height: 10px;
  border-radius: var(--radius-full);
  background: var(--border-strong);
  flex: 0 0 10px;
}

.response-step-done {
  background: var(--success);
}

.response-step-current {
  background: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.route-branch-preview {
  min-height: 0;
  margin-top: 14px;
}

.route-branch-preview:not(:empty) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid var(--accent-border);
  border-radius: var(--radius-sm);
  background: var(--accent-soft);
  padding: 10px 12px;
}

.route-branch-preview-copy {
  color: var(--accent-text);
  font-weight: 600;
}

.route-branch-preview-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}

.response-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.response-close-button {
  width: 32px;
  height: 32px;
  font-size: 22px;
  line-height: 1;
}

.response-question-row,
.response-review-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.response-question-text {
  min-width: 0;
  color: var(--text-primary);
  font-size: 1.1em;
  font-weight: 600;
}

.response-ignore-action {
  flex: 0 0 auto;
  padding: 5px 9px;
  border: 1px solid var(--border-strong);
  border-radius: 999px;
  background: transparent;
  color: var(--text-tertiary);
  cursor: pointer;
  font-size: 0.78rem;
  font-weight: 700;
}

.response-ignore-action:hover {
  border-color: var(--danger);
  color: var(--danger);
}

.answer-radio-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  min-width: 0;
  max-width: 520px;
}

.answer-grid-header {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) repeat(2, minmax(0, 0.8fr));
  gap: 12px 8px;
  padding: 8px 0;
  font-size: 0.82em;
  font-weight: 600;
  color: var(--text-tertiary);
  border-bottom: 1px solid var(--border);
}

.answer-grid-row {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) repeat(2, minmax(0, 0.8fr));
  gap: 12px 8px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid var(--border);
}

.answer-grid-row:last-child {
  border-bottom: none;
}

.answer-grid-row .answer-grid-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 4px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: var(--surface);
  cursor: pointer;
}

.answer-grid-row .answer-grid-cell input[type="radio"] {
  width: 18px;
  height: 18px;
  margin: 0;
  cursor: pointer;
}

.answer-grid-row .answer-grid-label {
  font-weight: 500;
  color: var(--text-primary);
  padding: 4px;
}

@media (max-width: 480px) {
  .answer-grid-header,
  .answer-grid-row {
    grid-template-columns: minmax(0, 1.2fr) repeat(2, minmax(0, 0.8fr));
    gap: 8px 5px;
  }

  .answer-grid-header {
    font-size: 0.74em;
  }

  .answer-grid-header > span,
  .answer-grid-row .answer-grid-cell,
  .answer-grid-row .answer-grid-label {
    min-width: 0;
    box-sizing: border-box;
    overflow-wrap: anywhere;
  }
}

.btn-back-question {
  flex-shrink: 0;
  padding: 8px 12px;
  font-size: 0.9em;
  background: var(--bg-muted);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  cursor: pointer;
  color: var(--text-primary);
}

.btn-back-question:hover {
  background: var(--border);
  border-color: var(--text-muted);
}

/* Talk Creation */
.talk-editor {
  background: var(--surface);
  border-radius: var(--radius-md);
  padding: 20px;
}

.question-editor {
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 15px;
  margin-bottom: 15px;
}

.answer-editor {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.add-answer {
  background: var(--bg-muted);
  border: 2px dashed var(--border-strong);
  border-radius: var(--radius-sm);
  padding: 10px;
  text-align: center;
  cursor: pointer;
  color: var(--text-tertiary);
  transition: all 0.2s ease;
}

.add-answer:hover {
  background: var(--accent-soft);
  border-color: var(--accent);
  color: var(--accent);
}

/* Survey Results */
.survey-results {
  background: var(--surface);
  border-radius: var(--radius-md);
  padding: 20px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid var(--bg-muted);
}

.progress-bar {
  background: var(--bg-muted);
  border-radius: var(--radius-md);
  height: 8px;
  overflow: hidden;
  margin-top: 5px;
}

.progress-fill {
  background: var(--accent);
  height: 100%;
  transition: width 0.3s ease;
}

/* Responsive Design */
@media (max-width: 768px) {
  .app-container {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    height: 300px;
    border-right: none;
    border-bottom: 1px solid var(--border);
  }

  .message {
    max-width: 85%;
  }

  .modal-content {
    margin: 20px;
    width: auto;
  }

  /* This rule intentionally follows the generic mobile modal rule above so the
     Identity & devices takeover cannot regain margins or shrink below 100vw. */
  .identity-devices-page.modal-fullscreen {
    margin: 0;
  }
}

/* Error States */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  height: 100dvh;
  text-align: center;
  padding: 20px;
}

.error-container h1 {
  color: var(--danger);
  margin-bottom: 20px;
}

.error-container p {
  color: var(--text-tertiary);
  margin-bottom: 30px;
  max-width: 400px;
}

/* Utility Classes */
.hidden {
  display: none;
}
.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.flex-center {
  align-items: center;
  justify-content: center;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.p-10 {
  padding: 10px;
}
.p-20 {
  padding: 20px;
}
/* User List Styles */
.user-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid var(--bg-muted);
  cursor: pointer;
  transition: background-color 0.2s;
}

.user-item:hover {
  background-color: var(--bg-subtle);
}

.user-details {
  flex: 1;
  margin-left: 10px;
}

.user-name {
  font-weight: 500;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.user-status {
  font-size: 0.85em;
  color: var(--success);
}

.btn-send-talk {
  background: var(--accent);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: var(--radius-sm);
  font-size: 0.9em;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-send-talk:hover {
  background: var(--accent-hover);
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
  color: var(--text-muted);
}

.empty-state p {
  margin: 5px 0;
}

/* User Profile (Me View) */
.user-profile {
  padding: 20px;
  background: var(--surface);
}

.profile-actions {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.profile-btn {
  width: 100%;
  padding: 15px 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  font-size: 1em;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 10px;
}

.profile-btn:hover {
  background: var(--bg-muted);
  border-color: var(--border-strong);
}

.profile-btn:active {
  transform: scale(0.98);
}

/* Primary Button */
.primary-btn {
  background: var(--success);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: var(--radius-md);
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.primary-btn:hover {
  background: var(--success-hover);
}

.primary-btn:active {
  transform: scale(0.98);
}

/* Conversations View Styles */
.conversations-list {
  padding: 8px;
}

.conversation-list-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: var(--surface);
  border-radius: var(--radius-lg);
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid var(--border);
}

.conversation-list-item:hover {
  background: var(--bg-muted);
  transform: translateX(4px);
}

.conversation-list-item.unread {
  background: var(--accent-soft);
  border-color: var(--success);
}

.conversation-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--gradient-accent);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5em;
  font-weight: bold;
  margin-right: 12px;
  flex-shrink: 0;
}

.conversation-avatar-wrapper {
  position: relative;
  margin-right: 12px;
  flex-shrink: 0;
}

.conversation-avatar-wrapper .conversation-avatar {
  margin-right: 0;
}

.conversation-online-indicator {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 12px;
  height: 12px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: var(--success);
}

/* K1 item 3 (docs/TODO.md): TechSupport liveness, never headcount — inline dot next to the
   built-in support row/roster name. Defaults to "away" until a real presence signal arrives. */
.techsupport-presence-indicator {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 8px;
  vertical-align: middle;
}

.techsupport-presence-indicator.online {
  background: var(--success);
}

.techsupport-presence-indicator.away {
  background: var(--text-tertiary);
}

/* General presence dot — same online/away treatment as TechSupport's own indicator above,
   shared by every ordinary contact row (contacts-view.ts) and chatroom member row
   (chatrooms-view.ts) so both lists render presence identically. */
.presence-indicator {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 8px;
  vertical-align: middle;
}

.presence-indicator.online {
  background: var(--success);
}

.presence-indicator.away {
  background: var(--text-tertiary);
}

/* K3 (docs/TODO.md): permanent app-bar badge whenever the current identity IS the TechSupport
   root — an operator must always be able to tell they are signed in as TechSupport. */
.techsupport-root-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent-hover);
  font-size: 0.72em;
  font-weight: 700;
  white-space: nowrap;
}

.peer-compatibility {
  margin-top: 9px;
}

.peer-compatibility-label {
  display: flex;
  justify-content: space-between;
  color: var(--text-secondary);
  font-size: 0.8em;
}

.peer-compatibility-track {
  height: 7px;
  overflow: hidden;
  margin-top: 4px;
  border-radius: var(--radius-sm);
  background: var(--border);
}

.peer-compatibility-track span {
  display: block;
  height: 100%;
  background: var(--success);
}

.peer-shared-tags {
  display: grid;
  gap: 3px;
  margin-top: 8px;
  color: var(--success-text);
  font-size: 0.84em;
}

.peer-reputation-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 9px;
  color: var(--text-secondary);
  font-size: 0.82em;
  font-weight: 700;
}

.stats-bar-list {
  display: grid;
  gap: 6px;
  margin: 0 0 10px;
}

.stats-bar-row {
  display: grid;
  grid-template-columns: minmax(72px, 1fr) minmax(80px, 2fr) 28px;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
  font-size: 0.78em;
}

.stats-bar-row > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stats-bar-row b {
  color: var(--text-primary);
  text-align: right;
}

.stats-bar-track {
  height: 8px;
  overflow: hidden;
  border-radius: var(--radius-sm);
  background: var(--border);
}

.stats-bar-track i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--accent);
}

.stats-sparkline {
  display: grid;
  gap: 2px;
  margin: 0 0 10px;
}

.stats-sparkline svg {
  width: 100%;
  height: 56px;
  border-bottom: 1px solid var(--border-strong);
  background: var(--bg-subtle);
}

.stats-sparkline span {
  color: var(--text-tertiary);
  font-size: 0.78em;
}

.survey-chart-title { margin-bottom: 8px; color: var(--text-primary); font-size: 0.9em; font-weight: 700; }
.survey-completion-funnel { display: grid; gap: 6px; margin: 14px 0; padding: 12px; border: 1px solid var(--accent-soft); border-radius: var(--radius-md); background: var(--accent-soft); }
.survey-funnel-step { display: grid; grid-template-columns: 28px 1fr 42px; align-items: center; gap: 8px; color: var(--text-secondary); font-size: 0.82em; }
.survey-funnel-step i { display: block; height: 14px; overflow: hidden; border-radius: var(--radius-sm); background: var(--accent-soft); }
.survey-funnel-step i::before { content: ''; display: block; width: 100%; height: 100%; background: var(--accent); }
.survey-funnel-step i { clip-path: polygon(0 0, 100% 0, 88% 100%, 12% 100%); }
.survey-funnel-step b { text-align: right; }
.survey-answer-bar { display: grid; grid-template-columns: minmax(90px, 1fr) minmax(90px, 2fr) auto; align-items: center; gap: 10px; padding: 8px 10px; margin-top: 6px; border: 1px solid var(--border); border-radius: var(--radius-sm); background: var(--bg-subtle); }
.survey-answer-bar > span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.survey-answer-bar i { height: 8px; overflow: hidden; border-radius: var(--radius-sm); background: var(--accent-soft); }
.survey-answer-bar i b { display: block; height: 100%; background: var(--accent); }
.survey-answer-bar strong { white-space: nowrap; }
.survey-answer-bar em { color: var(--text-tertiary); font-style: normal; font-weight: 500; }

.conversation-transport-chip {
  margin-left: 7px;
  border: 1px solid var(--accent-border);
  border-radius: var(--radius-sm);
  background: var(--accent-soft);
  color: var(--accent-hover);
  font-size: 0.72em;
  font-weight: 700;
  line-height: 1.35;
  padding: 1px 5px;
}

.unread-count-badge {
  display: inline-flex;
  min-width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  margin-right: 7px;
  border-radius: var(--radius-md);
  background: var(--danger);
  color: #fff;
  font-size: 0.72em;
  font-weight: 700;
}

.conversation-bot-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 1em;
  line-height: 1;
  background: var(--bg-muted);
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

/* Inline per-message counterpart to .conversation-bot-badge — TechSupport's own auto-answer
   indicator (docs/TODO.md K5) inside a message bubble rather than floated over an avatar. */
.message-bot-badge {
  display: inline-block;
  margin-right: 4px;
}

.conversation-content {
  flex: 1;
  min-width: 0;
}

.conversation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.conversation-name {
  font-weight: 600;
  font-size: 1em;
  color: var(--text-primary);
}

.conversation-time {
  font-size: 0.75em;
  color: var(--text-muted);
}

.conversation-preview {
  font-size: 0.9em;
  color: var(--text-tertiary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 6px;
}

.unread-badge {
  width: 8px;
  height: 8px;
  background: var(--success);
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

/* Conversation Detail Overlay */
.conversation-detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--surface);
  /* Above the peer/User layout (1000): rule N2a stacks ⟨Conv⟩ on top of ⟨User⟩. */
  z-index: 1001;
  display: none; /* Hidden by default */
  flex-direction: column;
}

/* Email-style thread list in the shared User layout (redesign §5) */
.peer-thread-list {
  padding: 4px 16px 8px;
}

.peer-thread-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  margin-bottom: 6px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  cursor: pointer;
}

.peer-thread-item:hover {
  background: var(--bg-subtle);
}

.peer-thread-main {
  min-width: 0;
  flex: 1;
}

.peer-thread-title {
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.peer-thread-snippet {
  font-size: 0.85em;
  color: var(--text-tertiary);
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.peer-thread-side {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.peer-thread-time {
  font-size: 0.75em;
  color: var(--text-muted);
  white-space: nowrap;
}

.thread-unread-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: var(--radius-full);
  background: var(--danger);
  color: #fff;
  font-size: 0.72em;
  font-weight: 700;
}

.peer-thread-group-label {
  font-size: 0.78em;
  font-weight: 700;
  color: var(--text-tertiary);
  padding: 8px 2px 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.conversation-detail-overlay .conversation-detail-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Conversation Detail View */
.conversation-detail-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.conversation-detail-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  gap: 12px;
}

.conversation-detail-info {
  flex: 1;
}

.conversation-detail-name {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.1em;
  color: var(--text-primary);
}

.conversation-detail-status {
  font-size: 0.85em;
  color: var(--text-muted);
}

/* Diagnostic lines (transport mode / fallback reason / last-contact) — hidden unless
   debug view is on (?debug=1 or localStorage iinpublic_debug=1). Text stays in the DOM. */
.conversation-transport-status,
.conversation-fallback-status,
.conversation-health-status {
  display: none;
  font-size: 0.8em;
  color: var(--text-muted);
}

body.iinpublic-debug .conversation-transport-status,
body.iinpublic-debug .conversation-fallback-status,
body.iinpublic-debug .conversation-health-status {
  display: block;
}

.conversation-messages {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: var(--bg-muted);
}

.message {
  margin-bottom: 12px;
  display: flex;
}

.message-own {
  justify-content: flex-end;
}

.message-other {
  justify-content: flex-start;
}

.message-content {
  max-width: 70%;
  padding: 10px 14px;
  border-radius: var(--radius-xl);
  background: var(--surface);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.message-own .message-content {
  background: var(--success);
  color: white;
  border-bottom-right-radius: 4px;
}

.message-other .message-content {
  background: var(--surface);
  color: var(--text-primary);
  border-bottom-left-radius: 4px;
}

.message-text {
  font-size: 0.95em;
  line-height: 1.4;
  word-wrap: break-word;
}

/* Matched-talk IPFS auto-share (L5): shared photo / file attachment card */
.ipfs-attachment {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 160px;
  max-width: 260px;
}

/* Inline chip: small preview thumbnail (image) or icon + name + Download link. */
.ipfs-attachment-chip {
  flex-direction: row;
  align-items: center;
  gap: 10px;
  min-width: 0;
  max-width: 300px;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-subtle);
}

.ipfs-attachment-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: var(--radius-sm);
  flex-shrink: 0;
  background: var(--bg-muted);
}

.ipfs-attachment-chip .ipfs-attachment-icon {
  flex-shrink: 0;
  font-size: 1.4em;
}

.ipfs-attachment-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.ipfs-attachment-chip .ipfs-attachment-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  font-size: 0.9em;
}

.ipfs-attachment-chip .ipfs-attachment-download {
  align-self: flex-start;
  margin-top: 2px;
  font-size: 0.95em;
  opacity: 0.55;
  text-decoration: none;
}

.ipfs-attachment-chip .ipfs-attachment-download:hover {
  opacity: 1;
}

/* In-app full-size photo viewer (lightbox) */
.media-lightbox {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: none;
  align-items: center;
  justify-content: center;
}

.media-lightbox-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.9);
}

.media-lightbox-img {
  position: relative;
  max-width: 92vw;
  max-height: 84vh;
  object-fit: contain;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
}

.media-lightbox-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  color: white;
  z-index: 1;
}

.media-lightbox-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.media-lightbox-action {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: var(--radius-full);
  background: rgba(255, 255, 255, 0.15);
  color: white;
  font-size: 1.1em;
  cursor: pointer;
}

.media-lightbox-action:hover {
  background: rgba(255, 255, 255, 0.28);
}

.ipfs-attachment-head {
  font-size: 0.9em;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ipfs-attachment-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ipfs-attachment-size {
  font-weight: 400;
  opacity: 0.7;
  font-size: 0.85em;
}

.ipfs-attachment-img {
  display: block;
  width: 100%;
  max-height: 240px;
  object-fit: contain;
  border-radius: var(--radius-md);
  background: var(--bg-muted);
}

.ipfs-attachment-download {
  font-size: 0.82em;
  font-weight: 600;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  align-self: flex-start;
}

.ipfs-attachment-loading {
  font-size: 0.78em;
  opacity: 0.7;
  font-style: italic;
}

/* Shared-media gallery */
.conversation-media-btn {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1.2em;
  border-radius: var(--radius-full);
}

.conversation-media-btn:hover {
  background: var(--bg-subtle);
}

.conversation-media-gallery {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--surface);
}

.conversation-media-gallery-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.conversation-media-title {
  font-weight: 600;
  color: var(--text-primary);
}

.conversation-media-tabs {
  display: flex;
  gap: 4px;
  padding: 8px 12px 0;
  flex-shrink: 0;
}

.conversation-media-tab {
  flex: 1;
  padding: 8px 4px;
  border: none;
  background: none;
  border-bottom: 2px solid transparent;
  color: var(--text-tertiary);
  font-weight: 600;
  font-size: 0.9em;
  cursor: pointer;
}

.conversation-media-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.conversation-media-grid {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 10px;
  align-content: start;
}

.conversation-media-grid.is-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.conversation-media-link {
  display: block;
  font-size: 0.85em;
  color: var(--accent);
  word-break: break-all;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-subtle);
}

.conversation-media-link:hover {
  border-color: var(--accent);
}

.conversation-media-empty {
  grid-column: 1 / -1;
  text-align: center;
  color: var(--text-muted);
  padding: 40px 20px;
}

.conversation-media-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 6px;
  background: var(--surface);
  overflow: hidden;
}

.conversation-media-tile:hover {
  border-color: var(--accent);
}

.media-tile-img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: var(--radius-sm);
}

.media-tile-fileicon {
  width: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  background: var(--bg-muted);
  border-radius: var(--radius-sm);
}

.media-tile-name {
  font-size: 0.72em;
  color: var(--text-secondary);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media-tile-size {
  font-size: 0.66em;
  color: var(--text-muted);
}

.media-tile-download {
  display: none;
}

.ipfs-attachment-link {
  font-size: 0.72em;
  opacity: 0.6;
  word-break: break-all;
  color: inherit;
}

.message-time {
  font-size: 0.75em;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 4px;
  text-align: right;
}

.message-other .message-time {
  color: var(--text-muted);
}

.conversation-input-container {
  display: flex;
  gap: 8px;
  padding: 12px;
  background: var(--surface);
  border-top: 1px solid var(--border);
  align-items: flex-end;
}

.conversation-attach-btn {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border: 1px solid var(--border-strong);
  background: var(--surface);
  border-radius: var(--radius-full);
  cursor: pointer;
  font-size: 1.2em;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, border-color 0.2s;
}

.conversation-attach-btn:hover {
  background: var(--bg-subtle);
  border-color: var(--accent);
}

#conversation-message-input {
  flex: 1;
  padding: 10px 14px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-xl);
  resize: none;
  font-family: inherit;
  font-size: 0.95em;
  outline: none;
}

#conversation-message-input:focus {
  border-color: var(--success);
}

.send-btn {
  background: var(--success);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: var(--radius-xl);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.send-btn:hover {
  background: var(--success-hover);
}

.send-btn:active {
  transform: scale(0.95);
}

/* Notification Badge on Tab Icon */
.nav-icon {
  position: relative;
}

.notification-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: var(--danger);
  color: white;
  font-size: 0.7em;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: var(--radius-md);
  min-width: 18px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.15);
}

/* ============================================================
   Chatroom member arrow
   ============================================================ */
.chatroom-member-arrow {
  color: var(--border-strong);
  font-size: 1.2em;
  margin-left: 4px;
}

.chatroom-member-item.member-stranger .chatroom-member-status {
  color: var(--text-muted);
}

.chatroom-member-item.member-known .chatroom-member-status {
  color: var(--accent);
}

/* ============================================================
   Peer Detail Overlay
   ============================================================ */
.peer-detail-overlay {
  position: fixed;
  inset: 0;
  background: var(--surface);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.peer-detail-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.peer-detail-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.peer-detail-info {
  flex: 1;
  min-width: 0;
}

.peer-detail-name {
  font-size: 1.1em;
  font-weight: 700;
  color: var(--text-primary);
}

.peer-detail-subtitle {
  font-size: 0.85em;
  color: var(--text-tertiary);
  margin-top: 2px;
}

.peer-detail-body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.peer-stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 16px;
}

.peer-stat-card {
  background: var(--bg-subtle);
  border-radius: var(--radius-lg);
  padding: 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid var(--border);
}

.peer-stat-card.peer-stat-mutual {
  grid-column: span 1;
  background: var(--success-soft);
  border-color: var(--success-border);
}

.peer-stat-icon {
  font-size: 1.4em;
  flex-shrink: 0;
}

.peer-stat-body {
  flex: 1;
  min-width: 0;
}

.peer-stat-label {
  font-size: 0.75em;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
}

.peer-stat-value {
  font-size: 1.1em;
  font-weight: 700;
  color: var(--text-primary);
}

.peer-stat-sub {
  font-size: 0.8em;
  color: var(--text-tertiary);
  margin-top: 2px;
}

.peer-section-header {
  border-top: 1px solid var(--border);
}

.peer-section-title {
  font-size: 0.95em;
  font-weight: 700;
  color: var(--text-secondary);
}

#peer-history-controls {
  display: flex;
}

.peer-history-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--bg-muted);
}

.peer-outcome-match {
  background: var(--success-soft);
}

.peer-outcome-mismatch {
  background: var(--danger-soft);
}

.peer-outcome-pending {
  background: var(--surface);
}

.peer-history-direction {
  font-size: 1.2em;
  flex-shrink: 0;
  margin-top: 2px;
}

.peer-history-body {
  flex: 1;
  min-width: 0;
}

.peer-history-title {
  font-size: 0.95em;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.peer-talk-type {
  font-size: 0.75em;
  background: var(--accent-soft);
  color: var(--accent-text);
  padding: 1px 6px;
  border-radius: var(--radius-sm);
  margin-left: 4px;
  vertical-align: middle;
}

.peer-history-meta {
  display: flex;
  gap: 8px;
  font-size: 0.8em;
  color: var(--text-tertiary);
  flex-wrap: wrap;
}

.peer-history-outcome {
  font-weight: 600;
}

.peer-outcome-match .peer-history-outcome {
  color: var(--success-hover);
}

.peer-outcome-mismatch .peer-history-outcome {
  color: var(--danger-hover);
}

.peer-section-title {
  font-size: 0.95em;
  font-weight: 700;
  color: var(--text-secondary);
}

.peer-conv-list {
  padding: 0 16px 8px;
}

.peer-conv-item {
  background: var(--bg-subtle);
  border-radius: var(--radius-md);
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid var(--border);
}

.peer-conv-talk-title {
  font-weight: 600;
  font-size: 0.9em;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.peer-conv-preview {
  font-size: 0.85em;
  color: var(--text-tertiary);
  margin-bottom: 8px;
}

.peer-open-chat-btn {
  font-size: 0.85em;
  padding: 6px 14px;
}

.peer-send-section {
  border-top: 1px solid var(--border);
  padding-top: 4px;
}

.peer-auto-mode-label {
  color: var(--text-secondary);
}

.peer-sort-btn.active,
.peer-filter-tab.active {
  background: var(--accent-hover);
  color: white;
}

/* Talk editor — compact, scroll-safe composer.
   The shell itself never scrolls: the form body does, while the header and submit bar remain
   reachable. Optional delivery/media/preview controls use progressive disclosure so a simple
   tag stays genuinely simple without removing any capability. */
.talk-editor-shell {
  display: flex;
  flex-direction: column;
  width: min(1000px, calc(100vw - 40px));
  max-width: 1000px;
  max-height: 90dvh;
  padding: 0;
  overflow: hidden;
}

.talk-editor-header {
  flex: 0 0 auto;
  align-items: center !important;
  margin: 0;
  padding: 18px 24px 14px;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}

.talk-editor-header .modal-title {
  margin: 0;
}

.talk-editor-promise {
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-weight: 650;
}

.talk-editor-close {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 999px;
}

.talk-editor-close:hover {
  background: var(--bg-subtle);
}

.talk-editor-form {
  flex: 1 1 auto;
  min-height: 0;
  padding: 18px 24px 20px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.talk-editor-description {
  margin: 0 0 16px;
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.4;
}

#browse-talk-templates-btn {
  justify-content: center;
  width: 100%;
}

.talk-type-picker {
  min-width: 0;
  padding: 0;
  border: 0;
}

.talk-type-picker .form-label {
  padding: 0;
}

.talk-type-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.talk-type-option {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  min-height: 48px;
  padding: 9px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
  color: var(--text-secondary);
  font-weight: 650;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;
}

.talk-type-option:hover {
  border-color: var(--accent-border);
  background: var(--accent-soft);
}

.talk-type-option:has(input:checked) {
  border-color: var(--accent);
  background: var(--accent-soft);
  color: var(--accent-text);
  box-shadow: inset 0 0 0 1px var(--accent);
}

.talk-type-option input {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  min-height: 0;
  margin: 0;
}

.talk-type-icon {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: var(--bg-muted);
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-weight: 800;
}

.talk-type-option:has(input:checked) .talk-type-icon {
  background: var(--accent);
  color: #fff;
}

#tag-like-group,
#tag-pair-group {
  margin-bottom: 10px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg-subtle);
}

.talk-editor-more {
  margin-top: 4px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
}

.talk-editor-more > summary {
  min-height: 44px;
  padding: 11px 14px;
  color: var(--text-secondary);
  font-weight: 700;
  cursor: pointer;
  user-select: none;
}

.talk-editor-more[open] > summary {
  border-bottom: 1px solid var(--border);
  color: var(--text-primary);
}

.talk-editor-more-body {
  padding: 16px 16px 0;
}

.talk-editor-actions {
  position: relative;
  flex: 0 0 auto;
  z-index: 4;
  margin: 0;
  padding: 12px 24px max(12px, env(safe-area-inset-bottom));
  border-top: 1px solid var(--border);
  background: color-mix(in srgb, var(--surface) 96%, transparent);
  box-shadow: 0 -8px 18px rgb(15 23 42 / 8%);
  backdrop-filter: blur(8px);
}

.talk-editor-actions #talk-submit-btn {
  min-width: 140px;
}

@media (max-width: 600px) {
  .talk-editor-shell.modal-fullscreen {
    width: 100vw;
    max-width: 100vw;
    height: 100dvh;
    max-height: 100dvh;
    margin: 0;
    border-radius: 0;
  }

  .talk-editor-header {
    padding: 11px 14px 9px;
  }

  .talk-editor-header .modal-title {
    font-size: 1.25rem;
  }

  .talk-editor-promise {
    display: none;
  }

  .talk-editor-close {
    width: 44px;
    height: 44px;
  }

  .talk-editor-form {
    padding: 12px 14px 16px;
    scrollbar-gutter: auto;
  }

  .talk-editor-description {
    margin-bottom: 12px;
    font-size: 0.84rem;
  }

  .talk-editor-form .form-group {
    margin-bottom: 14px;
  }

  .talk-type-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 7px;
  }

  .talk-type-option {
    min-height: 46px;
    padding: 8px;
  }

  .talk-editor-form input,
  .talk-editor-form select,
  .talk-editor-form textarea {
    font-size: 16px;
  }

  .talk-type-option input,
  .talk-send-chatroom-label input {
    width: 20px;
    height: 20px;
    min-height: 0;
  }

  .talk-editor-more-body {
    padding: 14px 12px 0;
  }

  .talk-editor-actions {
    flex-direction: row;
    align-items: stretch;
    margin: 0;
    padding: 10px 14px max(10px, env(safe-area-inset-bottom));
  }

  .talk-editor-actions > button,
  .talk-editor-actions > .btn {
    width: auto;
    min-height: 48px;
  }

  .talk-editor-actions #cancel-talk-btn {
    flex: 1 1 34%;
  }

  .talk-editor-actions #talk-submit-btn {
    flex: 2 1 66%;
    min-width: 0;
  }
}

/* Answered automatically by the receiver's chatbot (🤖): one scheme-independent violet so the
   record stands apart from every accent/talk-type color, in light and dark. */
:root {
  --chatbot-accent: #7c5cd6;
  --chatbot-soft: #f1ecfb;
}
@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) {
    --chatbot-accent: #a58cf0;
    --chatbot-soft: #241d36;
  }
}
:root[data-theme="dark"] {
  --chatbot-accent: #a58cf0;
  --chatbot-soft: #241d36;
}
.talk-badge-chatbot,
.answer-chatbot-mark {
  color: var(--chatbot-accent);
}

/* Person↔tag graph (OPEN-87): tag chips on person and tag pages, the tag directory. */
.tag-graph-body { padding: 12px 16px 16px; display: flex; flex-direction: column; gap: 10px; }
.tag-graph-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.tag-graph-chip {
  border: 1px solid var(--border-strong);
  background: var(--surface);
  color: var(--text-primary);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 0.85em;
  cursor: pointer;
}
.tag-graph-chip.is-shared { background: var(--accent-soft); border-color: var(--accent); font-weight: 600; }
.tag-graph-count { color: var(--text-tertiary); font-weight: 400; margin-left: 2px; }
.tag-graph-peer-tags { margin: 12px 16px 0; }
.tag-graph-heading { font-size: 0.8em; color: var(--text-tertiary); margin-bottom: 6px; }
.tag-graph-summary { margin: 0; color: var(--text-secondary); font-size: 0.9em; }
.tag-graph-people { display: flex; flex-direction: column; gap: 6px; max-height: 50vh; overflow-y: auto; }
.tag-graph-person {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 10px;
  border-radius: 8px;
  background: var(--bg-muted);
  cursor: pointer;
}
.tag-graph-person-name { font-weight: 600; }
.tag-graph-shared { font-size: 0.8em; color: var(--accent); }
.tag-graph-empty { color: var(--text-tertiary); text-align: center; margin: 8px 0; }
.contact-item-shared-tags { font-size: 0.8em; color: var(--accent); font-weight: 700; margin-top: 4px; }

/* Talks rows without per-row buttons (owner design 2026-10-24). */
.talk-tag-chip-flow { display: flex; flex-wrap: wrap; gap: 6px; margin: 4px 0 8px; }
.talk-tag-chip-flow.is-grouped { padding-left: 18px; }
.talk-tag-chip-flow > .talk-list-item.talk-tag-chip { margin: 0; cursor: pointer; }
.talk-list-item.talk-tag-out.is-liked { background: var(--accent-soft); border-color: var(--accent); }
.talk-tag-liked-mark { color: var(--accent); font-size: 0.9em; }
.talk-list-item.is-selected { outline: 2px solid var(--accent); outline-offset: 2px; }
.talk-pin-badge { font-size: 0.8em; line-height: 1; }
/* Rows without buttons (list-row-selection.ts): a long-press selects, the AppBar acts. */
.contact-item.is-selected,
.answer-talk-item.is-selected { outline: 2px solid var(--accent); outline-offset: 2px; }
.list-pin-badge { font-size: 0.8em; line-height: 1; flex-shrink: 0; }
/* Me: a tag row's ♡ / ✕, and the people a row leads to (contacts-focus.ts). */
.answer-tag-mark { color: var(--accent); font-weight: 700; width: 1.1em; text-align: center; }
.focus-chip { display: inline-flex; align-items: center; gap: 4px; padding: 4px 6px 4px 10px; border-radius: 999px; background: var(--accent-soft); border: 1px solid var(--accent-border); font-size: 0.85em; font-weight: 600; }
.focus-chip[hidden] { display: none; }
.focus-chip-clear { background: none; border: none; font-size: 1em; cursor: pointer; color: var(--text-tertiary); }
.graph-back-btn[hidden] { display: none; }
.place-graph-links { display: flex; flex-wrap: wrap; gap: 4px 10px; margin: 0 0 8px; }
.place-graph-links .graph-link { margin-left: 0; font-size: 0.85em; }
.graph-link { font-size: 0.8em; color: var(--accent-text); margin-left: 6px; cursor: pointer; text-decoration: underline; text-underline-offset: 2px; white-space: nowrap; }
.graph-link:focus-visible { outline: 2px solid var(--accent); outline-offset: 3px; border-radius: 3px; }
.graph-place-link { display: inline-block; max-width: 100%; white-space: normal; overflow-wrap: anywhere; }
.talk-graph-links { display: inline-flex; flex-wrap: wrap; gap: 4px; justify-content: flex-end; }
.talk-graph-links .graph-link { white-space: normal; overflow-wrap: anywhere; }
.tag-graph-heading .graph-link,
.talk-graph-links .graph-link,
.talk-tag-chip .graph-link { display: inline-flex; align-items: center; min-height: 32px; font-size: 0.875rem; }
.talk-tag-chip:has(.graph-place-link) { flex-wrap: wrap; }
.graph-place-focused > #chatroom-list-container,
.graph-place-focused > #chatroom-detail-container { display: none !important; }
#graph-place-panel { padding: 20px; overflow-y: auto; min-width: 0; }
#graph-place-panel h2 { overflow-wrap: anywhere; }
#graph-place-panel .place-graph-links { gap: 12px; margin: 18px 0; }
#graph-place-panel .graph-link { display: inline-flex; align-items: center; min-height: 44px; font-size: 1em; white-space: normal; }
#graph-place-panel button { min-height: 44px; padding: 8px 14px; }
#place-detail-graph-links { padding: 0 16px; }
body[data-graph-place-active] [data-appbar-view="chatrooms"],
body[data-graph-place-active] #back-to-chatrooms { display: none !important; }
.contact-item,
.answer-talk-item { -webkit-touch-callout: none; user-select: none; }
.talks-tap-hint { font-size: 0.8em; color: var(--text-tertiary); margin: 2px 2px 8px; }
.talks-direction-divider {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 16px 0 10px;
  color: var(--text-tertiary);
  font-size: 0.8em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.talks-direction-divider::before,
.talks-direction-divider::after { content: ''; flex: 1; border-top: 1px solid var(--border-strong); }

/* Map exchange history: neutral, selectable connections under people and broadcast effects. */
.chatroom-map-connections, .chatroom-map-connection-lines {
  position: absolute; inset: 0; width: 100%; height: 100%; pointer-events: none;
}
.chatroom-map-connection-line { stroke: #64748b; stroke-width: 1.5; opacity: .65; }
.chatroom-map-connection-line.selected { stroke: #334155; stroke-width: 3; opacity: 1; }
.chatroom-map-connection-line.dimmed, .chatroom-map-connection-label.dimmed { opacity: .25; }
.chatroom-map-connection-hit { stroke: transparent; stroke-width: 24; pointer-events: stroke; cursor: pointer; }
.chatroom-map-connection-hit:focus-visible { stroke: #64748b33; outline: none; }
.chatroom-map-connection-label {
  position: absolute; transform: translate(-50%, -50%); pointer-events: auto; cursor: pointer;
  border: 1px solid #94a3b8; border-radius: 12px; padding: 3px 7px; min-height: 28px;
  background: var(--surface, white); color: var(--text-primary, #334155); font-size: 11px; white-space: nowrap;
}
.chatroom-map-connection-label[hidden] { display: none; }
.chatroom-map-connection-panel {
  position: absolute; bottom: 36px; left: 50%; transform: translateX(-50%); max-width: calc(100% - 24px);
  display: flex; align-items: center; gap: 10px; border-radius: 10px; padding: 8px 12px;
  background: var(--surface, white); color: var(--text-primary, #334155); box-shadow: 0 2px 12px #0003;
  pointer-events: auto; font-size: 13px;
}
.chatroom-map-connection-panel[hidden] { display: none; }
.chatroom-map-connection-panel button { min-width: 80px; min-height: 44px; cursor: pointer; }
.chatroom-map-connection-label:focus-visible, .chatroom-map-connection-panel button:focus-visible {
  outline: 2px solid var(--accent, #2563eb); outline-offset: 2px;
}
.chatroom-map-member-actions { flex-wrap: wrap; }
@media (pointer: coarse) {
  .chatroom-map-connection-hit { stroke-width: 32; }
  .chatroom-map-connection-label { min-height: 44px; min-width: 44px; }
  .chatroom-map-member-profile { min-height: 44px; }
}
`, "",{"version":3,"sources":["webpack://./src/web/styles/main.css"],"names":[],"mappings":"AAAA;;;;;;;;iEAQiE;AACjE;;EAEE,0CAA0C;EAC1C,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;;EAEtB,yDAAyD;EACzD,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;;EAEvB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;;EAExB,oDAAoD;EACpD,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;;EAEvB,mCAAmC;EACnC,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;;EAElB,cAAc;EACd,oEAAoE;EACpE,qEAAqE;EACrE,2EAA2E;AAC7E;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;EACpE,qEAAqE;EACrE,2EAA2E;AAC7E;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;EACpE,qEAAqE;EACrE,2EAA2E;AAC7E;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;EACpE,qEAAqE;EACrE,2EAA2E;AAC7E;;AAEA;0FAC0F;AAC1F;EACE;;IAEE,iBAAiB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,wBAAwB,EAAE,sBAAsB;IACpH,kBAAkB,EAAE,wBAAwB,EAAE,uBAAuB,EAAE,yBAAyB;IAChG,iBAAiB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,wBAAwB;IAC5F,kBAAkB,EAAE,uBAAuB,EAAE,yBAAyB,EAAE,uBAAuB;IAC/F,uBAAuB,EAAE,yBAAyB,EAAE,wBAAwB,EAAE,qBAAqB;IACnG,iBAAiB,EAAE,wBAAwB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,kBAAkB;EAC5G;AACF;AACA;EACE,iBAAiB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,wBAAwB,EAAE,sBAAsB;EACpH,kBAAkB,EAAE,wBAAwB,EAAE,uBAAuB,EAAE,yBAAyB;EAChG,iBAAiB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,wBAAwB;EAC5F,kBAAkB,EAAE,uBAAuB,EAAE,yBAAyB,EAAE,uBAAuB;EAC/F,uBAAuB,EAAE,yBAAyB,EAAE,wBAAwB,EAAE,qBAAqB;EACnG,iBAAiB,EAAE,wBAAwB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,kBAAkB;AAC5G;AACA;EACE,iBAAiB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,wBAAwB;EAC5F,kBAAkB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,uBAAuB;EACnI,uBAAuB,EAAE,yBAAyB,EAAE,wBAAwB,EAAE,qBAAqB;EACnG,iBAAiB,EAAE,wBAAwB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,kBAAkB;AAC5G;AACA;EACE,iBAAiB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,wBAAwB;EAC5F,kBAAkB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,uBAAuB;EACnI,uBAAuB,EAAE,yBAAyB,EAAE,wBAAwB,EAAE,qBAAqB;EACnG,iBAAiB,EAAE,wBAAwB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,kBAAkB;AAC5G;AACA;EACE,iBAAiB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,wBAAwB;EAC5F,kBAAkB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,uBAAuB;EACnI,uBAAuB,EAAE,yBAAyB,EAAE,wBAAwB,EAAE,qBAAqB;EACnG,iBAAiB,EAAE,wBAAwB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,kBAAkB;AAC5G;;AAEA;EACE,eAAe;EACf,qGAAqG;;EAErG,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;;EAEpB,wCAAwC;EACxC,6CAA6C;EAC7C,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB;;;;qFAImF;EACnF,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gFAAgF;EAChF,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,sEAAsE;AACtE;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc,EAAE,oCAAoC;EACpD,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc,EAAE,gEAAgE;EAChF,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,cAAc;EACd,WAAW;EACX,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,kGAAkG;AAClG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,OAAO;EACP,aAAa,EAAE,uCAAuC;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;EACrD,yDAAyD;EACzD,yDAAyD;EACzD,gDAAgD;EAChD,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,gBAAgB;EAChB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,gGAAgG;AAChG;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kCAAkC;EAClC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,+GAA+G;EAC/G,cAAc;EACd,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kBAAkB;AAClB;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,qEAAqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB;;;;6DAI2D;EAC3D,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,2BAA2B;EAC3B,gBAAgB;EAChB,QAAQ;EACR,oBAAoB;AACtB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,6FAA6F;AAC7F;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wFAAwF;AACxF;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,wFAAwF;AACxF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iDAAiD;EACjD,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;EACE,oBAAoB;AACtB;AACA,6CAA6C,oBAAoB,EAAE;;AAEnE,8FAA8F;AAC9F;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uCAAuC;EACvC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,+DAA+D;EAC/D,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sFAAsF;AACtF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,SAAS;EACT,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,gGAAgG;AAChG;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,kGAAkG;AAClG;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uCAAuC;EACvC,+BAA+B;EAC/B,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8EAA8E;;AAE9E;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,yEAAyE;AACzE;;EAEE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,kCAAkC;AACpC;;AAEA;;+CAE+C;AAC/C;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,kCAAkC,EAAE;EAC1C,MAAM,uBAAuB,EAAE;EAC/B,MAAM,mCAAmC,EAAE;AAC7C;;AAEA,iGAAiG;AACjG;EACE,kCAAkC;AACpC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,OAAO;AACT;;AAEA;;EAEE,sCAAsC;EACtC,0BAA0B;EAC1B,4BAA4B;EAC5B,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;;;yEAKyE;AACzE;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA,4CAA4C;AAC5C;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,uCAAuC;EACvC,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sFAAsF;AACtF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;;EAEE,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,sCAAsC;EACtC,4BAA4B;EAC5B,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mFAAmF;EACnF,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;EACjC,sCAAsC;EACtC,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;uEACuE;AACvE;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,mFAAmF;AACnF;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,8BAA8B;AAChC;AACA,4BAA4B,gBAAgB,EAAE,kBAAkB,EAAE;AAClE,2BAA2B,iBAAiB,EAAE,4BAA4B,EAAE,mBAAmB,EAAE;;AAEjG,4FAA4F;AAC5F;EACE,mDAAmD;EACnD,oBAAoB;AACtB;AACA;EACE,mDAAmD;EACnD,oBAAoB;AACtB;AACA;EACE,KAAK,eAAe,EAAE,UAAU,EAAE;EAClC,MAAM,2BAA2B,EAAE,UAAU,EAAE;EAC/C,OAAO,gCAAgC,EAAE,UAAU,EAAE;AACvD;AACA;EACE,KAAK,eAAe,EAAE,UAAU,EAAE;EAClC,MAAM,4BAA4B,EAAE,UAAU,EAAE;EAChD,OAAO,kCAAkC,EAAE,UAAU,EAAE;AACzD;AACA;EACE,KAAK,UAAU,EAAE;AACnB;AACA;EACE;;IAEE,8CAA8C;EAChD;AACF;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;EAGE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;;EAGE,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;oFAEoF;AACpF;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;;8EAG8E;AAC9E;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;EAC5C,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,8FAA8F;AAC9F;EACE,eAAe;EACf,gDAAgD;EAChD,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;8DAC8D;AAC9D;EACE;IACE,gFAAgF;IAChF,UAAU;IACV,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;6CAG6C;AAC7C;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;mFAEmF;AACnF;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;8EAC8E;AAC9E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kFAAkF;EAClF;;kBAEgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gFAAgF;EAChF,mBAAmB;EACnB,0CAA0C;EAC1C,sFAAsF;EACtF,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,kFAAkF;EAClF,mBAAmB;EACnB,kFAAkF;EAClF,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C;sEACoE;EACpE,+CAA+C;AACjD;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,WAAW,iCAAiC,EAAE;EAC9C,MAAM,uCAAuC,EAAE;AACjD;;AAEA;EACE;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,0BAA0B;EAC1B,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;4EAC4E;AAC5E;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;;;;+EAM+E;AAC/E;EACE,qEAAqE;EACrE,kBAAkB;AACpB;AACA,wBAAwB,gBAAgB,EAAE;AAC1C,wBAAwB,gBAAgB,EAAE;AAC1C,wBAAwB,gBAAgB,EAAE;AAC1C,yBAAyB,iBAAiB,EAAE,gBAAgB,EAAE;;AAE9D,2DAA2D;AAC3D;EACE;;IAEE,6BAA6B;EAC/B;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,iBAAiB;IACjB,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,8BAA8B,EAAE,uDAAuD;IACvF,oBAAoB;EACtB;EACA;;IAEE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,0BAA0B;EAC5B;EACA;;;;IAIE,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,OAAO;EACT;EACA;IACE,OAAO;IACP,gBAAgB;EAClB;EACA,6CAA6C;EAC7C;;;IAGE,gBAAgB;EAClB;EACA,2EAA2E;EAC3E;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6FAA6F;AAC7F;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oEAAoE;EACpE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,oEAAoE;EACpE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE;;IAEE,mEAAmE;IACnE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;IAGE,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;+EAC6E;EAC7E;IACE,SAAS;EACX;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;+FAC+F;AAC/F;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;mEAEmE;AACnE;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;sFACsF;AACtF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,sBAAsB,kBAAkB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC1G,4BAA4B,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE,aAAa,EAAE,oCAAoC,EAAE,+BAA+B,EAAE,8BAA8B,EAAE;AAC3L,sBAAsB,aAAa,EAAE,oCAAoC,EAAE,mBAAmB,EAAE,QAAQ,EAAE,4BAA4B,EAAE,iBAAiB,EAAE;AAC3J,wBAAwB,cAAc,EAAE,YAAY,EAAE,gBAAgB,EAAE,+BAA+B,EAAE,8BAA8B,EAAE;AACzI,gCAAgC,WAAW,EAAE,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE;AACnH,wBAAwB,mDAAmD,EAAE;AAC7E,wBAAwB,iBAAiB,EAAE;AAC3C,qBAAqB,aAAa,EAAE,+DAA+D,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,eAAe,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,4BAA4B,EAAE;AACzQ,4BAA4B,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5F,uBAAuB,WAAW,EAAE,gBAAgB,EAAE,+BAA+B,EAAE,8BAA8B,EAAE;AACvH,yBAAyB,cAAc,EAAE,YAAY,EAAE,yBAAyB,EAAE;AAClF,4BAA4B,mBAAmB,EAAE;AACjD,wBAAwB,2BAA2B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE3F;EACE,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;4FAC4F;AAC5F;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,gFAAgF;EAChF,aAAa;EACb,aAAa,EAAE,sBAAsB;EACrC,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;0FAC0F;AAC1F;;;EAGE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,0BAA0B;EAC1B,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,0BAA0B;EAC1B,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;iEAEiE;AACjE;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;iEAEiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;;;gEAGgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,yDAAyD;EACzD,mCAAmC;EACnC,+DAA+D;EAC/D,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gDAAgD;IAChD,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,yDAAyD;EAC3D;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;EACd;AACF;;AAEA;8EAC8E;AAC9E;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;;EAEE,4BAA4B;AAC9B;;AAEA,sFAAsF;AACtF,kBAAkB,uBAAuB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC7F,mBAAmB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC7D;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA,4BAA4B,8BAA8B,EAAE,2BAA2B,EAAE,gBAAgB,EAAE;AAC3G,mBAAmB,2BAA2B,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACpF,uBAAuB,mBAAmB,EAAE;AAC5C,qBAAqB,gBAAgB,EAAE,2BAA2B,EAAE,kBAAkB,EAAE;AACxF,qBAAqB,SAAS,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAChF,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACzG;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;AACA,yBAAyB,gBAAgB,EAAE;AAC3C,oBAAoB,gBAAgB,EAAE,oBAAoB,EAAE;AAC5D,mBAAmB,2BAA2B,EAAE,kBAAkB,EAAE,aAAa,EAAE;AACnF,4BAA4B,gBAAgB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAEvG,kEAAkE;AAClE,sBAAsB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AACnF,iCAAiC,kBAAkB,EAAE;AACrD,sDAAsD,SAAS,EAAE,eAAe,EAAE;AAClF,wCAAwC,8BAA8B,EAAE,2BAA2B,EAAE;AACrG,uBAAuB,oBAAoB,EAAE,gBAAgB,EAAE;AAC/D,8BAA8B,gCAAgC,EAAE,mBAAmB,EAAE;AACrF,kBAAkB,gBAAgB,EAAE,cAAc,EAAE;AACpD,yFAAyF;AACzF;gCACgC,gCAAgC,EAAE,mBAAmB,EAAE;AACvF,kBAAkB,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE;AACpE,8EAA8E;AAC9E,mBAAmB,oBAAoB,EAAE,gBAAgB,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAC7F,cAAc,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,8BAA8B,EAAE,sCAAsC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACjO,sBAAsB,aAAa,EAAE;AACrC,oBAAoB,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE,2BAA2B,EAAE;AAClH,0BAA0B,aAAa,EAAE;AACzC,qBAAqB,aAAa,EAAE,eAAe,EAAE,aAAa,EAAE,eAAe,EAAE;AACrF,iCAAiC,cAAc,EAAE,iBAAiB,EAAE;AACpE,cAAc,gBAAgB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,eAAe,EAAE,0BAA0B,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;AAC3K,4BAA4B,gCAAgC,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACvG,oBAAoB,qBAAqB,EAAE,eAAe,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC1G,oBAAoB,oBAAoB,EAAE,eAAe,EAAE,QAAQ,EAAE,yBAAyB,EAAE;AAChG,gCAAgC,mBAAmB,EAAE,uBAAuB,EAAE;AAC9E;;6BAE6B,oBAAoB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC/G,wCAAwC,eAAe,EAAE;AACzD;oDACoD,wBAAwB,EAAE;AAC9E,qBAAqB,aAAa,EAAE,gBAAgB,EAAE,YAAY,EAAE;AACpE,wBAAwB,uBAAuB,EAAE;AACjD,wCAAwC,SAAS,EAAE,cAAc,EAAE;AACnE,iCAAiC,oBAAoB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACnI,4BAA4B,gBAAgB,EAAE,iBAAiB,EAAE;AACjE,4BAA4B,eAAe,EAAE;AAC7C;mDACmD,wBAAwB,EAAE;AAC7E;oBACoB,2BAA2B,EAAE,iBAAiB,EAAE;AACpE,kBAAkB,gBAAgB,EAAE,2BAA2B,EAAE,mBAAmB,EAAE;AACtF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;kCACkC,WAAW,EAAE,OAAO,EAAE,0CAA0C,EAAE;;AAEpG,8FAA8F;AAC9F;EACE,kBAAkB,EAAE,QAAQ,EAAE,WAAW,EAAE,YAAY,EAAE,oBAAoB;AAC/E;AACA,gCAAgC,eAAe,EAAE,iBAAiB,EAAE,YAAY,EAAE;AAClF,yCAAyC,eAAe,EAAE,eAAe,EAAE,UAAU,EAAE;AACvF,8EAA8E,YAAY,EAAE;AAC5F,+BAA+B,mBAAmB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,eAAe,EAAE;AAC/G,6CAA6C,iBAAiB,EAAE,aAAa,EAAE;AAC/E;EACE,kBAAkB,EAAE,gCAAgC,EAAE,oBAAoB,EAAE,eAAe;EAC3F,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB;EAClF,iCAAiC,EAAE,mCAAmC,EAAE,eAAe,EAAE,mBAAmB;AAC9G;AACA,yCAAyC,aAAa,EAAE;AACxD;EACE,kBAAkB,EAAE,YAAY,EAAE,SAAS,EAAE,2BAA2B,EAAE,4BAA4B;EACtG,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE,iBAAiB;EACrF,iCAAiC,EAAE,mCAAmC,EAAE,4BAA4B;EACpG,oBAAoB,EAAE,eAAe;AACvC;AACA,yCAAyC,aAAa,EAAE;AACxD,wCAAwC,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC5F;EACE,yCAAyC,EAAE,mBAAmB;AAChE;AACA,+BAA+B,eAAe,EAAE;AAChD;EACE,+BAA+B,gBAAgB,EAAE;EACjD,iCAAiC,gBAAgB,EAAE,eAAe,EAAE;EACpE,+BAA+B,gBAAgB,EAAE;AACnD","sourcesContent":["/* ============================================================\n   Design Tokens — single source of truth for color/shape/depth\n   Scheme system: \"Golden Hour\" (default) + 3 alternates, each with\n   a light and dark variant, selected via [data-color-scheme] on\n   <html> (see ui-settings-storage.ts's get/setColorSchemePreference\n   and applyStoredColorScheme, called at boot before first paint).\n   Falls through to Golden Hour when no attribute is set at all, so\n   any markup that predates the scheme system keeps working.\n   ============================================================ */\n:root,\n[data-color-scheme=\"goldenHour\"] {\n  /* Accent (marigold) — interactive/brand */\n  --accent: #cc6b1c;\n  --accent-hover: #b25914;\n  --accent-soft: #fbeee0;\n  --accent-border: #e8c9a4;\n  --accent-text: #8a4812;\n  --bubble-sent: #fbeee0;\n\n  /* Success (sage-forest) — matches, online, live status */\n  --success: #4d7a52;\n  --success-hover: #3f6543;\n  --success-soft: #e9f1e7;\n  --success-border: #bcd4bd;\n  --success-text: #2f4c32;\n\n  /* Danger (brick) */\n  --danger: #b23a2e;\n  --danger-hover: #952f25;\n  --danger-soft: #f7e7e3;\n  --danger-border: #e6bcb1;\n\n  /* Warning (dusty gold — distinct hue from accent) */\n  --warning: #a9791e;\n  --warning-soft: #f5eedd;\n  --warning-border: #e4cf9c;\n  --warning-text: #6b4d10;\n\n  /* Neutrals (warm ink, not slate) */\n  --text-primary: #211f1a;\n  --text-secondary: #6b6354;\n  --text-tertiary: #857c6a;\n  --text-muted: #9c9587;\n  --border: #e6e2d7;\n  --border-strong: #d8d2c2;\n  --bg-subtle: #f5f4f0;\n  --bg-muted: #ede9e0;\n  --surface: #ffffff;\n\n  /* Gradients */\n  --gradient-accent: linear-gradient(135deg, #e08a3c 0%, #cc6b1c 100%);\n  --gradient-success: linear-gradient(135deg, #6b9970 0%, #4d7a52 100%);\n  --gradient-success-hover: linear-gradient(135deg, #4d7a52 0%, #3f6543 100%);\n}\n\n[data-color-scheme=\"tropicalForest\"] {\n  --accent: #2f7a4f;\n  --accent-hover: #256440;\n  --accent-soft: #e1f0e5;\n  --accent-border: #b9d9c1;\n  --accent-text: #1c4c31;\n  --bubble-sent: #e1f0e5;\n  --success: #6b8e3d;\n  --success-hover: #587532;\n  --success-soft: #eef3e0;\n  --success-border: #cfdcae;\n  --success-text: #445a26;\n  --danger: #c1452e;\n  --danger-hover: #a13a26;\n  --danger-soft: #f8e6e0;\n  --danger-border: #e8bfae;\n  --warning: #c98a24;\n  --warning-soft: #f6ecd8;\n  --warning-border: #e6cd97;\n  --warning-text: #7c5615;\n  --text-primary: #1e2a1f;\n  --text-secondary: #54604f;\n  --text-tertiary: #6f7c68;\n  --text-muted: #8b9484;\n  --border: #dbe4d2;\n  --border-strong: #c7d3ba;\n  --bg-subtle: #eff3ea;\n  --bg-muted: #e2ead9;\n  --surface: #ffffff;\n  --gradient-accent: linear-gradient(135deg, #479166 0%, #2f7a4f 100%);\n  --gradient-success: linear-gradient(135deg, #85a95a 0%, #6b8e3d 100%);\n  --gradient-success-hover: linear-gradient(135deg, #6b8e3d 0%, #587532 100%);\n}\n\n[data-color-scheme=\"snowMountain\"] {\n  --accent: #1f8fc4;\n  --accent-hover: #1a76a3;\n  --accent-soft: #e2f2fa;\n  --accent-border: #b7dced;\n  --accent-text: #135a7c;\n  --bubble-sent: #e2f2fa;\n  --success: #3e7a4f;\n  --success-hover: #336440;\n  --success-soft: #e6f1e8;\n  --success-border: #bcd8c2;\n  --success-text: #274d31;\n  --danger: #c23b2e;\n  --danger-hover: #a23124;\n  --danger-soft: #f8e5e2;\n  --danger-border: #e8bcb0;\n  --warning: #d69a2a;\n  --warning-soft: #f7edd9;\n  --warning-border: #ecd49b;\n  --warning-text: #815e13;\n  --text-primary: #1b2733;\n  --text-secondary: #556575;\n  --text-tertiary: #6d7c8b;\n  --text-muted: #8b98a5;\n  --border: #dbe4ea;\n  --border-strong: #c5d2db;\n  --bg-subtle: #f4f7fa;\n  --bg-muted: #e6edf2;\n  --surface: #ffffff;\n  --gradient-accent: linear-gradient(135deg, #3fabdb 0%, #1f8fc4 100%);\n  --gradient-success: linear-gradient(135deg, #619871 0%, #3e7a4f 100%);\n  --gradient-success-hover: linear-gradient(135deg, #3e7a4f 0%, #336440 100%);\n}\n\n[data-color-scheme=\"beachSunset\"] {\n  --accent: #e8637a;\n  --accent-hover: #d14964;\n  --accent-soft: #fce7ec;\n  --accent-border: #f0bfca;\n  --accent-text: #9c3149;\n  --bubble-sent: #fce7ec;\n  --success: #2e8a83;\n  --success-hover: #25716b;\n  --success-soft: #e2f1ef;\n  --success-border: #b2d9d5;\n  --success-text: #1a534e;\n  --danger: #c4453f;\n  --danger-hover: #a53933;\n  --danger-soft: #f8e5e3;\n  --danger-border: #e9bcb8;\n  --warning: #e0a431;\n  --warning-soft: #faeed6;\n  --warning-border: #efd696;\n  --warning-text: #7f5714;\n  --text-primary: #2b1e22;\n  --text-secondary: #6b545a;\n  --text-tertiary: #856b71;\n  --text-muted: #a0888d;\n  --border: #eddac4;\n  --border-strong: #e0c6a8;\n  --bg-subtle: #fbf1e4;\n  --bg-muted: #f3e2ce;\n  --surface: #ffffff;\n  --gradient-accent: linear-gradient(135deg, #ee839a 0%, #e8637a 100%);\n  --gradient-success: linear-gradient(135deg, #4fa39c 0%, #2e8a83 100%);\n  --gradient-success-hover: linear-gradient(135deg, #2e8a83 0%, #25716b 100%);\n}\n\n/* Dark variants — same 4 schemes, applied when the OS/site theme is dark. Mirrors the\n   pattern the redesign preview artifact used: same token names, deeper/brighter values. */\n@media (prefers-color-scheme: dark) {\n  :root:not([data-theme=\"light\"]),\n  [data-color-scheme=\"goldenHour\"]:not([data-theme=\"light\"]) {\n    --accent: #f0a93e; --accent-hover: #f5bc63; --accent-soft: #3a2a14; --accent-border: #5c451f; --accent-text: #f5bc63;\n    --success: #7fb386; --success-hover: #97c29c; --success-soft: #1c2b1e; --success-border: #35492f;\n    --danger: #e2796a; --danger-hover: #e89686; --danger-soft: #3a211c; --danger-border: #5a352c;\n    --warning: #d3a94a; --warning-soft: #362b14; --warning-border: #56461f; --warning-text: #e0bc74;\n    --text-primary: #f2eee6; --text-secondary: #c4bbaa; --text-tertiary: #a89d89; --text-muted: #877d6c;\n    --border: #332c22; --border-strong: #443b2c; --bg-subtle: #17140f; --bg-muted: #1e1a14; --surface: #1e1a14;\n  }\n}\n[data-theme=\"dark\"][data-color-scheme=\"goldenHour\"], :root[data-theme=\"dark\"]:not([data-color-scheme]) {\n  --accent: #f0a93e; --accent-hover: #f5bc63; --accent-soft: #3a2a14; --accent-border: #5c451f; --accent-text: #f5bc63;\n  --success: #7fb386; --success-hover: #97c29c; --success-soft: #1c2b1e; --success-border: #35492f;\n  --danger: #e2796a; --danger-hover: #e89686; --danger-soft: #3a211c; --danger-border: #5a352c;\n  --warning: #d3a94a; --warning-soft: #362b14; --warning-border: #56461f; --warning-text: #e0bc74;\n  --text-primary: #f2eee6; --text-secondary: #c4bbaa; --text-tertiary: #a89d89; --text-muted: #877d6c;\n  --border: #332c22; --border-strong: #443b2c; --bg-subtle: #17140f; --bg-muted: #1e1a14; --surface: #1e1a14;\n}\n[data-theme=\"dark\"][data-color-scheme=\"tropicalForest\"] {\n  --accent: #4fcb82; --accent-hover: #6fd89a; --accent-soft: #173322; --accent-border: #2c5138;\n  --success: #a3c46a; --success-soft: #212f16; --danger: #e37b62; --danger-soft: #37201a; --warning: #e0b45c; --warning-soft: #332711;\n  --text-primary: #e7f0e4; --text-secondary: #a9bba2; --text-tertiary: #8a9c83; --text-muted: #6d8069;\n  --border: #26362b; --border-strong: #334839; --bg-subtle: #0e1912; --bg-muted: #152119; --surface: #152119;\n}\n[data-theme=\"dark\"][data-color-scheme=\"snowMountain\"] {\n  --accent: #4dc4ec; --accent-hover: #71d1f0; --accent-soft: #123544; --accent-border: #234f61;\n  --success: #79b98c; --success-soft: #17281c; --danger: #e08072; --danger-soft: #372019; --warning: #e0b558; --warning-soft: #332811;\n  --text-primary: #eaf2f7; --text-secondary: #aebfc9; --text-tertiary: #8ea0ac; --text-muted: #6f818e;\n  --border: #233442; --border-strong: #2f4353; --bg-subtle: #0d1720; --bg-muted: #132029; --surface: #132029;\n}\n[data-theme=\"dark\"][data-color-scheme=\"beachSunset\"] {\n  --accent: #f58aa0; --accent-hover: #f9a4b5; --accent-soft: #3a1f28; --accent-border: #573240;\n  --success: #5cb3ab; --success-soft: #173330; --danger: #e37b73; --danger-soft: #3a221e; --warning: #e6bc63; --warning-soft: #332811;\n  --text-primary: #f5e8e0; --text-secondary: #c9aeb5; --text-tertiary: #ab8f95; --text-muted: #8a707a;\n  --border: #3a2c40; --border-strong: #4a3a50; --bg-subtle: #1c1420; --bg-muted: #241a29; --surface: #241a29;\n}\n\n:root {\n  /* Typography */\n  --font-display: ui-rounded, \"SF Pro Rounded\", \"Nunito\", -apple-system, \"Segoe UI\", Roboto, sans-serif;\n\n  /* Shape */\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 14px;\n  --radius-xl: 18px;\n  --radius-full: 999px;\n\n  /* Depth (warm-tinted, not cold slate) */\n  --shadow-sm: 0 1px 2px rgba(33, 26, 15, 0.06);\n  --shadow-md: 0 4px 12px rgba(33, 26, 15, 0.08);\n  --shadow-lg: 0 12px 32px rgba(33, 26, 15, 0.16);\n}\n\n/* Reset and Base Styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml,\nbody {\n  height: 100%;\n  overflow: hidden;\n  /* Chrome/WebView's mobile \"font boosting\" inflates text independent of layout (icons,\n     badges, card widths stay fixed while text grows and wraps) — breaks fixed-width UI like\n     the chatroom list under a larger-than-default OS/browser font-size setting. Opt out so\n     our own font sizes always render as specified; the Android WebView also pins\n     textZoom=100 for the native app (MainActivity.kt), this covers browser access. */\n  text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  line-height: 1.6;\n  color: var(--text-primary);\n  background-color: var(--bg-muted);\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Visible keyboard focus everywhere, no default ring on mouse click */\n:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 2px;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: none;\n}\n\n/* Loading Screen */\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  height: 100dvh; /* mobile: exclude browser URL bar */\n  background: var(--gradient-accent);\n  color: white;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-left: 4px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Main App Layout */\n.app-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  height: 100dvh; /* mobile: exclude browser URL bar so bottom nav stays visible */\n  overflow: hidden;\n  background: var(--bg-muted);\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Single AppBar (top header) — redesign §1 */\n.top-header {\n  background: var(--surface);\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 15px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n  z-index: 10;\n  gap: 8px;\n  position: relative;\n}\n\n.app-bar-left {\n  display: flex;\n  align-items: center;\n  min-width: 36px;\n  flex-shrink: 0;\n}\n\n.app-bar-back-btn {\n  width: 36px;\n  height: 36px;\n  background: none;\n  border: none;\n  font-size: 1.4em;\n  cursor: pointer;\n  color: var(--text-primary);\n  border-radius: var(--radius-sm);\n  align-items: center;\n  justify-content: center;\n}\n\n.app-bar-back-btn:hover {\n  background: var(--bg-muted);\n}\n\n.app-bar-center {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  overflow: hidden;\n}\n\n.header-title {\n  font-family: var(--font-display);\n  font-size: 1.1em;\n  font-weight: 700;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.header-title:empty {\n  display: none;\n}\n\n.header-actions {\n  display: flex;\n  gap: 2px;\n  min-width: 44px;\n  justify-content: flex-end;\n  align-items: center;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.app-bar-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.app-bar-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border-radius: var(--radius-sm);\n}\n\n.app-bar-action-btn:disabled,\n#dm-inbox-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n/* Icon-only inline; the label shows when the button lives in the ⋯ panel */\n.app-bar-actions .app-bar-btn-label {\n  display: none;\n}\n\n.app-bar-overflow-menu {\n  display: none;\n  align-items: center;\n  position: relative;\n}\n\n.app-bar-overflow-btn {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-sm);\n}\n\n.app-bar-overflow-panel {\n  display: none;\n  position: absolute;\n  top: 100%;\n  right: 0;\n  z-index: 999;\n  background: var(--surface);\n  border-radius: var(--radius-md);\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);\n  min-width: 190px;\n  overflow: hidden;\n  flex-direction: column;\n}\n\n.app-bar-overflow-panel.open {\n  display: flex;\n}\n\n.app-bar-overflow-panel .app-bar-action-btn {\n  width: 100%;\n  justify-content: flex-start;\n  padding: 10px 14px;\n  font-size: 1em;\n  border-radius: 0;\n}\n\n.app-bar-overflow-panel .app-bar-btn-label {\n  display: inline;\n  font-size: 0.9em;\n}\n\n.appbar-view-hidden {\n  display: none !important;\n}\n\n/* Mobile \"Filters ▾\" disclosure — redesign §6 */\n.filter-bar {\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.filter-bar-toggle {\n  display: none;\n  background: var(--bg-muted);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  padding: 6px 12px;\n  cursor: pointer;\n  font-size: 0.9em;\n  align-items: center;\n  gap: 4px;\n}\n\n.filter-bar-content {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  align-items: center;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n@media (max-width: 767px) {\n  .filter-bar-toggle {\n    display: inline-flex;\n  }\n\n  .filter-bar-content {\n    display: none;\n  }\n\n  .filter-bar-content.open {\n    display: flex;\n    flex-basis: 100%;\n  }\n}\n\n.header-btn {\n  background: none;\n  border: none;\n  font-size: 1.3em;\n  cursor: pointer;\n  padding: 5px;\n  color: var(--text-primary);\n  transition: opacity 0.2s;\n}\n\n.header-btn:hover {\n  opacity: 0.7;\n}\n\n.header-user-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.header-user-info .user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--gradient-accent);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 0.9em;\n}\n\n.header-status {\n  flex: 1;\n  min-width: 0;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: var(--text-primary);\n  font-size: 0.92em;\n  font-weight: 600;\n  text-align: center;\n}\n\n.header-status-text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.header-status-text[hidden] {\n  display: none;\n}\n\n/* The selected folder/detail heading already names the scope; the AppBar shows changing counts. */\n#status-bar-text {\n  display: inline-flex;\n  align-items: center;\n  line-height: 1.15;\n}\n\n#status-bar-text .status-bar-meta {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#status-bar-text .status-bar-meta {\n  font-weight: 500;\n  color: var(--text-secondary, #4b5563);\n}\n\n/* View Container */\n.view-container {\n  flex: 1;\n  min-height: 0; /* Prevent flex item from overflowing */\n  position: relative;\n  overflow: hidden;\n  background: var(--bg-muted);\n}\n\n.view-panel {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: none;\n  flex-direction: column;\n  background: var(--bg-muted);\n  overflow: hidden;\n}\n\n.view-panel.active {\n  display: flex;\n}\n\n.view-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  background: var(--surface);\n}\n\n/* Bottom Navigation */\n.bottom-nav {\n  height: calc(70px + env(safe-area-inset-bottom, 0px));\n  min-height: calc(70px + env(safe-area-inset-bottom, 0px));\n  max-height: calc(70px + env(safe-area-inset-bottom, 0px));\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n  background: var(--surface);\n  border-top: 1px solid var(--border);\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-shrink: 0;\n  flex-grow: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.nav-btn {\n  flex: 1;\n  height: 100%;\n  max-height: 70px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  gap: 3px;\n  transition: all 0.2s;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.nav-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  transition: color 0.2s, transform 0.2s;\n}\n\n.nav-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.nav-label {\n  font-family: var(--font-display);\n  font-size: 0.75em;\n  color: var(--text-muted);\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.nav-btn.active .nav-icon {\n  color: var(--accent);\n  transform: translateY(-1px);\n}\n\n.nav-btn.active .nav-label {\n  color: var(--accent);\n  font-weight: 600;\n}\n\n.nav-btn:hover {\n  background: rgba(15, 23, 42, 0.04);\n}\n\n/* Remove old sidebar styles */\n.sidebar {\n  display: none;\n}\n\n.sidebar-actions {\n  display: none;\n}\n\n.main-content {\n  display: none;\n}\n\n/* Header */\n.header {\n  background: var(--surface);\n  padding: 15px 20px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: between;\n  align-items: center;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n}\n\n.profile-avatar-image {\n  width: 100%;\n  height: 100%;\n  display: block;\n  border-radius: inherit;\n  object-fit: cover;\n}\n\n.chatbot-overlay {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 16px;\n  height: 16px;\n  background: var(--success);\n  border-radius: 50%;\n  border: 2px solid white;\n}\n\n/* Chatroom Info */\n.chatroom-info {\n  padding: 12px 15px;\n  background: var(--bg-muted);\n  border-bottom: 1px solid var(--border-strong);\n  flex-shrink: 0;\n}\n\n.chatroom-title {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 0.9em;\n  margin-bottom: 3px;\n  color: var(--text-primary);\n}\n\n.chatroom-status {\n  font-size: 0.75em;\n  color: var(--text-muted);\n}\n\n/* Conversation List */\n.conversation-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n  background: var(--surface);\n}\n\n.conversation-item {\n  background: var(--surface);\n  border-radius: var(--radius-md);\n  padding: 15px;\n  margin-bottom: 10px;\n  border: 1px solid var(--border);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.conversation-item:hover {\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);\n  transform: translateY(-1px);\n}\n\n.conversation-item.active {\n  border-color: var(--accent);\n  background: var(--accent-soft);\n}\n\n.conversation-preview {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.conversation-details h4 {\n  margin-bottom: 5px;\n  color: var(--text-primary);\n}\n\n.conversation-details p {\n  color: var(--text-tertiary);\n  font-size: 0.9em;\n}\n\n.conversation-meta {\n  text-align: right;\n  font-size: 0.8em;\n  color: var(--text-muted);\n}\n\n.unread-badge {\n  background: var(--accent);\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8em;\n  margin-top: 5px;\n}\n\n/* Welcome Banner */\n.location-room-suggestion {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  border: 1px solid var(--accent-border);\n  border-radius: var(--radius-md);\n  background: var(--accent-soft);\n  color: var(--accent-text);\n}\n\n.location-room-suggestion button {\n  border: 0;\n  border-radius: var(--radius-sm);\n  padding: 5px 9px;\n  cursor: pointer;\n  background: var(--accent);\n  color: #fff;\n}\n\n.location-room-suggestion button[data-action=\"dismiss\"] {\n  margin-left: auto;\n  background: transparent;\n  color: var(--accent-text);\n  font-size: 18px;\n  line-height: 1;\n}\n\n.system-announcements {\n  display: grid;\n  gap: 8px;\n  margin: 0 0 12px;\n}\n\n.system-announcement {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid var(--warning-border);\n  border-radius: var(--radius-md);\n  background: var(--warning-soft);\n  color: var(--warning-text);\n}\n\n.system-announcement button {\n  margin-left: auto;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n/* App-download banner: shown to plain browser tabs (never inside the packaged Electron shell) */\n.app-download-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  background: var(--gradient-accent);\n  color: #fff;\n  font-size: 0.85em;\n}\n\n.app-download-banner-text {\n  font-weight: 600;\n}\n\n.app-download-banner-link {\n  color: #fff;\n  font-weight: 700;\n  text-decoration: underline;\n  white-space: nowrap;\n}\n\n.app-download-banner-see-options {\n  border: 0;\n  background: transparent;\n  font: inherit;\n  cursor: pointer;\n  padding: 0;\n}\n\n.app-download-banner-dismiss {\n  margin-left: auto;\n  border: 0;\n  background: transparent;\n  color: #fff;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0.85;\n}\n\n/* Status Bar - Permanent chatroom status display */\n.status-bar {\n  background: var(--gradient-accent);\n  color: white;\n  padding: 10px 16px;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  /* Stay visible: #chatrooms-view is a flex column; without this the bar can shrink when the member list grows */\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n#chatrooms-view > .status-bar {\n  min-height: min-content;\n}\n\n.status-bar-content {\n  font-size: 0.9em;\n  font-weight: 500;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.status-bar-content::before {\n  content: '👤';\n  font-size: 1.1em;\n}\n\n.status-bar-actions {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Chatroom List */\n#chatroom-list-container {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  background: var(--surface);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n#chatroom-list {\n  padding: 8px;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.chatroom-view-mode-btn[aria-pressed='true'] {\n  background: var(--accent-soft);\n  color: var(--accent-text);\n  box-shadow: inset 0 0 0 1px var(--accent-border);\n}\n\n.chatroom-view-mode-btn:focus-visible {\n  outline: 3px solid color-mix(in srgb, var(--accent) 35%, transparent);\n  outline-offset: 1px;\n}\n\n.chatroom-map-status {\n  position: absolute;\n  z-index: 2;\n  top: 8px;\n  left: 8px;\n  max-width: calc(100% - 72px);\n  padding: 5px 8px;\n  border-radius: var(--radius-sm);\n  background: rgb(255 255 255 / 90%);\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  line-height: 1.25;\n  box-shadow: var(--shadow-sm);\n  pointer-events: none;\n}\n\n.chatroom-map {\n  flex: 1 1 auto;\n  min-height: 320px;\n  width: 100%;\n  background: var(--bg-subtle);\n  color: var(--text-muted);\n}\n\n.chatroom-map.loading,\n.chatroom-map.load-failed {\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  text-align: center;\n}\n\n.chatroom-map-marker {\n  display: grid;\n  place-items: center;\n  position: relative;\n  width: 34px !important;\n  height: 34px !important;\n  margin: 0 !important;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  /* Fixed (not theme-token) colors: --accent and --success can both land on\n     similar greens in some color schemes (e.g. tropicalForest), which made\n     \"your room\" vs \"other rooms\" unreadable on the map. Matches the\n     underlying MapLibre circle layer's hardcoded #2563eb/#16803c pair\n     (chatroom-map-view.ts) so both rendering layers agree. */\n  background: #2563eb;\n  color: #fff;\n  box-shadow: 0 2px 8px rgb(0 0 0 / 35%);\n  font-size: 0.75rem;\n  font-weight: 800;\n  cursor: pointer;\n  appearance: none;\n}\n\n.chatroom-map-marker.empty-place {\n  opacity: 0.55;\n}\n\n.chatroom-map-marker.current-room {\n  background: #16803c;\n  box-shadow: 0 0 0 4px rgb(22 128 60 / 30%), 0 2px 8px rgb(0 0 0 / 35%);\n}\n\n.chatroom-map-tooltip {\n  display: none;\n  position: absolute;\n  z-index: 2;\n  bottom: calc(100% + 9px);\n  left: 50%;\n  min-width: max-content;\n  max-width: 220px;\n  padding: 7px 9px;\n  border: 1px solid rgb(0 0 0 / 12%);\n  border-radius: 6px;\n  background: #fff;\n  color: #111827;\n  box-shadow: 0 3px 12px rgb(0 0 0 / 22%);\n  transform: translateX(-50%);\n  text-align: left;\n  gap: 2px;\n  pointer-events: none;\n}\n\n/* Room list header: Nearby headcount and the custom-room sort choice. */\n.room-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 10px 4px 2px;\n  font-size: 0.92em;\n}\n\n.room-list-header-sort-only {\n  justify-content: flex-end;\n}\n\n.room-list-total {\n  font-weight: 700;\n}\n\n.room-list-sort {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-secondary, #4b5563);\n}\n\n.room-list-sort select {\n  padding: 4px 8px;\n  border: 1px solid var(--border-strong, #d1d5db);\n  border-radius: 8px;\n  background: var(--surface, #fff);\n  color: inherit;\n}\n\n/* People on the map: ★ me (larger), green = my room (can exchange Talks), yellow = others. */\n.chatroom-map-user-dot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 14px;\n  height: 14px;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  box-shadow: 0 0 0 1px rgb(0 0 0 / 35%);\n  color: #111827;\n  font: 700 9px/1 system-ui, sans-serif;\n}\n\n.chatroom-map-user-dot[data-count]:not([data-count=\"1\"]) {\n  min-width: 32px;\n  width: auto;\n  height: 24px;\n  padding: 0 5px;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n/* Broadcast waves sit under markers and never intercept taps or map gestures. */\n.chatroom-map-broadcast-effects {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.chatroom-map-broadcast-label {\n  font: 600 12px/1.4 system-ui, sans-serif;\n  paint-order: stroke;\n  stroke: #fff;\n  stroke-width: 4px;\n  stroke-linejoin: round;\n}\n\n.chatroom-map-user-dot-matched {\n  width: auto;\n  min-width: 36px;\n  height: 26px;\n  padding: 0 5px;\n  border-radius: 13px;\n  font-size: 11px;\n  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #16a34a;\n}\n\n.chatroom-map-member-contact {\n  border: 0;\n  padding: 0;\n  background: none;\n  color: inherit;\n  font: inherit;\n  font-weight: 700;\n  text-align: start;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.chatroom-map-user-dot-room {\n  background: #16a34a;\n  color: #fff;\n}\n\n.chatroom-map-user-dot-other {\n  background: #facc15;\n}\n\n.chatroom-map-user-dot-self {\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 0;\n  background: none;\n  box-shadow: none;\n  color: #f59e0b;\n  font-size: 28px;\n  text-shadow: 0 0 2px #fff, 0 0 2px #fff, 0 1px 3px rgb(0 0 0 / 55%);\n}\n\n.chatroom-map-user-dot {\n  position: relative;\n}\n\n/* Keep marker positioning independent of the lazy-loaded MapLibre stylesheet's order. */\n.chatroom-map-user-dot.maplibregl-marker,\n.chatroom-map-marker.maplibregl-marker {\n  position: absolute;\n}\n\n.chatroom-map-user-dot-traveler {\n  position: absolute;\n  top: -9px;\n  right: -10px;\n  color: #1e293b;\n  font: 700 11px/1 system-ui, sans-serif;\n  text-shadow: 0 0 2px #fff, 0 0 2px #fff;\n}\n\n.chatroom-map-user-legend {\n  position: absolute;\n  left: 8px;\n  bottom: 30px;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 6px 8px;\n  border-radius: 8px;\n  background: var(--surface, #fff);\n  color: var(--text-primary, #111827);\n  box-shadow: 0 2px 8px rgb(0 0 0 / 20%);\n  font-size: 0.8em;\n  pointer-events: none;\n}\n\n.chatroom-map-user-legend[hidden] {\n  display: none;\n}\n\n.chatroom-map-user-legend > span {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.chatroom-map-user-legend-swatch.chatroom-map-user-dot-self {\n  width: 14px;\n  height: 14px;\n  font-size: 15px;\n}\n\n/* Tapped tile on the room map: its name and an Enter button, pinned at the tap point. */\n.chatroom-map-tile-card {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 240px;\n  margin-bottom: 6px;\n  padding: 6px 6px 6px 10px;\n  border: 1px solid rgb(0 0 0 / 12%);\n  border-radius: 8px;\n  background: var(--surface, #fff);\n  color: var(--text-primary, #111827);\n  box-shadow: 0 3px 12px rgb(0 0 0 / 22%);\n  font-size: 0.9em;\n}\n\n.chatroom-map-tile-card > strong {\n  overflow: hidden;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chatroom-map-member-card {\n  flex-direction: column;\n  align-items: stretch;\n  width: min(280px, 80vw);\n  max-width: none;\n  max-height: 50vh;\n  overflow-y: auto;\n  padding: 8px;\n  cursor: default;\n}\n\n.chatroom-map-member {\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 4px 10px;\n  align-items: start;\n}\n\n.chatroom-map-member + .chatroom-map-member {\n  padding-top: 8px;\n  border-top: 1px solid var(--border, rgb(0 0 0 / 10%));\n}\n\n.chatroom-map-member-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  border-radius: 50%;\n  background: #16803c;\n  color: #fff;\n  font-weight: 600;\n}\n\n.chatroom-map-member-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.chatroom-map-member-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.chatroom-map-member-info strong {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chatroom-map-member-status,\n.chatroom-map-member-details span {\n  color: var(--text-secondary, #4b5563);\n  font-size: 0.85em;\n  overflow-wrap: anywhere;\n}\n\n.chatroom-map-member-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 2px;\n}\n\n.chatroom-map-member-actions {\n  display: flex;\n  grid-column: 1 / -1;\n  gap: 6px;\n}\n\n.chatroom-map-member-actions button {\n  flex: 1;\n}\n\n.chatroom-map-member-profile {\n  min-height: 32px;\n  padding: 4px 10px;\n  border: 1px solid var(--border, rgb(0 0 0 / 15%));\n  border-radius: 6px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.chatroom-map-user-dot[role=\"button\"] {\n  cursor: pointer;\n}\n\n/* Older/static map sources have no self action; interactive stars open Me. */\n.chatroom-map-user-dot-self {\n  pointer-events: none;\n}\n.chatroom-map-user-dot-self[role=\"button\"] { pointer-events: auto; }\n\n/* A 14 px dot is a hard tap target on a phone: widen the hit area without changing the dot. */\n.chatroom-map-user-dot[role=\"button\"]::after {\n  content: '';\n  position: absolute;\n  inset: -12px;\n}\n\n.chatroom-map-tile-enter {\n  flex: none;\n  min-height: 32px;\n  padding: 4px 10px;\n  border: 0;\n  border-radius: 6px;\n  background: var(--accent, #2563eb);\n  color: #fff;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.chatroom-map-marker:hover .chatroom-map-tooltip,\n.chatroom-map-marker:focus-visible .chatroom-map-tooltip {\n  display: grid;\n}\n\n.chatroom-map-tooltip > span {\n  color: #4b5563;\n  font-size: 0.78rem;\n}\n\n.chatroom-map-cluster {\n  display: grid;\n  place-items: center;\n  min-width: 42px;\n  height: 42px;\n  padding: 0 8px;\n  border: 3px solid #fff;\n  border-radius: 999px;\n  background: #0f766e;\n  color: #fff;\n  box-shadow: 0 2px 10px rgb(0 0 0 / 35%);\n  font: inherit;\n  font-size: 0.8rem;\n  font-weight: 800;\n  cursor: zoom-in;\n}\n\n.chatroom-map-cluster:focus-visible,\n.chatroom-map-marker:focus-visible {\n  outline: 3px solid color-mix(in srgb, var(--accent) 45%, white);\n  outline-offset: 2px;\n}\n\n@media (max-width: 480px) {\n  .chatroom-map-status {\n    max-width: calc(100% - 64px);\n  }\n\n  .chatroom-map {\n    min-height: 260px;\n  }\n}\n\n.chatroom-item {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  margin-bottom: 8px;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.chatroom-flat-section + .chatroom-flat-section {\n  margin-top: 22px;\n}\n\n/* Nearby v3 list: custom rooms and nearby people share one compact browser surface. */\n.nearby-browser-list {\n  margin-top: 10px;\n  overflow: hidden;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n}\n\n.nearby-browser-people,\n#chatroom-members-list {\n  position: relative;\n}\n\n.nearby-self-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 78px;\n  padding: 10px 14px;\n  border: 0;\n  border-radius: 0;\n  background: var(--bg-subtle);\n  color: var(--text-primary);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.nearby-self-row .chatroom-member-avatar {\n  margin-right: 12px;\n  flex-shrink: 0;\n  color: #b45309;\n  background: #fef3c7;\n}\n\n.nearby-self-row .chatroom-member-name {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.nearby-self-effect-space {\n  display: block;\n  height: 20px;\n}\n\n.nearby-self-row:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: -3px;\n}\n\n.nearby-browser-list .chatroom-flat-section + .chatroom-flat-section {\n  margin-top: 0;\n  border-top: 1px solid var(--border);\n}\n\n.nearby-browser-list .chatroom-flat-heading {\n  margin: 0;\n  padding: 10px 14px 7px;\n  background: var(--bg-subtle);\n}\n\n.nearby-browser-list .chatroom-item,\n.nearby-browser-list .nearby-person-item {\n  display: flex;\n  align-items: center;\n  min-height: 58px;\n  margin: 0;\n  padding: 10px 14px;\n  border: 0;\n  border-top: 1px solid var(--border);\n  border-radius: 0;\n  background: var(--surface);\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.nearby-browser-list .chatroom-item:hover,\n.nearby-browser-list .nearby-person-item:hover {\n  transform: none;\n  background: var(--bg-subtle);\n}\n\n.nearby-browser-list .chatroom-item:active {\n  transform: none;\n}\n\n.nearby-browser-list .chatroom-icon {\n  width: 40px;\n  margin-right: 12px;\n  text-align: center;\n  font-size: 1.55rem;\n}\n\n.nearby-browser-list .chatroom-flat-metrics {\n  margin-top: 4px;\n}\n\n.nearby-browser-list .chatroom-headcount {\n  padding: 0;\n  background: transparent;\n  color: var(--text-tertiary);\n}\n\n.nearby-browser-list .chatroom-flat-empty {\n  margin: 0;\n  padding: 14px;\n  border: 0;\n  border-top: 1px solid var(--border);\n  border-radius: 0;\n}\n\n.chatroom-flat-heading {\n  margin: 4px 8px 10px;\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n/* Nearby (§3.7): \"Sent to N of M\" under my Nearby row; \"Show more people here\" under my list. */\n.chatroom-flat-progress {\n  margin: 4px 12px 0;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n/* §3.7 \"Meeting new people in groups\": the group bar above the people, Nearby and Places alike. */\n.nearby-group-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px 12px;\n  margin: 8px;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n}\n\n.nearby-group-title {\n  font-weight: 600;\n}\n\n.nearby-group-note {\n  margin-top: 2px;\n  color: var(--text-tertiary);\n  font-size: 0.88rem;\n}\n\n.nearby-group-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.nearby-meet-confirm {\n  position: fixed;\n  inset: 0;\n  z-index: 5000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(15, 23, 42, 0.48);\n}\n\n.nearby-meet-confirm-card {\n  width: min(440px, 96vw);\n  padding: 18px;\n  border-radius: 16px;\n  background: var(--surface);\n  box-shadow: 0 18px 55px rgba(15, 23, 42, 0.2);\n}\n\n.nearby-meet-confirm-title {\n  font-size: 1.05em;\n  font-weight: 700;\n}\n\n.nearby-meet-confirm-body {\n  margin: 8px 0 16px;\n  color: var(--text-secondary);\n  line-height: 1.45;\n}\n\n.nearby-meet-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.chatroom-flat-empty {\n  margin: 0 8px;\n  padding: 16px;\n  border: 1px dashed var(--border-strong);\n  border-radius: var(--radius-lg);\n  color: var(--text-tertiary);\n  font-size: 0.9rem;\n}\n\n.chatroom-flat-metrics {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 12px;\n  margin-top: 8px;\n  color: var(--text-tertiary);\n  font-size: 0.82rem;\n}\n\n.chatroom-item:hover {\n  background: var(--bg-subtle);\n  border-color: var(--success);\n  transform: translateX(4px);\n}\n\n.chatroom-item:active {\n  transform: translateX(4px) scale(0.98);\n}\n\n/* Expand/Collapse icon */\n.chatroom-expand-icon {\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  user-select: none;\n  font-size: 0.8em;\n  color: var(--text-tertiary);\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.chatroom-expand-icon:hover {\n  color: var(--success);\n  transform: scale(1.2);\n}\n\n.chatroom-expand-icon-placeholder {\n  width: 20px;\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n\n/* Remove old margin-based indentation (now using inline style padding-left) */\n\n.chatroom-icon {\n  font-size: 2em;\n  margin-right: 16px;\n  flex-shrink: 0;\n}\n\n.chatroom-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.chatroom-name {\n  font-size: 1.05em;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 2px 8px;\n  overflow-wrap: break-word;\n}\n\n.chatroom-description {\n  font-size: 0.85em;\n  color: var(--text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chatroom-arrow {\n  font-size: 1.5em;\n  color: var(--border-strong);\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n.chatroom-headcount {\n  margin-left: 0;\n  padding: 2px 8px;\n  background: var(--success-soft);\n  color: var(--success-text);\n  border-radius: var(--radius-lg);\n  font-size: 0.9em;\n  font-weight: 500;\n  display: inline-block;\n}\n\n.current-room-badge {\n  margin-left: 8px;\n  padding: 2px 8px;\n  background: var(--success);\n  color: white;\n  border-radius: var(--radius-lg);\n  font-size: 0.75em;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.chatroom-item.current-room {\n  border-color: var(--success);\n  border-width: 2px;\n  background: var(--success-soft);\n}\n\n/* Chatroom Detail View */\n#chatroom-detail-container {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface);\n  overflow: hidden;\n}\n\n.chatroom-detail-header {\n  padding: 16px;\n  background: var(--bg-subtle);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n#back-to-chatrooms {\n  background: none;\n  border: none;\n  font-size: 1.5em;\n  color: var(--success);\n  cursor: pointer;\n  padding: 4px 8px;\n  transition: transform 0.2s ease;\n}\n\n#back-to-chatrooms:hover {\n  transform: translateX(-4px);\n}\n\n#chatroom-detail-info {\n  flex: 1;\n}\n\n#current-chatroom-title {\n  font-size: 1.1em;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n#current-chatroom-status {\n  font-size: 0.85em;\n  color: var(--text-muted);\n}\n\n#chatroom-metadata {\n  margin: 8px 16px;\n  padding: 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg-subtle);\n}\n\n.chatroom-metadata-title {\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.chatroom-metadata-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 3px 0;\n  font-size: 0.85em;\n  color: var(--text-tertiary);\n}\n\n.chatroom-metadata-row strong {\n  text-align: right;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n/* Contacts View */\n#contacts-list-container {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n.contact-item:hover {\n  background: var(--bg-subtle) !important;\n  border-color: var(--success) !important;\n}\n\n.contact-detail-header {\n  padding: 16px;\n  background: var(--bg-subtle);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n#contact-detail-container .contact-talks-list {\n  padding: 8px;\n  overflow-y: auto;\n}\n\n.contact-talk-item:hover {\n  background: var(--bg-muted) !important;\n}\n\n#chatroom-members-list {\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  padding: 8px;\n}\n\n.chatroom-member-item {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  margin-bottom: 8px;\n  background: var(--surface);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.chatroom-member-item:hover {\n  background: var(--bg-subtle);\n  border-color: var(--success);\n}\n\n.chatroom-member-avatar {\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n  border-radius: 50%;\n  background: var(--gradient-accent);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 1.1em;\n  flex-shrink: 0;\n}\n\n/* Holds the avatar and, for a Traveler, the ✈ badge on its top-right corner. */\n.chatroom-member-avatar-wrap {\n  position: relative;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.chatroom-member-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.chatroom-member-name {\n  font-size: 1em;\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.chatroom-member-status {\n  font-size: 0.8em;\n  color: var(--success);\n}\n\n/* Broadcast sent: highlight members who received the broadcast */\n.chatroom-member-item.broadcast-sent-to {\n  background: var(--success-soft) !important;\n  border-radius: var(--radius-md);\n  transition: background 0.3s ease;\n}\n\n/* Match indicator on member name (Tom sees green when Jerry/Bob match) */\n.chatroom-member-item.member-matched .chatroom-member-name,\n.nearby-person-item.member-matched .chatroom-member-name {\n  color: var(--success);\n  font-weight: 700;\n}\n\n.chatroom-member-item.member-matched .chatroom-member-status,\n.nearby-person-item.member-matched .chatroom-member-status {\n  content: 'Matched';\n}\n\n/* Flash when new talk received from this user */\n.chatroom-member-item.flash-new-talk {\n  animation: flashMember 1s ease-out;\n}\n\n/* TechSupport's fixed, compact pinned row above the sorted roster — a single line, not the\n   two-line avatar+status block ordinary members get (same reasoning as the Contacts tab's\n   own pinned support row, contacts-view.ts). */\n.chatroom-member-support-pinned {\n  padding: 8px 12px;\n  background: var(--accent-soft);\n  border-color: var(--accent-border);\n}\n\n.chatroom-member-support-pinned .chatroom-member-name {\n  flex: 1;\n  min-width: 0;\n  margin-bottom: 0;\n}\n\n.chatroom-member-support-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--accent-soft);\n  color: var(--accent-hover);\n  font-size: 0.72em;\n  font-weight: 700;\n  margin-left: 8px;\n}\n\n.chatroom-member-traveler-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--surface);\n  color: var(--accent-hover);\n  border: 1px solid var(--border-strong);\n  font-size: 11px;\n  line-height: 1;\n  pointer-events: none;\n}\n\n@keyframes flashMember {\n  0%, 100% { background: transparent; }\n  25% { background: rgba(5, 150, 105, 0.4); }\n  50% { background: transparent; }\n  75% { background: rgba(5, 150, 105, 0.25); }\n}\n\n/* TODO §Q: Talk -> Me-tab Q&A reverse edge — briefly highlights the answer row(s) scrolled to. */\n.answer-item-highlighted {\n  animation: flashMember 2s ease-out;\n}\n\n/* Settings tab — drill-down menu */\n.settings-jump-menu {\n  display: grid;\n  gap: 14px;\n}\n\n.settings-jump-menu-group {\n  display: grid;\n  gap: 6px;\n}\n\n.settings-jump-menu-group-label {\n  margin: 0;\n  padding: 0 4px;\n  color: var(--text-tertiary);\n  font-size: 0.76em;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.settings-jump-menu-group-items {\n  overflow: hidden;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface);\n}\n\n.settings-jump-menu-item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  color: var(--text-primary);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.settings-jump-menu-item:hover {\n  background: var(--bg-subtle);\n}\n\n.settings-jump-menu-icon {\n  flex-shrink: 0;\n  font-size: 1.05em;\n}\n\n.settings-jump-menu-label {\n  flex: 1 1 auto;\n}\n\n.settings-jump-menu-chevron {\n  color: var(--text-tertiary);\n}\n\n.status-bar-actions #broadcast-talk-btn {\n  margin: 0;\n  padding: 12px 14px;\n  background: var(--gradient-success);\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 0.98em;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.status-bar-actions #broadcast-talk-btn:hover {\n  background: var(--gradient-success-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(5, 150, 105, 0.4);\n}\n\n.status-bar-actions #broadcast-talk-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.3);\n}\n\n/* Talks View */\n.talks-nav-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: var(--bg-subtle);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.talks-nav-tabs {\n  display: flex;\n  gap: 8px;\n  flex: 1;\n}\n\n.talks-nav-btn,\n.talks-nav-back {\n  border: 1px solid var(--border-strong);\n  background: var(--surface);\n  color: var(--text-secondary);\n  border-radius: var(--radius-full);\n  padding: 8px 14px;\n  font-size: 0.92em;\n  font-weight: 600;\n}\n\n.talks-nav-btn.active {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: white;\n}\n\n.talks-nav-back {\n  flex-shrink: 0;\n}\n\n.talks-header {\n  padding: 16px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.create-talk-btn {\n  width: 100%;\n  padding: 14px 20px;\n  background: var(--gradient-success);\n  color: white;\n  border: none;\n  border-radius: var(--radius-lg);\n  font-size: 1em;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(5, 150, 105, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.create-talk-btn:hover {\n  background: var(--gradient-success-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);\n}\n\n.create-talk-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 6px rgba(5, 150, 105, 0.2);\n}\n\n.talks-list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  background: var(--bg-subtle);\n  padding: 8px;\n}\n\n/* Shared manual pin control for Contacts, Talks, and Me answer rows. */\n.list-pin-button {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted);\n  opacity: 0.5;\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.list-pin-button:hover,\n.list-pin-button:focus-visible {\n  background: var(--accent-soft);\n  border-color: var(--accent-border);\n  color: var(--accent-text);\n  opacity: 1;\n  outline: none;\n}\n\n.list-pin-button.is-pinned {\n  color: var(--accent-text);\n  background: var(--accent-soft);\n  opacity: 1;\n}\n\n.list-pin-button.talk-copy-button.is-copied {\n  position: relative;\n  color: var(--accent-text);\n  background: var(--accent-soft);\n  opacity: 1;\n}\n\n.list-pin-button.talk-copy-button.is-copied::after {\n  content: '✓';\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: var(--success);\n  color: #fff;\n  font-size: 10px;\n  line-height: 14px;\n  text-align: center;\n}\n\n.answer-question-item {\n  position: relative;\n}\n\n.answer-question-item > .list-pin-badge {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n}\n\n.talk-list-item {\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  padding: 16px;\n  margin-bottom: 8px;\n  border: 1px solid var(--border);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.talk-list-item:hover {\n  background: var(--bg-subtle);\n  border-color: var(--success);\n  transform: translateX(4px);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n\n.talk-list-item:active {\n  transform: translateX(4px) scale(0.98);\n}\n\n/* Row gestures (incoming: down = retain, left = Ignore/Pass, right = Like for tags;\n * outgoing: left = delete):\n * `.talk-gesture-live` suspends the row's own hover/active transition while a drag is in\n * progress so the row tracks the pointer 1:1, then removing it lets the base transition\n * animate the snap-back on release. The hint classes preview the color of the\n * retain/Ignore/delete outcome before the commit threshold is reached. */\n.talk-list-item.talk-gesture-live {\n  transition: none;\n}\n\n.talk-list-item.talk-gesture-hint-copy {\n  background: #dcfce7 !important;\n}\n\n.talk-list-item.talk-gesture-hint-delete {\n  background: #fee2e2 !important;\n}\n\n.talk-list-item.talk-gesture-hint-ignore {\n  background: var(--bg-muted) !important;\n}\n\n.talk-list-item.talk-gesture-hint-like {\n  background: #dcfce7 !important;\n}\n\n.talk-list-item[data-role=\"incoming\"].talk-gesture-hint-ignore::after,\n.talk-list-item[data-role=\"incoming\"].talk-gesture-hint-like::after {\n  content: attr(data-gesture-label);\n  font-size: 0.75rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.talk-item-chevron {\n  color: var(--text-muted);\n  font-size: 1.1em;\n  line-height: 1;\n}\n\n.talk-icon-badge {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 2px 6px;\n  font-size: 0.95em;\n  cursor: pointer;\n}\n\n.talk-icon-badge input[type=\"checkbox\"] {\n  accent-color: var(--accent);\n  width: 14px;\n  height: 14px;\n  margin: 0;\n}\n\n/* Me tab — merged-by-question answer rows */\n.answer-tag-item {\n  transition: background 0.15s ease;\n}\n\n.answer-tag-item .answer-tag-checkbox {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--accent);\n  flex-shrink: 0;\n}\n\n.settings-scheme-radio {\n  accent-color: var(--accent);\n}\n\n.answer-qa-item {\n  display: flex;\n  flex-direction: column;\n  border-radius: var(--radius-lg);\n  padding: 10px 12px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.qa-line {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 8px;\n}\n\n.qa-question {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.qa-arrow {\n  color: var(--text-tertiary);\n}\n\n.qa-answer {\n  font-weight: 600;\n  color: var(--accent-text);\n}\n\n.qa-chevron {\n  color: var(--text-tertiary);\n  font-size: 1.05em;\n  line-height: 1;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.qa-stats {\n  margin-top: 6px;\n  font-size: 0.76em;\n  color: var(--text-tertiary);\n}\n\n.context-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  background: var(--warning-soft);\n  border: 1px solid var(--warning-border);\n  color: var(--warning-text);\n  border-radius: var(--radius-full);\n  padding: 2px 7px;\n  font-size: 0.78em;\n  flex-shrink: 0;\n}\n\n.context-indicator .count {\n  font-weight: 700;\n}\n\n/* Contacts tab — icon-only broadcast-to-group button (was an oversized text button) */\nbutton.contacts-broadcast-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-radius: var(--radius-sm);\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  font-size: 1em;\n  flex-shrink: 0;\n}\n\n.talk-list-item.talk-incoming-new {\n  background: var(--accent-soft);\n  border-color: var(--accent-border);\n  box-shadow: inset 0 0 0 1px var(--accent-border);\n}\n\n.talk-list-item.talk-incoming-answered,\n.talk-list-item.talk-broadcast-disabled {\n  background: var(--bg-muted);\n  border-color: var(--border-strong);\n  color: var(--text-tertiary);\n}\n\n.talk-list-item.talk-broadcast-enabled {\n  background: var(--success-soft);\n  border-color: var(--success-border);\n}\n\n.talk-incoming-sender {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0 6px;\n  min-width: 0;\n}\n\n.talk-incoming-avatar {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--accent-soft);\n  color: var(--accent-text);\n  border: 1px solid var(--accent-border);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 26px;\n  font-size: 0.78em;\n  font-weight: 800;\n  overflow: hidden;\n}\n\n.talk-incoming-avatar .profile-avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.talk-incoming-sender-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.9em;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.talk-info-chips {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 6px 0 8px;\n}\n\n.talk-info-chip {\n  min-height: 22px;\n  border-radius: var(--radius-full);\n  border: 1px solid var(--border-strong);\n  background: var(--bg-subtle);\n  color: var(--text-primary);\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 8px;\n  font-size: 0.78em;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.talk-language-alert {\n  background: var(--warning-soft);\n  border-color: var(--warning-border);\n  color: var(--warning-text);\n}\n\n.talk-expiry-green {\n  background: var(--success-soft);\n  border-color: var(--success-border);\n  color: var(--success-hover);\n}\n\n.talk-expiry-amber {\n  background: var(--warning-soft);\n  border-color: var(--warning-border);\n  color: var(--warning-text);\n}\n\n.talk-expiry-red {\n  background: var(--danger-soft);\n  border-color: var(--danger-border);\n  color: var(--danger-hover);\n}\n\n.talk-progress-ring {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: conic-gradient(var(--accent) var(--progress, 0%), var(--accent-soft) 0);\n  box-shadow: inset 0 0 0 3px #fff;\n  flex: 0 0 14px;\n}\n\n.talk-list-item.talk-type-tag,\n.talk-list-item.talk-tag-chip {\n  min-height: 34px;\n  padding: 6px 10px;\n  border-radius: var(--radius-full);\n  border: 1px solid var(--accent-border);\n  background: var(--accent-soft);\n  color: var(--accent-text);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: fit-content;\n  max-width: 100%;\n}\n\n/* Filled pill = incoming, outlined pill = outgoing — the same filled-vs-outline\n * shape language as the card rows' tinted-vs-white background below. */\n.talk-list-item.talk-tag-in {\n  border-color: var(--accent-border);\n  background: var(--accent-soft);\n  color: var(--accent-hover);\n}\n\n.talk-list-item.talk-tag-out {\n  border-color: var(--accent);\n  background: var(--surface);\n  color: var(--accent-text);\n}\n\n/* Starter tags (OPEN-87): an icon heading per group, its tags indented below it. */\n.starter-tag-group-heading {\n  margin: 14px 0 4px;\n  font-size: 0.85em;\n  font-weight: 700;\n  color: var(--text-secondary);\n}\n\n.starter-tag-create-prompt {\n  margin: 14px 0 6px 18px;\n  padding: 12px 14px;\n  border: 1px dashed var(--accent);\n  border-radius: 12px;\n  background: var(--accent-soft);\n}\n.starter-tag-create-title { font-weight: 700; margin-bottom: 4px; }\n.starter-tag-create-body { font-size: 0.88em; color: var(--text-secondary); margin-bottom: 10px; }\n\n/* One-tap tag answering (OPEN-87): Like moves right, then down; Pass flies left, then up. */\n.talk-list-item.talk-tag-chip.talk-tag-fly-like {\n  animation: talk-tag-fly-like 520ms ease-in forwards;\n  pointer-events: none;\n}\n.talk-list-item.talk-tag-chip.talk-tag-fly-pass {\n  animation: talk-tag-fly-pass 520ms ease-in forwards;\n  pointer-events: none;\n}\n@keyframes talk-tag-fly-like {\n  0% { transform: none; opacity: 1; }\n  45% { transform: translateX(45vw); opacity: 1; }\n  100% { transform: translate(45vw, 60vh); opacity: 0; }\n}\n@keyframes talk-tag-fly-pass {\n  0% { transform: none; opacity: 1; }\n  45% { transform: translateX(-45vw); opacity: 1; }\n  100% { transform: translate(-45vw, -60vh); opacity: 0; }\n}\n@keyframes talk-tag-fade {\n  to { opacity: 0; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .talk-list-item.talk-tag-chip.talk-tag-fly-like,\n  .talk-list-item.talk-tag-chip.talk-tag-fly-pass {\n    animation: talk-tag-fade 200ms linear forwards;\n  }\n}\n\n.talk-list-item.talk-tag-chip:hover {\n  transform: translateX(2px);\n  border-color: var(--accent);\n  background: var(--accent-soft);\n}\n\n.talk-tag-decision-actions {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  flex: 0 0 auto;\n}\n\n.talk-tag-decision-button {\n  width: 30px;\n  height: 30px;\n  margin: 0;\n  padding: 0;\n  border: 1px solid var(--border);\n  border-radius: 50%;\n  background: var(--surface);\n  color: var(--text-muted);\n  font: inherit;\n  font-size: 1rem;\n  font-weight: 800;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.talk-tag-decision-button:hover,\n.talk-tag-decision-button:focus-visible {\n  border-color: currentColor;\n}\n\n.talk-tag-pass-button:hover,\n.talk-tag-pass-button:focus-visible,\n.talk-tag-pass-button.is-selected {\n  background: var(--bg-muted);\n  color: var(--text-tertiary);\n}\n\n.talk-tag-like-button:hover,\n.talk-tag-like-button:focus-visible,\n.talk-tag-like-button.is-selected {\n  border-color: var(--success);\n  background: #dcfce7;\n  color: var(--success);\n}\n\n.talk-tag-text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.94em;\n  font-weight: 700;\n}\n\n.talk-tag-text-button {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  padding: 0;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n}\n\n.talk-tag-text-button:hover {\n  text-decoration: underline;\n}\n\n.talk-list-item.talk-type-flow {\n  border-radius: var(--radius-md);\n  border-color: var(--accent-border);\n  background: var(--accent-soft);\n}\n\n.talk-list-item.talk-type-survey {\n  border-radius: 8px 18px 8px 18px;\n  border-color: var(--success-border);\n  background: var(--success-soft);\n}\n\n.talk-list-item.talk-type-route {\n  border-radius: var(--radius-md);\n  border-color: var(--warning);\n  background: var(--warning-soft);\n  padding: 18px;\n  box-shadow: inset 0 0 0 1px var(--warning-border);\n}\n\n.talk-list-item.talk-type-route .talk-item-title {\n  font-size: 1.18em;\n}\n\n.talk-list-item.talk-type-flow .talk-badge-type {\n  background: var(--accent-soft);\n  color: var(--accent-text);\n}\n\n.talk-list-item.talk-type-survey .talk-badge-type {\n  background: var(--success-soft);\n  color: var(--success-hover);\n}\n\n.talk-list-item.talk-type-route .talk-badge-type {\n  background: var(--warning-soft);\n  color: var(--warning-text);\n}\n\n.talk-item-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.talk-item-title {\n  flex: 1 1 auto;\n  font-size: 1.1em;\n  font-weight: 600;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n\n.talk-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: var(--radius-lg);\n  font-size: 0.75em;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n/* Consecutive badges (role/status + type + language, at the top of a talk's details\n   popup — ui-manager.ts) render with no gap between them otherwise, since .talk-badge\n   itself carries no margin — they end up touching, looking like one run-on block. */\n.talk-badge + .talk-badge {\n  margin-left: 6px;\n}\n\n.talk-badge-created {\n  background: var(--accent-soft);\n  color: var(--accent-text);\n}\n\n.talk-badge-answered {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n\n.talk-badge-type {\n  background: var(--bg-muted);\n  color: var(--text-tertiary);\n}\n\n.talk-badge-broadcast-enabled {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n\n.talk-badge-broadcast-disabled {\n  background: var(--bg-muted);\n  color: var(--text-tertiary);\n}\n\n/* Icon-only row actions (view/details/broadcast-toggle/remove/survey-stats) — one\n * compact, ghost-style control instead of a full-size solid-colored `.btn` each.\n * State (on/off, destructive) is carried by the icon glyph itself, not a filled\n * background, so it doesn't add its own redundant color on top of the icon. */\nbutton.talk-icon-btn {\n  background: transparent;\n  color: var(--text-secondary);\n  border: none;\n  padding: 4px 6px;\n  font-size: 0.95em;\n  min-width: 0;\n  line-height: 1;\n  border-radius: var(--radius-sm);\n  box-shadow: none;\n}\n\nbutton.talk-icon-btn:hover {\n  background: var(--bg-subtle);\n  color: var(--text-primary);\n  transform: none;\n  box-shadow: none;\n}\n\n.talk-broadcast-toggle-btn.talk-broadcast-toggle-off {\n  opacity: 0.6;\n}\n\n.talk-item-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.talk-item-time {\n  font-size: 0.85em;\n  color: var(--text-muted);\n}\n\n/* Chat Area */\n.chat-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-muted);\n}\n\n.messages-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 15px;\n  background: var(--bg-muted);\n}\n\n.message {\n  max-width: 70%;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.message.sent {\n  margin-left: auto;\n  flex-direction: row-reverse;\n}\n\n.message-bubble {\n  background: var(--surface);\n  padding: 10px 14px;\n  border-radius: var(--radius-md);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  position: relative;\n  word-wrap: break-word;\n}\n\n.message.sent .message-bubble {\n  background: var(--bubble-sent);\n  color: var(--text-primary);\n}\n\n.message-time {\n  font-size: 0.7em;\n  color: var(--text-muted);\n  margin-top: 5px;\n}\n\n/* Talk Interface */\n.talk-question {\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n  margin-bottom: 20px;\n  border: 2px solid var(--border);\n}\n\n.question-text {\n  font-size: 1.1em;\n  margin-bottom: 15px;\n  color: var(--text-primary);\n}\n\n.answer-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.answer-chip {\n  background: var(--bg-muted);\n  border: 2px solid transparent;\n  border-radius: var(--radius-xl);\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.answer-chip:hover {\n  background: var(--accent-soft);\n  border-color: var(--accent);\n}\n\n.answer-chip.selected {\n  background: var(--accent);\n  color: white;\n  border-color: var(--accent-hover);\n}\n\n.answer-chip.ignore {\n  background: var(--danger);\n  color: white;\n}\n\n.answer-chip.match {\n  background: var(--success);\n  color: white;\n}\n\n/* Message Input */\n.message-input-area {\n  background: var(--surface);\n  border-top: 1px solid var(--border);\n  padding: 15px 20px;\n}\n\n.message-input-container {\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n}\n\n.message-input {\n  flex: 1;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  padding: 10px 15px;\n  outline: none;\n  resize: none;\n  min-height: 40px;\n  max-height: 120px;\n}\n\n.message-input:focus {\n  border-color: var(--accent);\n}\n\n.send-button {\n  background: var(--accent);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s ease;\n}\n\n.send-button:hover {\n  background: var(--accent-hover);\n}\n\n.send-button:disabled {\n  background: var(--border-strong);\n  cursor: not-allowed;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n}\n\n.tab {\n  flex: 1;\n  padding: 15px;\n  text-align: center;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.tab:hover {\n  background: var(--bg-subtle);\n}\n\n.tab.active {\n  border-bottom-color: var(--accent);\n  color: var(--accent);\n  font-weight: bold;\n}\n\n/* Buttons */\n.btn {\n  background: var(--accent);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 1em;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn:hover {\n  background: var(--accent-hover);\n  transform: translateY(-1px);\n}\n\n.btn:disabled {\n  background: var(--border-strong);\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-secondary {\n  background: var(--surface);\n  color: var(--text-secondary);\n  border: 1px solid var(--border-strong);\n}\n\n.btn-secondary:hover {\n  background: var(--bg-subtle);\n  color: var(--text-primary);\n}\n\n.btn-success {\n  background: var(--success);\n}\n\n.btn-success:hover {\n  background: var(--success-hover);\n}\n\n.btn-danger {\n  background: var(--danger);\n}\n\n.btn-danger:hover {\n  background: var(--danger-hover);\n}\n\n/* Form Elements */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.form-input {\n  width: 100%;\n  padding: 10px 15px;\n  background: var(--surface);\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.form-input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n/* Notifications - above modals so \"no talks to broadcast\" etc. are visible when modal opens */\n.notification {\n  position: fixed;\n  top: calc(62px + (var(--toast-index, 0) * 58px));\n  right: 20px;\n  padding: 15px 20px;\n  border-radius: var(--radius-sm);\n  color: white;\n  z-index: 10000;\n  animation: slideIn 0.3s ease;\n}\n\n/* Toast placement per width (GUI redesign §8): < 768px they render full-width\n   at the top, one at a time, instead of stacking top-right. */\n@media (max-width: 767px) {\n  .notification {\n    top: calc(58px + (var(--toast-index, 0) * 58px) + env(safe-area-inset-top, 0px));\n    left: 12px;\n    right: 12px;\n    text-align: center;\n  }\n}\n\n.notification.success {\n  background: var(--success);\n}\n\n.notification.error {\n  background: var(--danger);\n}\n\n.notification.info {\n  background: var(--accent);\n}\n\n.notification.warning {\n  background: var(--warning);\n  color: var(--text-primary);\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: var(--surface);\n  color: var(--text-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  padding: 30px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  margin-bottom: 20px;\n}\n\n/* Headers that carry a close button (many don't — some just have a title + subtitle\n   paragraph, which must stay stacked, not pushed to the right) get title-left/×-right\n   layout by default instead of the close button silently falling to its own line below\n   the title as an unlabeled block element. */\n.modal-header:has(.close-button) {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.modal-header:has(.close-button) .modal-title {\n  margin-bottom: 0;\n}\n\n.modal-title {\n  margin-bottom: 10px;\n  color: var(--text-primary);\n}\n\n/* Some call sites already inline this same styling per-instance; this shared default\n   covers the rest so an unstyled native <button>&times;</button> never renders as a\n   raw bordered box that reads as a stray/broken element instead of a close icon. */\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  color: var(--text-tertiary, #666);\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.close-button:hover {\n  color: var(--text-primary);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n/* First-run tour: each stop gets its own color and a concise product promise.\n   The decorative orbits suggest one idea branching into many conversations. */\n.walkthrough-card {\n  position: relative;\n  overflow-x: hidden;\n  border: 1px solid color-mix(in srgb, var(--walkthrough-accent) 24%, var(--border));\n  background:\n    radial-gradient(circle at 100% 0%, var(--walkthrough-accent-soft), transparent 38%),\n    var(--surface);\n}\n\n.walkthrough-card::before {\n  content: '';\n  position: absolute;\n  inset: 0 0 auto;\n  height: 4px;\n  background: var(--walkthrough-accent);\n}\n\n.walkthrough-header {\n  position: relative;\n  display: grid !important;\n  grid-template-columns: 1fr auto;\n  gap: 3px 12px !important;\n  margin-bottom: 8px;\n}\n\n.walkthrough-progress-label {\n  color: var(--walkthrough-accent);\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.walkthrough-header .modal-title {\n  grid-column: 1;\n  font-size: clamp(1.35rem, 5vw, 1.75rem);\n}\n\n.walkthrough-header .close-button {\n  grid-column: 2;\n  grid-row: 1 / span 2;\n}\n\n.walkthrough-hero {\n  position: relative;\n  padding: 12px 18px 18px;\n  text-align: center;\n  animation: walkthrough-reveal 240ms ease-out;\n}\n\n.walkthrough-icon {\n  position: relative;\n  display: grid;\n  place-items: center;\n  width: 74px;\n  height: 74px;\n  margin: 0 auto 14px;\n  border: 1px solid color-mix(in srgb, var(--walkthrough-accent) 35%, transparent);\n  border-radius: 24px;\n  background: var(--walkthrough-accent-soft);\n  box-shadow: 0 12px 28px color-mix(in srgb, var(--walkthrough-accent) 18%, transparent);\n  font-size: 2.35rem;\n  line-height: 1;\n  transform: rotate(-3deg);\n}\n\n.walkthrough-tagline {\n  position: relative;\n  max-width: 460px;\n  margin: 0 auto 10px;\n  color: var(--text-primary);\n  font-size: clamp(1.08rem, 4.5vw, 1.32rem);\n  font-weight: 800;\n  line-height: 1.25;\n  text-wrap: balance;\n}\n\n.walkthrough-body {\n  position: relative;\n  max-width: 465px;\n  margin: 0 auto;\n  color: var(--text-secondary, #555);\n  font-size: 0.96rem;\n  line-height: 1.55;\n  text-wrap: pretty;\n}\n\n.walkthrough-points {\n  position: relative;\n  display: grid;\n  gap: 7px;\n  max-width: 465px;\n  margin: 14px auto 0;\n  padding: 0;\n  list-style: none;\n  text-align: left;\n}\n\n.walkthrough-points li {\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  align-items: start;\n  gap: 8px;\n  padding: 8px 10px;\n  border: 1px solid color-mix(in srgb, var(--walkthrough-accent) 18%, var(--border));\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--walkthrough-accent-soft) 45%, var(--surface));\n  color: var(--text-primary);\n  font-size: 0.86rem;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.walkthrough-point-icon {\n  line-height: 1.2;\n  text-align: center;\n}\n\n.walkthrough-orbit {\n  position: absolute;\n  border-radius: 50%;\n  background: var(--walkthrough-accent-soft);\n  /* OPEN-39: decorative only — a few loops, then rest. A never-ending loop kept the compositor at\n     ~38 % of a core on Android 7 while the walkthrough stayed open. */\n  animation: walkthrough-float 3.2s ease-in-out 3;\n}\n\n.walkthrough-orbit.orbit-one {\n  top: 6px;\n  left: 15%;\n  width: 13px;\n  height: 13px;\n}\n\n.walkthrough-orbit.orbit-two {\n  top: 54px;\n  right: 13%;\n  width: 20px;\n  height: 20px;\n  animation-delay: -1.4s;\n}\n\n.walkthrough-dots {\n  display: flex;\n  justify-content: center;\n  gap: 7px;\n  margin-bottom: 12px;\n}\n\n.walkthrough-dot {\n  width: 9px;\n  height: 9px;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: var(--border);\n  cursor: pointer;\n  transition: width 160ms ease, background-color 160ms ease, transform 160ms ease;\n}\n\n.walkthrough-dot:hover {\n  transform: scale(1.25);\n}\n\n.walkthrough-dot.active {\n  width: 25px;\n  background: var(--walkthrough-accent);\n}\n\n.walkthrough-dot:focus-visible {\n  outline: 3px solid var(--walkthrough-accent-soft);\n  outline-offset: 3px;\n}\n\n.walkthrough-actions {\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.walkthrough-navigation {\n  display: flex;\n  gap: 8px;\n}\n\n.walkthrough-card .primary-btn {\n  background: var(--walkthrough-accent);\n  border-color: var(--walkthrough-accent);\n}\n\n@keyframes walkthrough-reveal {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes walkthrough-float {\n  0%, 100% { transform: translateY(0) scale(1); }\n  50% { transform: translateY(-6px) scale(1.08); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .walkthrough-hero,\n  .walkthrough-orbit {\n    animation: none;\n  }\n\n  .walkthrough-dot {\n    transition: none;\n  }\n}\n\n/* Starter actions shown when the ordinary Talks list is empty. */\n.talks-starter-heading h2 {\n  margin: 8px 0;\n  color: var(--text-primary);\n  font-size: clamp(1.35rem, 5vw, 1.75rem);\n  line-height: 1.2;\n  text-wrap: balance;\n}\n\n.talks-starter-heading p {\n  margin: 0 auto 16px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.talks-starter-mark {\n  display: grid;\n  place-items: center;\n  width: 68px;\n  height: 68px;\n  margin: 10px auto;\n  border-radius: 22px;\n  background: var(--accent-soft);\n  font-size: 2rem;\n}\n\n.talks-starter-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 9px;\n}\n\n.talks-starter-card {\n  display: grid;\n  grid-template-columns: 32px minmax(0, 1fr);\n  gap: 9px;\n  align-items: start;\n  min-height: 76px;\n  padding: 11px;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: var(--surface);\n  color: var(--text-primary);\n  cursor: pointer;\n  text-align: left;\n}\n\n.talks-starter-card:hover {\n  border-color: var(--accent);\n  background: var(--accent-soft);\n}\n\n.talks-starter-card small {\n  display: block;\n  margin-top: 3px;\n  color: var(--text-secondary);\n  font-size: 0.78rem;\n  line-height: 1.3;\n}\n\n.talks-starter-icon {\n  font-size: 1.35rem;\n  line-height: 1.2;\n}\n\n.settings-inline-actions,\n.talks-starter-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.talks-starter-shelf {\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 26px 18px 40px;\n}\n\n.talks-starter-heading {\n  margin-bottom: 18px;\n  text-align: center;\n}\n\n.talks-starter-actions {\n  justify-content: center;\n  margin-top: 16px;\n}\n\n/* Identity & devices WP1: resilient card/row layout and a close control that\n   remains reachable while the full-screen page scrolls on small displays. */\n.identity-devices-page {\n  box-sizing: border-box;\n}\n\n.identity-devices-header {\n  position: sticky;\n  top: -30px;\n  z-index: 2;\n  margin: -30px -30px 16px;\n  padding: 20px 30px 12px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n}\n\n.identity-linked-device-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.identity-linked-device-summary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.identity-current-device-summary {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n/* ==========================================================================\n   Popup responsive size classes (GUI redesign §8)\n   Reference width matrix: 320 · 390 · 768 · 1024.\n   Size classes are set per-dialog via `.modal-content.size-{s,m,l,xl}`;\n   L/XL dialogs additionally carry `.modal-fullscreen` so they take over the\n   screen (not a bottom sheet) on narrow viewports.\n   ========================================================================== */\n.modal-content {\n  /* Never allow horizontal scrolling inside a dialog (e2e-asserted). */\n  overflow-x: hidden;\n}\n.modal-content.size-s { max-width: 440px; }\n.modal-content.size-m { max-width: 560px; }\n.modal-content.size-l { max-width: 800px; }\n.modal-content.size-xl { max-width: 1000px; max-height: 90vh; }\n\n/* 768px: L/XL clamp to the viewport with a small gutter. */\n@media (max-width: 768px) {\n  .modal-content.size-l,\n  .modal-content.size-xl {\n    max-width: calc(100vw - 40px);\n  }\n}\n\n/* ≤480px (covers 320/390): bottom sheets + stacked full-width actions. */\n@media (max-width: 480px) {\n  .modal-overlay {\n    align-items: flex-end;\n  }\n  .modal-content {\n    width: calc(100vw - 24px);\n    max-width: calc(100vw - 24px);\n    max-height: 92dvh;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    padding: 20px;\n  }\n  .modal-actions {\n    flex-direction: column-reverse; /* primary action (last in DOM) ends up at the bottom */\n    align-items: stretch;\n  }\n  .modal-actions > button,\n  .modal-actions > .btn {\n    width: 100%;\n    min-height: 44px;\n  }\n  .walkthrough-card {\n    padding: 18px 18px max(18px, env(safe-area-inset-bottom));\n  }\n  .talks-starter-grid {\n    grid-template-columns: 1fr;\n  }\n  .settings-inline-actions,\n  .settings-inline-actions .btn,\n  .talks-starter-actions,\n  .talks-starter-actions .btn {\n    width: 100%;\n  }\n  .walkthrough-hero {\n    padding: 8px 4px 14px;\n  }\n  .walkthrough-points {\n    gap: 6px;\n    margin-top: 11px;\n  }\n  .walkthrough-points li {\n    padding: 7px 8px;\n    font-size: 0.82rem;\n  }\n  .walkthrough-actions {\n    flex-direction: row;\n    align-items: center;\n  }\n  .walkthrough-actions > button {\n    width: auto;\n  }\n  .walkthrough-navigation {\n    flex: 1;\n  }\n  .walkthrough-navigation .btn {\n    flex: 1;\n    min-height: 44px;\n  }\n  /* Inputs/selects keep a 44px touch target. */\n  .modal-content input,\n  .modal-content select,\n  .modal-content textarea {\n    min-height: 44px;\n  }\n  /* L/XL dialogs become full-screen takeovers (no visible scrim to click). */\n  .modal-content.modal-fullscreen {\n    width: 100vw;\n    max-width: 100vw;\n    height: 100dvh;\n    max-height: 100dvh;\n    border-radius: 0;\n  }\n\n  .identity-devices-page.modal-fullscreen {\n    margin: 0;\n    width: 100vw;\n    max-width: 100vw;\n    height: 100dvh;\n    max-height: 100dvh;\n    padding: 16px;\n    border-radius: 0;\n  }\n\n  .identity-devices-header {\n    top: -16px;\n    margin: -16px -16px 12px;\n    padding: 14px 16px 10px;\n  }\n\n  .identity-linked-device-row,\n  .identity-current-device-summary {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .identity-linked-device-row > .btn {\n    width: 100%;\n    min-height: 44px;\n  }\n}\n\n/* My Answers list – single row per item, wider layout */\n.answers-view-inner {\n  max-width: min(900px, 95%);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.answer-outcome-item {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.answer-outcome-item:hover {\n  filter: brightness(0.97);\n}\n\n/* Answer modal: table-style grid – Auto | Manual | Permanent columns, answers on the right */\n.response-step-panel {\n  background: var(--bg-subtle);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 10px 12px;\n  margin-bottom: 16px;\n}\n\n.response-step-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: var(--text-secondary);\n  font-size: 0.86em;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.response-step-dots {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.response-step-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: var(--radius-full);\n  background: var(--border-strong);\n  flex: 0 0 10px;\n}\n\n.response-step-done {\n  background: var(--success);\n}\n\n.response-step-current {\n  background: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n\n.route-branch-preview {\n  min-height: 0;\n  margin-top: 14px;\n}\n\n.route-branch-preview:not(:empty) {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border: 1px solid var(--accent-border);\n  border-radius: var(--radius-sm);\n  background: var(--accent-soft);\n  padding: 10px 12px;\n}\n\n.route-branch-preview-copy {\n  color: var(--accent-text);\n  font-weight: 600;\n}\n\n.route-branch-preview-actions {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 8px;\n}\n\n.response-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.response-close-button {\n  width: 32px;\n  height: 32px;\n  font-size: 22px;\n  line-height: 1;\n}\n\n.response-question-row,\n.response-review-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n}\n\n.response-question-text {\n  min-width: 0;\n  color: var(--text-primary);\n  font-size: 1.1em;\n  font-weight: 600;\n}\n\n.response-ignore-action {\n  flex: 0 0 auto;\n  padding: 5px 9px;\n  border: 1px solid var(--border-strong);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--text-tertiary);\n  cursor: pointer;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.response-ignore-action:hover {\n  border-color: var(--danger);\n  color: var(--danger);\n}\n\n.answer-radio-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 100%;\n  min-width: 0;\n  max-width: 520px;\n}\n\n.answer-grid-header {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) repeat(2, minmax(0, 0.8fr));\n  gap: 12px 8px;\n  padding: 8px 0;\n  font-size: 0.82em;\n  font-weight: 600;\n  color: var(--text-tertiary);\n  border-bottom: 1px solid var(--border);\n}\n\n.answer-grid-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) repeat(2, minmax(0, 0.8fr));\n  gap: 12px 8px;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.answer-grid-row:last-child {\n  border-bottom: none;\n}\n\n.answer-grid-row .answer-grid-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 38px;\n  padding: 4px;\n  border: 1px solid var(--border);\n  border-radius: 9px;\n  background: var(--surface);\n  cursor: pointer;\n}\n\n.answer-grid-row .answer-grid-cell input[type=\"radio\"] {\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  cursor: pointer;\n}\n\n.answer-grid-row .answer-grid-label {\n  font-weight: 500;\n  color: var(--text-primary);\n  padding: 4px;\n}\n\n@media (max-width: 480px) {\n  .answer-grid-header,\n  .answer-grid-row {\n    grid-template-columns: minmax(0, 1.2fr) repeat(2, minmax(0, 0.8fr));\n    gap: 8px 5px;\n  }\n\n  .answer-grid-header {\n    font-size: 0.74em;\n  }\n\n  .answer-grid-header > span,\n  .answer-grid-row .answer-grid-cell,\n  .answer-grid-row .answer-grid-label {\n    min-width: 0;\n    box-sizing: border-box;\n    overflow-wrap: anywhere;\n  }\n}\n\n.btn-back-question {\n  flex-shrink: 0;\n  padding: 8px 12px;\n  font-size: 0.9em;\n  background: var(--bg-muted);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  color: var(--text-primary);\n}\n\n.btn-back-question:hover {\n  background: var(--border);\n  border-color: var(--text-muted);\n}\n\n/* Talk Creation */\n.talk-editor {\n  background: var(--surface);\n  border-radius: var(--radius-md);\n  padding: 20px;\n}\n\n.question-editor {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 15px;\n  margin-bottom: 15px;\n}\n\n.answer-editor {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.add-answer {\n  background: var(--bg-muted);\n  border: 2px dashed var(--border-strong);\n  border-radius: var(--radius-sm);\n  padding: 10px;\n  text-align: center;\n  cursor: pointer;\n  color: var(--text-tertiary);\n  transition: all 0.2s ease;\n}\n\n.add-answer:hover {\n  background: var(--accent-soft);\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* Survey Results */\n.survey-results {\n  background: var(--surface);\n  border-radius: var(--radius-md);\n  padding: 20px;\n}\n\n.stat-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--bg-muted);\n}\n\n.progress-bar {\n  background: var(--bg-muted);\n  border-radius: var(--radius-md);\n  height: 8px;\n  overflow: hidden;\n  margin-top: 5px;\n}\n\n.progress-fill {\n  background: var(--accent);\n  height: 100%;\n  transition: width 0.3s ease;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .app-container {\n    flex-direction: column;\n  }\n\n  .sidebar {\n    width: 100%;\n    height: 300px;\n    border-right: none;\n    border-bottom: 1px solid var(--border);\n  }\n\n  .message {\n    max-width: 85%;\n  }\n\n  .modal-content {\n    margin: 20px;\n    width: auto;\n  }\n\n  /* This rule intentionally follows the generic mobile modal rule above so the\n     Identity & devices takeover cannot regain margins or shrink below 100vw. */\n  .identity-devices-page.modal-fullscreen {\n    margin: 0;\n  }\n}\n\n/* Error States */\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  height: 100dvh;\n  text-align: center;\n  padding: 20px;\n}\n\n.error-container h1 {\n  color: var(--danger);\n  margin-bottom: 20px;\n}\n\n.error-container p {\n  color: var(--text-tertiary);\n  margin-bottom: 30px;\n  max-width: 400px;\n}\n\n/* Utility Classes */\n.hidden {\n  display: none;\n}\n.flex {\n  display: flex;\n}\n.flex-column {\n  flex-direction: column;\n}\n.flex-center {\n  align-items: center;\n  justify-content: center;\n}\n.text-center {\n  text-align: center;\n}\n.text-right {\n  text-align: right;\n}\n.mb-10 {\n  margin-bottom: 10px;\n}\n.mb-20 {\n  margin-bottom: 20px;\n}\n.p-10 {\n  padding: 10px;\n}\n.p-20 {\n  padding: 20px;\n}\n/* User List Styles */\n.user-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 15px;\n  border-bottom: 1px solid var(--bg-muted);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.user-item:hover {\n  background-color: var(--bg-subtle);\n}\n\n.user-details {\n  flex: 1;\n  margin-left: 10px;\n}\n\n.user-name {\n  font-weight: 500;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.user-status {\n  font-size: 0.85em;\n  color: var(--success);\n}\n\n.btn-send-talk {\n  background: var(--accent);\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: var(--radius-sm);\n  font-size: 0.9em;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn-send-talk:hover {\n  background: var(--accent-hover);\n}\n\n.empty-state {\n  padding: 40px 20px;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.empty-state p {\n  margin: 5px 0;\n}\n\n/* User Profile (Me View) */\n.user-profile {\n  padding: 20px;\n  background: var(--surface);\n}\n\n.profile-actions {\n  margin-top: 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.profile-btn {\n  width: 100%;\n  padding: 15px 20px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  font-size: 1em;\n  cursor: pointer;\n  text-align: left;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.profile-btn:hover {\n  background: var(--bg-muted);\n  border-color: var(--border-strong);\n}\n\n.profile-btn:active {\n  transform: scale(0.98);\n}\n\n/* Primary Button */\n.primary-btn {\n  background: var(--success);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: var(--radius-md);\n  font-size: 1em;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.primary-btn:hover {\n  background: var(--success-hover);\n}\n\n.primary-btn:active {\n  transform: scale(0.98);\n}\n\n/* Conversations View Styles */\n.conversations-list {\n  padding: 8px;\n}\n\n.conversation-list-item {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  margin-bottom: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid var(--border);\n}\n\n.conversation-list-item:hover {\n  background: var(--bg-muted);\n  transform: translateX(4px);\n}\n\n.conversation-list-item.unread {\n  background: var(--accent-soft);\n  border-color: var(--success);\n}\n\n.conversation-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--gradient-accent);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5em;\n  font-weight: bold;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.conversation-avatar-wrapper {\n  position: relative;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.conversation-avatar-wrapper .conversation-avatar {\n  margin-right: 0;\n}\n\n.conversation-online-indicator {\n  position: absolute;\n  right: -1px;\n  bottom: -1px;\n  width: 12px;\n  height: 12px;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  background: var(--success);\n}\n\n/* K1 item 3 (docs/TODO.md): TechSupport liveness, never headcount — inline dot next to the\n   built-in support row/roster name. Defaults to \"away\" until a real presence signal arrives. */\n.techsupport-presence-indicator {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-left: 8px;\n  vertical-align: middle;\n}\n\n.techsupport-presence-indicator.online {\n  background: var(--success);\n}\n\n.techsupport-presence-indicator.away {\n  background: var(--text-tertiary);\n}\n\n/* General presence dot — same online/away treatment as TechSupport's own indicator above,\n   shared by every ordinary contact row (contacts-view.ts) and chatroom member row\n   (chatrooms-view.ts) so both lists render presence identically. */\n.presence-indicator {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-left: 8px;\n  vertical-align: middle;\n}\n\n.presence-indicator.online {\n  background: var(--success);\n}\n\n.presence-indicator.away {\n  background: var(--text-tertiary);\n}\n\n/* K3 (docs/TODO.md): permanent app-bar badge whenever the current identity IS the TechSupport\n   root — an operator must always be able to tell they are signed in as TechSupport. */\n.techsupport-root-badge {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--accent-soft);\n  color: var(--accent-hover);\n  font-size: 0.72em;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.peer-compatibility {\n  margin-top: 9px;\n}\n\n.peer-compatibility-label {\n  display: flex;\n  justify-content: space-between;\n  color: var(--text-secondary);\n  font-size: 0.8em;\n}\n\n.peer-compatibility-track {\n  height: 7px;\n  overflow: hidden;\n  margin-top: 4px;\n  border-radius: var(--radius-sm);\n  background: var(--border);\n}\n\n.peer-compatibility-track span {\n  display: block;\n  height: 100%;\n  background: var(--success);\n}\n\n.peer-shared-tags {\n  display: grid;\n  gap: 3px;\n  margin-top: 8px;\n  color: var(--success-text);\n  font-size: 0.84em;\n}\n\n.peer-reputation-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 9px;\n  color: var(--text-secondary);\n  font-size: 0.82em;\n  font-weight: 700;\n}\n\n.stats-bar-list {\n  display: grid;\n  gap: 6px;\n  margin: 0 0 10px;\n}\n\n.stats-bar-row {\n  display: grid;\n  grid-template-columns: minmax(72px, 1fr) minmax(80px, 2fr) 28px;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-secondary);\n  font-size: 0.78em;\n}\n\n.stats-bar-row > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.stats-bar-row b {\n  color: var(--text-primary);\n  text-align: right;\n}\n\n.stats-bar-track {\n  height: 8px;\n  overflow: hidden;\n  border-radius: var(--radius-sm);\n  background: var(--border);\n}\n\n.stats-bar-track i {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--accent);\n}\n\n.stats-sparkline {\n  display: grid;\n  gap: 2px;\n  margin: 0 0 10px;\n}\n\n.stats-sparkline svg {\n  width: 100%;\n  height: 56px;\n  border-bottom: 1px solid var(--border-strong);\n  background: var(--bg-subtle);\n}\n\n.stats-sparkline span {\n  color: var(--text-tertiary);\n  font-size: 0.78em;\n}\n\n.survey-chart-title { margin-bottom: 8px; color: var(--text-primary); font-size: 0.9em; font-weight: 700; }\n.survey-completion-funnel { display: grid; gap: 6px; margin: 14px 0; padding: 12px; border: 1px solid var(--accent-soft); border-radius: var(--radius-md); background: var(--accent-soft); }\n.survey-funnel-step { display: grid; grid-template-columns: 28px 1fr 42px; align-items: center; gap: 8px; color: var(--text-secondary); font-size: 0.82em; }\n.survey-funnel-step i { display: block; height: 14px; overflow: hidden; border-radius: var(--radius-sm); background: var(--accent-soft); }\n.survey-funnel-step i::before { content: ''; display: block; width: 100%; height: 100%; background: var(--accent); }\n.survey-funnel-step i { clip-path: polygon(0 0, 100% 0, 88% 100%, 12% 100%); }\n.survey-funnel-step b { text-align: right; }\n.survey-answer-bar { display: grid; grid-template-columns: minmax(90px, 1fr) minmax(90px, 2fr) auto; align-items: center; gap: 10px; padding: 8px 10px; margin-top: 6px; border: 1px solid var(--border); border-radius: var(--radius-sm); background: var(--bg-subtle); }\n.survey-answer-bar > span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.survey-answer-bar i { height: 8px; overflow: hidden; border-radius: var(--radius-sm); background: var(--accent-soft); }\n.survey-answer-bar i b { display: block; height: 100%; background: var(--accent); }\n.survey-answer-bar strong { white-space: nowrap; }\n.survey-answer-bar em { color: var(--text-tertiary); font-style: normal; font-weight: 500; }\n\n.conversation-transport-chip {\n  margin-left: 7px;\n  border: 1px solid var(--accent-border);\n  border-radius: var(--radius-sm);\n  background: var(--accent-soft);\n  color: var(--accent-hover);\n  font-size: 0.72em;\n  font-weight: 700;\n  line-height: 1.35;\n  padding: 1px 5px;\n}\n\n.unread-count-badge {\n  display: inline-flex;\n  min-width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  margin-right: 7px;\n  border-radius: var(--radius-md);\n  background: var(--danger);\n  color: #fff;\n  font-size: 0.72em;\n  font-weight: 700;\n}\n\n.conversation-bot-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  font-size: 1em;\n  line-height: 1;\n  background: var(--bg-muted);\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);\n}\n\n/* Inline per-message counterpart to .conversation-bot-badge — TechSupport's own auto-answer\n   indicator (docs/TODO.md K5) inside a message bubble rather than floated over an avatar. */\n.message-bot-badge {\n  display: inline-block;\n  margin-right: 4px;\n}\n\n.conversation-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.conversation-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.conversation-name {\n  font-weight: 600;\n  font-size: 1em;\n  color: var(--text-primary);\n}\n\n.conversation-time {\n  font-size: 0.75em;\n  color: var(--text-muted);\n}\n\n.conversation-preview {\n  font-size: 0.9em;\n  color: var(--text-tertiary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.unread-badge {\n  width: 8px;\n  height: 8px;\n  background: var(--success);\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n/* Conversation Detail Overlay */\n.conversation-detail-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--surface);\n  /* Above the peer/User layout (1000): rule N2a stacks ⟨Conv⟩ on top of ⟨User⟩. */\n  z-index: 1001;\n  display: none; /* Hidden by default */\n  flex-direction: column;\n}\n\n/* Email-style thread list in the shared User layout (redesign §5) */\n.peer-thread-list {\n  padding: 4px 16px 8px;\n}\n\n.peer-thread-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 12px;\n  margin-bottom: 6px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n}\n\n.peer-thread-item:hover {\n  background: var(--bg-subtle);\n}\n\n.peer-thread-main {\n  min-width: 0;\n  flex: 1;\n}\n\n.peer-thread-title {\n  font-weight: 600;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.peer-thread-snippet {\n  font-size: 0.85em;\n  color: var(--text-tertiary);\n  margin-top: 2px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.peer-thread-side {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.peer-thread-time {\n  font-size: 0.75em;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.thread-unread-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: var(--radius-full);\n  background: var(--danger);\n  color: #fff;\n  font-size: 0.72em;\n  font-weight: 700;\n}\n\n.peer-thread-group-label {\n  font-size: 0.78em;\n  font-weight: 700;\n  color: var(--text-tertiary);\n  padding: 8px 2px 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.conversation-detail-overlay .conversation-detail-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* Conversation Detail View */\n.conversation-detail-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.conversation-detail-header {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  gap: 12px;\n}\n\n.conversation-detail-info {\n  flex: 1;\n}\n\n.conversation-detail-name {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 1.1em;\n  color: var(--text-primary);\n}\n\n.conversation-detail-status {\n  font-size: 0.85em;\n  color: var(--text-muted);\n}\n\n/* Diagnostic lines (transport mode / fallback reason / last-contact) — hidden unless\n   debug view is on (?debug=1 or localStorage iinpublic_debug=1). Text stays in the DOM. */\n.conversation-transport-status,\n.conversation-fallback-status,\n.conversation-health-status {\n  display: none;\n  font-size: 0.8em;\n  color: var(--text-muted);\n}\n\nbody.iinpublic-debug .conversation-transport-status,\nbody.iinpublic-debug .conversation-fallback-status,\nbody.iinpublic-debug .conversation-health-status {\n  display: block;\n}\n\n.conversation-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  background: var(--bg-muted);\n}\n\n.message {\n  margin-bottom: 12px;\n  display: flex;\n}\n\n.message-own {\n  justify-content: flex-end;\n}\n\n.message-other {\n  justify-content: flex-start;\n}\n\n.message-content {\n  max-width: 70%;\n  padding: 10px 14px;\n  border-radius: var(--radius-xl);\n  background: var(--surface);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.message-own .message-content {\n  background: var(--success);\n  color: white;\n  border-bottom-right-radius: 4px;\n}\n\n.message-other .message-content {\n  background: var(--surface);\n  color: var(--text-primary);\n  border-bottom-left-radius: 4px;\n}\n\n.message-text {\n  font-size: 0.95em;\n  line-height: 1.4;\n  word-wrap: break-word;\n}\n\n/* Matched-talk IPFS auto-share (L5): shared photo / file attachment card */\n.ipfs-attachment {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 160px;\n  max-width: 260px;\n}\n\n/* Inline chip: small preview thumbnail (image) or icon + name + Download link. */\n.ipfs-attachment-chip {\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  max-width: 300px;\n  padding: 8px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg-subtle);\n}\n\n.ipfs-attachment-thumb {\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n  border-radius: var(--radius-sm);\n  flex-shrink: 0;\n  background: var(--bg-muted);\n}\n\n.ipfs-attachment-chip .ipfs-attachment-icon {\n  flex-shrink: 0;\n  font-size: 1.4em;\n}\n\n.ipfs-attachment-meta {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n\n.ipfs-attachment-chip .ipfs-attachment-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n  font-size: 0.9em;\n}\n\n.ipfs-attachment-chip .ipfs-attachment-download {\n  align-self: flex-start;\n  margin-top: 2px;\n  font-size: 0.95em;\n  opacity: 0.55;\n  text-decoration: none;\n}\n\n.ipfs-attachment-chip .ipfs-attachment-download:hover {\n  opacity: 1;\n}\n\n/* In-app full-size photo viewer (lightbox) */\n.media-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  display: none;\n  align-items: center;\n  justify-content: center;\n}\n\n.media-lightbox-backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.9);\n}\n\n.media-lightbox-img {\n  position: relative;\n  max-width: 92vw;\n  max-height: 84vh;\n  object-fit: contain;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-lg);\n}\n\n.media-lightbox-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  color: white;\n  z-index: 1;\n}\n\n.media-lightbox-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.media-lightbox-action {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: var(--radius-full);\n  background: rgba(255, 255, 255, 0.15);\n  color: white;\n  font-size: 1.1em;\n  cursor: pointer;\n}\n\n.media-lightbox-action:hover {\n  background: rgba(255, 255, 255, 0.28);\n}\n\n.ipfs-attachment-head {\n  font-size: 0.9em;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ipfs-attachment-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ipfs-attachment-size {\n  font-weight: 400;\n  opacity: 0.7;\n  font-size: 0.85em;\n}\n\n.ipfs-attachment-img {\n  display: block;\n  width: 100%;\n  max-height: 240px;\n  object-fit: contain;\n  border-radius: var(--radius-md);\n  background: var(--bg-muted);\n}\n\n.ipfs-attachment-download {\n  font-size: 0.82em;\n  font-weight: 600;\n  color: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n  align-self: flex-start;\n}\n\n.ipfs-attachment-loading {\n  font-size: 0.78em;\n  opacity: 0.7;\n  font-style: italic;\n}\n\n/* Shared-media gallery */\n.conversation-media-btn {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 1.2em;\n  border-radius: var(--radius-full);\n}\n\n.conversation-media-btn:hover {\n  background: var(--bg-subtle);\n}\n\n.conversation-media-gallery {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface);\n}\n\n.conversation-media-gallery-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.conversation-media-title {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.conversation-media-tabs {\n  display: flex;\n  gap: 4px;\n  padding: 8px 12px 0;\n  flex-shrink: 0;\n}\n\n.conversation-media-tab {\n  flex: 1;\n  padding: 8px 4px;\n  border: none;\n  background: none;\n  border-bottom: 2px solid transparent;\n  color: var(--text-tertiary);\n  font-weight: 600;\n  font-size: 0.9em;\n  cursor: pointer;\n}\n\n.conversation-media-tab.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.conversation-media-grid {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 12px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));\n  gap: 10px;\n  align-content: start;\n}\n\n.conversation-media-grid.is-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.conversation-media-link {\n  display: block;\n  font-size: 0.85em;\n  color: var(--accent);\n  word-break: break-all;\n  padding: 8px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg-subtle);\n}\n\n.conversation-media-link:hover {\n  border-color: var(--accent);\n}\n\n.conversation-media-empty {\n  grid-column: 1 / -1;\n  text-align: center;\n  color: var(--text-muted);\n  padding: 40px 20px;\n}\n\n.conversation-media-tile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 6px;\n  background: var(--surface);\n  overflow: hidden;\n}\n\n.conversation-media-tile:hover {\n  border-color: var(--accent);\n}\n\n.media-tile-img {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  object-fit: cover;\n  border-radius: var(--radius-sm);\n}\n\n.media-tile-fileicon {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2em;\n  background: var(--bg-muted);\n  border-radius: var(--radius-sm);\n}\n\n.media-tile-name {\n  font-size: 0.72em;\n  color: var(--text-secondary);\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.media-tile-size {\n  font-size: 0.66em;\n  color: var(--text-muted);\n}\n\n.media-tile-download {\n  display: none;\n}\n\n.ipfs-attachment-link {\n  font-size: 0.72em;\n  opacity: 0.6;\n  word-break: break-all;\n  color: inherit;\n}\n\n.message-time {\n  font-size: 0.75em;\n  color: rgba(255, 255, 255, 0.7);\n  margin-top: 4px;\n  text-align: right;\n}\n\n.message-other .message-time {\n  color: var(--text-muted);\n}\n\n.conversation-input-container {\n  display: flex;\n  gap: 8px;\n  padding: 12px;\n  background: var(--surface);\n  border-top: 1px solid var(--border);\n  align-items: flex-end;\n}\n\n.conversation-attach-btn {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border: 1px solid var(--border-strong);\n  background: var(--surface);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  font-size: 1.2em;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.conversation-attach-btn:hover {\n  background: var(--bg-subtle);\n  border-color: var(--accent);\n}\n\n#conversation-message-input {\n  flex: 1;\n  padding: 10px 14px;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-xl);\n  resize: none;\n  font-family: inherit;\n  font-size: 0.95em;\n  outline: none;\n}\n\n#conversation-message-input:focus {\n  border-color: var(--success);\n}\n\n.send-btn {\n  background: var(--success);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: var(--radius-xl);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.send-btn:hover {\n  background: var(--success-hover);\n}\n\n.send-btn:active {\n  transform: scale(0.95);\n}\n\n/* Notification Badge on Tab Icon */\n.nav-icon {\n  position: relative;\n}\n\n.notification-badge {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background: var(--danger);\n  color: white;\n  font-size: 0.7em;\n  font-weight: bold;\n  padding: 2px 6px;\n  border-radius: var(--radius-md);\n  min-width: 18px;\n  text-align: center;\n  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.15);\n}\n\n/* ============================================================\n   Chatroom member arrow\n   ============================================================ */\n.chatroom-member-arrow {\n  color: var(--border-strong);\n  font-size: 1.2em;\n  margin-left: 4px;\n}\n\n.chatroom-member-item.member-stranger .chatroom-member-status {\n  color: var(--text-muted);\n}\n\n.chatroom-member-item.member-known .chatroom-member-status {\n  color: var(--accent);\n}\n\n/* ============================================================\n   Peer Detail Overlay\n   ============================================================ */\n.peer-detail-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--surface);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.peer-detail-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.peer-detail-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.peer-detail-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.peer-detail-name {\n  font-size: 1.1em;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.peer-detail-subtitle {\n  font-size: 0.85em;\n  color: var(--text-tertiary);\n  margin-top: 2px;\n}\n\n.peer-detail-body {\n  flex: 1;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.peer-stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  padding: 16px;\n}\n\n.peer-stat-card {\n  background: var(--bg-subtle);\n  border-radius: var(--radius-lg);\n  padding: 14px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  border: 1px solid var(--border);\n}\n\n.peer-stat-card.peer-stat-mutual {\n  grid-column: span 1;\n  background: var(--success-soft);\n  border-color: var(--success-border);\n}\n\n.peer-stat-icon {\n  font-size: 1.4em;\n  flex-shrink: 0;\n}\n\n.peer-stat-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.peer-stat-label {\n  font-size: 0.75em;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 2px;\n}\n\n.peer-stat-value {\n  font-size: 1.1em;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.peer-stat-sub {\n  font-size: 0.8em;\n  color: var(--text-tertiary);\n  margin-top: 2px;\n}\n\n.peer-section-header {\n  border-top: 1px solid var(--border);\n}\n\n.peer-section-title {\n  font-size: 0.95em;\n  font-weight: 700;\n  color: var(--text-secondary);\n}\n\n#peer-history-controls {\n  display: flex;\n}\n\n.peer-history-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--bg-muted);\n}\n\n.peer-outcome-match {\n  background: var(--success-soft);\n}\n\n.peer-outcome-mismatch {\n  background: var(--danger-soft);\n}\n\n.peer-outcome-pending {\n  background: var(--surface);\n}\n\n.peer-history-direction {\n  font-size: 1.2em;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.peer-history-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.peer-history-title {\n  font-size: 0.95em;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.peer-talk-type {\n  font-size: 0.75em;\n  background: var(--accent-soft);\n  color: var(--accent-text);\n  padding: 1px 6px;\n  border-radius: var(--radius-sm);\n  margin-left: 4px;\n  vertical-align: middle;\n}\n\n.peer-history-meta {\n  display: flex;\n  gap: 8px;\n  font-size: 0.8em;\n  color: var(--text-tertiary);\n  flex-wrap: wrap;\n}\n\n.peer-history-outcome {\n  font-weight: 600;\n}\n\n.peer-outcome-match .peer-history-outcome {\n  color: var(--success-hover);\n}\n\n.peer-outcome-mismatch .peer-history-outcome {\n  color: var(--danger-hover);\n}\n\n.peer-section-title {\n  font-size: 0.95em;\n  font-weight: 700;\n  color: var(--text-secondary);\n}\n\n.peer-conv-list {\n  padding: 0 16px 8px;\n}\n\n.peer-conv-item {\n  background: var(--bg-subtle);\n  border-radius: var(--radius-md);\n  padding: 12px;\n  margin-bottom: 8px;\n  border: 1px solid var(--border);\n}\n\n.peer-conv-talk-title {\n  font-weight: 600;\n  font-size: 0.9em;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.peer-conv-preview {\n  font-size: 0.85em;\n  color: var(--text-tertiary);\n  margin-bottom: 8px;\n}\n\n.peer-open-chat-btn {\n  font-size: 0.85em;\n  padding: 6px 14px;\n}\n\n.peer-send-section {\n  border-top: 1px solid var(--border);\n  padding-top: 4px;\n}\n\n.peer-auto-mode-label {\n  color: var(--text-secondary);\n}\n\n.peer-sort-btn.active,\n.peer-filter-tab.active {\n  background: var(--accent-hover);\n  color: white;\n}\n\n/* Talk editor — compact, scroll-safe composer.\n   The shell itself never scrolls: the form body does, while the header and submit bar remain\n   reachable. Optional delivery/media/preview controls use progressive disclosure so a simple\n   tag stays genuinely simple without removing any capability. */\n.talk-editor-shell {\n  display: flex;\n  flex-direction: column;\n  width: min(1000px, calc(100vw - 40px));\n  max-width: 1000px;\n  max-height: 90dvh;\n  padding: 0;\n  overflow: hidden;\n}\n\n.talk-editor-header {\n  flex: 0 0 auto;\n  align-items: center !important;\n  margin: 0;\n  padding: 18px 24px 14px;\n  border-bottom: 1px solid var(--border);\n  background: var(--surface);\n}\n\n.talk-editor-header .modal-title {\n  margin: 0;\n}\n\n.talk-editor-promise {\n  margin: 4px 0 0;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  font-weight: 650;\n}\n\n.talk-editor-close {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n}\n\n.talk-editor-close:hover {\n  background: var(--bg-subtle);\n}\n\n.talk-editor-form {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 18px 24px 20px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n}\n\n.talk-editor-description {\n  margin: 0 0 16px;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n#browse-talk-templates-btn {\n  justify-content: center;\n  width: 100%;\n}\n\n.talk-type-picker {\n  min-width: 0;\n  padding: 0;\n  border: 0;\n}\n\n.talk-type-picker .form-label {\n  padding: 0;\n}\n\n.talk-type-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.talk-type-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  min-height: 48px;\n  padding: 9px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--surface);\n  color: var(--text-secondary);\n  font-weight: 650;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;\n}\n\n.talk-type-option:hover {\n  border-color: var(--accent-border);\n  background: var(--accent-soft);\n}\n\n.talk-type-option:has(input:checked) {\n  border-color: var(--accent);\n  background: var(--accent-soft);\n  color: var(--accent-text);\n  box-shadow: inset 0 0 0 1px var(--accent);\n}\n\n.talk-type-option input {\n  flex: 0 0 auto;\n  width: 18px;\n  height: 18px;\n  min-height: 0;\n  margin: 0;\n}\n\n.talk-type-icon {\n  display: grid;\n  flex: 0 0 auto;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 7px;\n  background: var(--bg-muted);\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  font-weight: 800;\n}\n\n.talk-type-option:has(input:checked) .talk-type-icon {\n  background: var(--accent);\n  color: #fff;\n}\n\n#tag-like-group,\n#tag-pair-group {\n  margin-bottom: 10px;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg-subtle);\n}\n\n.talk-editor-more {\n  margin-top: 4px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--surface);\n}\n\n.talk-editor-more > summary {\n  min-height: 44px;\n  padding: 11px 14px;\n  color: var(--text-secondary);\n  font-weight: 700;\n  cursor: pointer;\n  user-select: none;\n}\n\n.talk-editor-more[open] > summary {\n  border-bottom: 1px solid var(--border);\n  color: var(--text-primary);\n}\n\n.talk-editor-more-body {\n  padding: 16px 16px 0;\n}\n\n.talk-editor-actions {\n  position: relative;\n  flex: 0 0 auto;\n  z-index: 4;\n  margin: 0;\n  padding: 12px 24px max(12px, env(safe-area-inset-bottom));\n  border-top: 1px solid var(--border);\n  background: color-mix(in srgb, var(--surface) 96%, transparent);\n  box-shadow: 0 -8px 18px rgb(15 23 42 / 8%);\n  backdrop-filter: blur(8px);\n}\n\n.talk-editor-actions #talk-submit-btn {\n  min-width: 140px;\n}\n\n@media (max-width: 600px) {\n  .talk-editor-shell.modal-fullscreen {\n    width: 100vw;\n    max-width: 100vw;\n    height: 100dvh;\n    max-height: 100dvh;\n    margin: 0;\n    border-radius: 0;\n  }\n\n  .talk-editor-header {\n    padding: 11px 14px 9px;\n  }\n\n  .talk-editor-header .modal-title {\n    font-size: 1.25rem;\n  }\n\n  .talk-editor-promise {\n    display: none;\n  }\n\n  .talk-editor-close {\n    width: 44px;\n    height: 44px;\n  }\n\n  .talk-editor-form {\n    padding: 12px 14px 16px;\n    scrollbar-gutter: auto;\n  }\n\n  .talk-editor-description {\n    margin-bottom: 12px;\n    font-size: 0.84rem;\n  }\n\n  .talk-editor-form .form-group {\n    margin-bottom: 14px;\n  }\n\n  .talk-type-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 7px;\n  }\n\n  .talk-type-option {\n    min-height: 46px;\n    padding: 8px;\n  }\n\n  .talk-editor-form input,\n  .talk-editor-form select,\n  .talk-editor-form textarea {\n    font-size: 16px;\n  }\n\n  .talk-type-option input,\n  .talk-send-chatroom-label input {\n    width: 20px;\n    height: 20px;\n    min-height: 0;\n  }\n\n  .talk-editor-more-body {\n    padding: 14px 12px 0;\n  }\n\n  .talk-editor-actions {\n    flex-direction: row;\n    align-items: stretch;\n    margin: 0;\n    padding: 10px 14px max(10px, env(safe-area-inset-bottom));\n  }\n\n  .talk-editor-actions > button,\n  .talk-editor-actions > .btn {\n    width: auto;\n    min-height: 48px;\n  }\n\n  .talk-editor-actions #cancel-talk-btn {\n    flex: 1 1 34%;\n  }\n\n  .talk-editor-actions #talk-submit-btn {\n    flex: 2 1 66%;\n    min-width: 0;\n  }\n}\n\n/* Answered automatically by the receiver's chatbot (🤖): one scheme-independent violet so the\n   record stands apart from every accent/talk-type color, in light and dark. */\n:root {\n  --chatbot-accent: #7c5cd6;\n  --chatbot-soft: #f1ecfb;\n}\n@media (prefers-color-scheme: dark) {\n  :root:not([data-theme=\"light\"]) {\n    --chatbot-accent: #a58cf0;\n    --chatbot-soft: #241d36;\n  }\n}\n:root[data-theme=\"dark\"] {\n  --chatbot-accent: #a58cf0;\n  --chatbot-soft: #241d36;\n}\n.talk-badge-chatbot,\n.answer-chatbot-mark {\n  color: var(--chatbot-accent);\n}\n\n/* Person↔tag graph (OPEN-87): tag chips on person and tag pages, the tag directory. */\n.tag-graph-body { padding: 12px 16px 16px; display: flex; flex-direction: column; gap: 10px; }\n.tag-graph-chips { display: flex; flex-wrap: wrap; gap: 6px; }\n.tag-graph-chip {\n  border: 1px solid var(--border-strong);\n  background: var(--surface);\n  color: var(--text-primary);\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 0.85em;\n  cursor: pointer;\n}\n.tag-graph-chip.is-shared { background: var(--accent-soft); border-color: var(--accent); font-weight: 600; }\n.tag-graph-count { color: var(--text-tertiary); font-weight: 400; margin-left: 2px; }\n.tag-graph-peer-tags { margin: 12px 16px 0; }\n.tag-graph-heading { font-size: 0.8em; color: var(--text-tertiary); margin-bottom: 6px; }\n.tag-graph-summary { margin: 0; color: var(--text-secondary); font-size: 0.9em; }\n.tag-graph-people { display: flex; flex-direction: column; gap: 6px; max-height: 50vh; overflow-y: auto; }\n.tag-graph-person {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 10px;\n  border-radius: 8px;\n  background: var(--bg-muted);\n  cursor: pointer;\n}\n.tag-graph-person-name { font-weight: 600; }\n.tag-graph-shared { font-size: 0.8em; color: var(--accent); }\n.tag-graph-empty { color: var(--text-tertiary); text-align: center; margin: 8px 0; }\n.contact-item-shared-tags { font-size: 0.8em; color: var(--accent); font-weight: 700; margin-top: 4px; }\n\n/* Talks rows without per-row buttons (owner design 2026-10-24). */\n.talk-tag-chip-flow { display: flex; flex-wrap: wrap; gap: 6px; margin: 4px 0 8px; }\n.talk-tag-chip-flow.is-grouped { padding-left: 18px; }\n.talk-tag-chip-flow > .talk-list-item.talk-tag-chip { margin: 0; cursor: pointer; }\n.talk-list-item.talk-tag-out.is-liked { background: var(--accent-soft); border-color: var(--accent); }\n.talk-tag-liked-mark { color: var(--accent); font-size: 0.9em; }\n.talk-list-item.is-selected { outline: 2px solid var(--accent); outline-offset: 2px; }\n.talk-pin-badge { font-size: 0.8em; line-height: 1; }\n/* Rows without buttons (list-row-selection.ts): a long-press selects, the AppBar acts. */\n.contact-item.is-selected,\n.answer-talk-item.is-selected { outline: 2px solid var(--accent); outline-offset: 2px; }\n.list-pin-badge { font-size: 0.8em; line-height: 1; flex-shrink: 0; }\n/* Me: a tag row's ♡ / ✕, and the people a row leads to (contacts-focus.ts). */\n.answer-tag-mark { color: var(--accent); font-weight: 700; width: 1.1em; text-align: center; }\n.focus-chip { display: inline-flex; align-items: center; gap: 4px; padding: 4px 6px 4px 10px; border-radius: 999px; background: var(--accent-soft); border: 1px solid var(--accent-border); font-size: 0.85em; font-weight: 600; }\n.focus-chip[hidden] { display: none; }\n.focus-chip-clear { background: none; border: none; font-size: 1em; cursor: pointer; color: var(--text-tertiary); }\n.graph-back-btn[hidden] { display: none; }\n.place-graph-links { display: flex; flex-wrap: wrap; gap: 4px 10px; margin: 0 0 8px; }\n.place-graph-links .graph-link { margin-left: 0; font-size: 0.85em; }\n.graph-link { font-size: 0.8em; color: var(--accent-text); margin-left: 6px; cursor: pointer; text-decoration: underline; text-underline-offset: 2px; white-space: nowrap; }\n.graph-link:focus-visible { outline: 2px solid var(--accent); outline-offset: 3px; border-radius: 3px; }\n.graph-place-link { display: inline-block; max-width: 100%; white-space: normal; overflow-wrap: anywhere; }\n.talk-graph-links { display: inline-flex; flex-wrap: wrap; gap: 4px; justify-content: flex-end; }\n.talk-graph-links .graph-link { white-space: normal; overflow-wrap: anywhere; }\n.tag-graph-heading .graph-link,\n.talk-graph-links .graph-link,\n.talk-tag-chip .graph-link { display: inline-flex; align-items: center; min-height: 32px; font-size: 0.875rem; }\n.talk-tag-chip:has(.graph-place-link) { flex-wrap: wrap; }\n.graph-place-focused > #chatroom-list-container,\n.graph-place-focused > #chatroom-detail-container { display: none !important; }\n#graph-place-panel { padding: 20px; overflow-y: auto; min-width: 0; }\n#graph-place-panel h2 { overflow-wrap: anywhere; }\n#graph-place-panel .place-graph-links { gap: 12px; margin: 18px 0; }\n#graph-place-panel .graph-link { display: inline-flex; align-items: center; min-height: 44px; font-size: 1em; white-space: normal; }\n#graph-place-panel button { min-height: 44px; padding: 8px 14px; }\n#place-detail-graph-links { padding: 0 16px; }\nbody[data-graph-place-active] [data-appbar-view=\"chatrooms\"],\nbody[data-graph-place-active] #back-to-chatrooms { display: none !important; }\n.contact-item,\n.answer-talk-item { -webkit-touch-callout: none; user-select: none; }\n.talks-tap-hint { font-size: 0.8em; color: var(--text-tertiary); margin: 2px 2px 8px; }\n.talks-direction-divider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 16px 0 10px;\n  color: var(--text-tertiary);\n  font-size: 0.8em;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.talks-direction-divider::before,\n.talks-direction-divider::after { content: ''; flex: 1; border-top: 1px solid var(--border-strong); }\n\n/* Map exchange history: neutral, selectable connections under people and broadcast effects. */\n.chatroom-map-connections, .chatroom-map-connection-lines {\n  position: absolute; inset: 0; width: 100%; height: 100%; pointer-events: none;\n}\n.chatroom-map-connection-line { stroke: #64748b; stroke-width: 1.5; opacity: .65; }\n.chatroom-map-connection-line.selected { stroke: #334155; stroke-width: 3; opacity: 1; }\n.chatroom-map-connection-line.dimmed, .chatroom-map-connection-label.dimmed { opacity: .25; }\n.chatroom-map-connection-hit { stroke: transparent; stroke-width: 24; pointer-events: stroke; cursor: pointer; }\n.chatroom-map-connection-hit:focus-visible { stroke: #64748b33; outline: none; }\n.chatroom-map-connection-label {\n  position: absolute; transform: translate(-50%, -50%); pointer-events: auto; cursor: pointer;\n  border: 1px solid #94a3b8; border-radius: 12px; padding: 3px 7px; min-height: 28px;\n  background: var(--surface, white); color: var(--text-primary, #334155); font-size: 11px; white-space: nowrap;\n}\n.chatroom-map-connection-label[hidden] { display: none; }\n.chatroom-map-connection-panel {\n  position: absolute; bottom: 36px; left: 50%; transform: translateX(-50%); max-width: calc(100% - 24px);\n  display: flex; align-items: center; gap: 10px; border-radius: 10px; padding: 8px 12px;\n  background: var(--surface, white); color: var(--text-primary, #334155); box-shadow: 0 2px 12px #0003;\n  pointer-events: auto; font-size: 13px;\n}\n.chatroom-map-connection-panel[hidden] { display: none; }\n.chatroom-map-connection-panel button { min-width: 80px; min-height: 44px; cursor: pointer; }\n.chatroom-map-connection-label:focus-visible, .chatroom-map-connection-panel button:focus-visible {\n  outline: 2px solid var(--accent, #2563eb); outline-offset: 2px;\n}\n.chatroom-map-member-actions { flex-wrap: wrap; }\n@media (pointer: coarse) {\n  .chatroom-map-connection-hit { stroke-width: 32; }\n  .chatroom-map-connection-label { min-height: 44px; min-width: 44px; }\n  .chatroom-map-member-profile { min-height: 44px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
